
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireaaf2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireaaf2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jDc6A", function(module, exports) {

exports = module.exports = (parcelRequire("dhZFU"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("gp40O"));

exports.Duplex = (parcelRequire("6vWFA"));

exports.Transform = (parcelRequire("HoDDH"));

exports.PassThrough = (parcelRequire("7TAGp"));

exports.finished = (parcelRequire("6lWQa"));

exports.pipeline = (parcelRequire("hVXSr"));

});
parcelRegister("dhZFU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $9accb442dc062ddb$var$Readable;
/*<replacement>*/ var $9accb442dc062ddb$var$Duplex;
/*</replacement>*/ $9accb442dc062ddb$var$Readable.ReadableState = $9accb442dc062ddb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9accb442dc062ddb$require$EE = $7etJZ.EventEmitter;
var $9accb442dc062ddb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $2TqX2 = parcelRequire("2TqX2");

var $6ZWSX = parcelRequire("6ZWSX");
var $9accb442dc062ddb$require$Buffer = $6ZWSX.Buffer;
var $9accb442dc062ddb$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $9accb442dc062ddb$var$_uint8ArrayToBuffer(chunk) {
    return $9accb442dc062ddb$require$Buffer.from(chunk);
}
function $9accb442dc062ddb$var$_isUint8Array(obj) {
    return $9accb442dc062ddb$require$Buffer.isBuffer(obj) || obj instanceof $9accb442dc062ddb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9accb442dc062ddb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9accb442dc062ddb$var$debug = $kjyEk.debuglog('stream');
else $9accb442dc062ddb$var$debug = function debug() {};

var $h7Z80 = parcelRequire("h7Z80");

var $K2gOp = parcelRequire("K2gOp");

var $alL6i = parcelRequire("alL6i");
var $9accb442dc062ddb$var$getHighWaterMark = $alL6i.getHighWaterMark;

var $kNdBK = parcelRequire("kNdBK");
var $9accb442dc062ddb$require$_require$codes = $kNdBK.codes;
var $9accb442dc062ddb$var$ERR_INVALID_ARG_TYPE = $9accb442dc062ddb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9accb442dc062ddb$var$ERR_STREAM_PUSH_AFTER_EOF = $9accb442dc062ddb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9accb442dc062ddb$var$ERR_METHOD_NOT_IMPLEMENTED = $9accb442dc062ddb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9accb442dc062ddb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9accb442dc062ddb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9accb442dc062ddb$var$StringDecoder;
var $9accb442dc062ddb$var$createReadableStreamAsyncIterator;
var $9accb442dc062ddb$var$from;

(parcelRequire("dlqwk"))($9accb442dc062ddb$var$Readable, $2TqX2);
var $9accb442dc062ddb$var$errorOrDestroy = $K2gOp.errorOrDestroy;
var $9accb442dc062ddb$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $9accb442dc062ddb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9accb442dc062ddb$var$ReadableState(options, stream, isDuplex) {
    $9accb442dc062ddb$var$Duplex = $9accb442dc062ddb$var$Duplex || (parcelRequire("6vWFA"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $9accb442dc062ddb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9accb442dc062ddb$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $h7Z80();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9accb442dc062ddb$var$StringDecoder) $9accb442dc062ddb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9accb442dc062ddb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9accb442dc062ddb$var$Readable(options) {
    $9accb442dc062ddb$var$Duplex = $9accb442dc062ddb$var$Duplex || (parcelRequire("6vWFA"));
    if (!(this instanceof $9accb442dc062ddb$var$Readable)) return new $9accb442dc062ddb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9accb442dc062ddb$var$Duplex;
    this._readableState = new $9accb442dc062ddb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $2TqX2.call(this);
}
Object.defineProperty($9accb442dc062ddb$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9accb442dc062ddb$var$Readable.prototype.destroy = $K2gOp.destroy;
$9accb442dc062ddb$var$Readable.prototype._undestroy = $K2gOp.undestroy;
$9accb442dc062ddb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9accb442dc062ddb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9accb442dc062ddb$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9accb442dc062ddb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9accb442dc062ddb$var$Readable.prototype.unshift = function(chunk) {
    return $9accb442dc062ddb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9accb442dc062ddb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9accb442dc062ddb$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9accb442dc062ddb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9accb442dc062ddb$var$chunkInvalid(state, chunk);
        if (er) $9accb442dc062ddb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $9accb442dc062ddb$require$Buffer.prototype) chunk = $9accb442dc062ddb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9accb442dc062ddb$var$errorOrDestroy(stream, new $9accb442dc062ddb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9accb442dc062ddb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9accb442dc062ddb$var$errorOrDestroy(stream, new $9accb442dc062ddb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9accb442dc062ddb$var$addChunk(stream, state, chunk, false);
                    else $9accb442dc062ddb$var$maybeReadMore(stream, state);
                } else $9accb442dc062ddb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9accb442dc062ddb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9accb442dc062ddb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9accb442dc062ddb$var$emitReadable(stream);
    }
    $9accb442dc062ddb$var$maybeReadMore(stream, state);
}
function $9accb442dc062ddb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9accb442dc062ddb$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $9accb442dc062ddb$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$9accb442dc062ddb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9accb442dc062ddb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9accb442dc062ddb$var$StringDecoder) $9accb442dc062ddb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9accb442dc062ddb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9accb442dc062ddb$var$MAX_HWM = 0x40000000;
function $9accb442dc062ddb$var$computeNewHighWaterMark(n) {
    if (n >= $9accb442dc062ddb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9accb442dc062ddb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9accb442dc062ddb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9accb442dc062ddb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9accb442dc062ddb$var$Readable.prototype.read = function(n) {
    $9accb442dc062ddb$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9accb442dc062ddb$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $9accb442dc062ddb$var$endReadable(this);
        else $9accb442dc062ddb$var$emitReadable(this);
        return null;
    }
    n = $9accb442dc062ddb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9accb442dc062ddb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9accb442dc062ddb$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9accb442dc062ddb$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9accb442dc062ddb$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $9accb442dc062ddb$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9accb442dc062ddb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9accb442dc062ddb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9accb442dc062ddb$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $9accb442dc062ddb$var$onEofChunk(stream, state) {
    $9accb442dc062ddb$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9accb442dc062ddb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9accb442dc062ddb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9accb442dc062ddb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9accb442dc062ddb$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9accb442dc062ddb$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9accb442dc062ddb$var$emitReadable_, stream);
    }
}
function $9accb442dc062ddb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9accb442dc062ddb$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9accb442dc062ddb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9accb442dc062ddb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9accb442dc062ddb$var$maybeReadMore_, stream, state);
    }
}
function $9accb442dc062ddb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9accb442dc062ddb$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9accb442dc062ddb$var$Readable.prototype._read = function(n) {
    $9accb442dc062ddb$var$errorOrDestroy(this, new $9accb442dc062ddb$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$9accb442dc062ddb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9accb442dc062ddb$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9accb442dc062ddb$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9accb442dc062ddb$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9accb442dc062ddb$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9accb442dc062ddb$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $9accb442dc062ddb$var$debug('ondata');
        var ret = dest.write(chunk);
        $9accb442dc062ddb$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9accb442dc062ddb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9accb442dc062ddb$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9accb442dc062ddb$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($9accb442dc062ddb$var$EElistenerCount(dest, 'error') === 0) $9accb442dc062ddb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9accb442dc062ddb$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $9accb442dc062ddb$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $9accb442dc062ddb$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9accb442dc062ddb$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $9accb442dc062ddb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9accb442dc062ddb$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9accb442dc062ddb$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $9accb442dc062ddb$var$flow(src);
        }
    };
}
$9accb442dc062ddb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9accb442dc062ddb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9accb442dc062ddb$var$Readable.prototype.on = function(ev, fn) {
    var res = $2TqX2.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9accb442dc062ddb$var$debug('on readable', state.length, state.reading);
            if (state.length) $9accb442dc062ddb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9accb442dc062ddb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9accb442dc062ddb$var$Readable.prototype.addListener = $9accb442dc062ddb$var$Readable.prototype.on;
$9accb442dc062ddb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $2TqX2.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9accb442dc062ddb$var$updateReadableListening, this);
    return res;
};
$9accb442dc062ddb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $2TqX2.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9accb442dc062ddb$var$updateReadableListening, this);
    return res;
};
function $9accb442dc062ddb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $9accb442dc062ddb$var$nReadingNextTick(self1) {
    $9accb442dc062ddb$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9accb442dc062ddb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9accb442dc062ddb$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9accb442dc062ddb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9accb442dc062ddb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9accb442dc062ddb$var$resume_, stream, state);
    }
}
function $9accb442dc062ddb$var$resume_(stream, state) {
    $9accb442dc062ddb$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $9accb442dc062ddb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9accb442dc062ddb$var$Readable.prototype.pause = function() {
    $9accb442dc062ddb$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9accb442dc062ddb$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $9accb442dc062ddb$var$flow(stream) {
    var state = stream._readableState;
    $9accb442dc062ddb$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9accb442dc062ddb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $9accb442dc062ddb$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $9accb442dc062ddb$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9accb442dc062ddb$var$kProxyEvents.length; n++)stream.on($9accb442dc062ddb$var$kProxyEvents[n], this.emit.bind(this, $9accb442dc062ddb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9accb442dc062ddb$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $9accb442dc062ddb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9accb442dc062ddb$var$createReadableStreamAsyncIterator === undefined) $9accb442dc062ddb$var$createReadableStreamAsyncIterator = (parcelRequire("5mvJP"));
    return $9accb442dc062ddb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9accb442dc062ddb$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9accb442dc062ddb$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9accb442dc062ddb$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9accb442dc062ddb$var$Readable._fromList = $9accb442dc062ddb$var$fromList;
Object.defineProperty($9accb442dc062ddb$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9accb442dc062ddb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9accb442dc062ddb$var$endReadable(stream) {
    var state = stream._readableState;
    $9accb442dc062ddb$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9accb442dc062ddb$var$endReadableNT, state, stream);
    }
}
function $9accb442dc062ddb$var$endReadableNT(state, stream) {
    $9accb442dc062ddb$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $9accb442dc062ddb$var$Readable.from = function(iterable, opts) {
    if ($9accb442dc062ddb$var$from === undefined) $9accb442dc062ddb$var$from = (parcelRequire("izXhK"));
    return $9accb442dc062ddb$var$from($9accb442dc062ddb$var$Readable, iterable, opts);
};
function $9accb442dc062ddb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("2TqX2", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("h7Z80", function(module, exports) {
'use strict';
function $c78281e018aec848$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c78281e018aec848$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c78281e018aec848$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c78281e018aec848$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c78281e018aec848$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c78281e018aec848$var$_defineProperty(obj, key, value) {
    key = $c78281e018aec848$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c78281e018aec848$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c78281e018aec848$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c78281e018aec848$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c78281e018aec848$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c78281e018aec848$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c78281e018aec848$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c78281e018aec848$var$_toPropertyKey(arg) {
    var key = $c78281e018aec848$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c78281e018aec848$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $c78281e018aec848$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $c78281e018aec848$var$inspect = $kjyEk.inspect;
var $c78281e018aec848$var$custom = $c78281e018aec848$var$inspect && $c78281e018aec848$var$inspect.custom || 'inspect';
function $c78281e018aec848$var$copyBuffer(src, target, offset) {
    $c78281e018aec848$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $c78281e018aec848$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $c78281e018aec848$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $c78281e018aec848$var$Buffer.alloc(0);
                var ret = $c78281e018aec848$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $c78281e018aec848$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $c78281e018aec848$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $c78281e018aec848$var$custom,
            value: function value(_, options) {
                return $c78281e018aec848$var$inspect(this, $c78281e018aec848$var$_objectSpread($c78281e018aec848$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("K2gOp", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $08a60ecc9e841cc2$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($08a60ecc9e841cc2$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($08a60ecc9e841cc2$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($08a60ecc9e841cc2$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($08a60ecc9e841cc2$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($08a60ecc9e841cc2$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($08a60ecc9e841cc2$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($08a60ecc9e841cc2$var$emitCloseNT, _this);
    });
    return this;
}
function $08a60ecc9e841cc2$var$emitErrorAndCloseNT(self, err) {
    $08a60ecc9e841cc2$var$emitErrorNT(self, err);
    $08a60ecc9e841cc2$var$emitCloseNT(self);
}
function $08a60ecc9e841cc2$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $08a60ecc9e841cc2$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $08a60ecc9e841cc2$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $08a60ecc9e841cc2$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $08a60ecc9e841cc2$var$destroy,
    undestroy: $08a60ecc9e841cc2$var$undestroy,
    errorOrDestroy: $08a60ecc9e841cc2$var$errorOrDestroy
};

});

parcelRegister("alL6i", function(module, exports) {
'use strict';

var $789066b7ba4f4ab2$var$ERR_INVALID_OPT_VALUE = (parcelRequire("kNdBK")).codes.ERR_INVALID_OPT_VALUE;
function $789066b7ba4f4ab2$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $789066b7ba4f4ab2$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $789066b7ba4f4ab2$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $789066b7ba4f4ab2$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $789066b7ba4f4ab2$var$getHighWaterMark
};

});
parcelRegister("kNdBK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $f232f07bebf82b05$export$e45cb6485273080e, (v) => $f232f07bebf82b05$export$e45cb6485273080e = v);
var $f232f07bebf82b05$export$e45cb6485273080e;
'use strict';
function $f232f07bebf82b05$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $f232f07bebf82b05$var$codes = {};
function $f232f07bebf82b05$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $f232f07bebf82b05$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $f232f07bebf82b05$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $f232f07bebf82b05$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $f232f07bebf82b05$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $f232f07bebf82b05$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $f232f07bebf82b05$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$f232f07bebf82b05$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$f232f07bebf82b05$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $f232f07bebf82b05$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($f232f07bebf82b05$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($f232f07bebf82b05$var$oneOf(expected, 'type'));
    else {
        var type = $f232f07bebf82b05$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($f232f07bebf82b05$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$f232f07bebf82b05$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$f232f07bebf82b05$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$f232f07bebf82b05$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$f232f07bebf82b05$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$f232f07bebf82b05$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$f232f07bebf82b05$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$f232f07bebf82b05$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$f232f07bebf82b05$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$f232f07bebf82b05$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$f232f07bebf82b05$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$f232f07bebf82b05$export$e45cb6485273080e = $f232f07bebf82b05$var$codes;

});


parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("6vWFA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
/*<replacement>*/ var $4be325f05acd0803$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $4be325f05acd0803$var$Duplex;

var $dhZFU = parcelRequire("dhZFU");

var $gp40O = parcelRequire("gp40O");

(parcelRequire("dlqwk"))($4be325f05acd0803$var$Duplex, $dhZFU);
// Allow the keys array to be GC'ed.
var $4be325f05acd0803$var$keys = $4be325f05acd0803$var$objectKeys($gp40O.prototype);
for(var $4be325f05acd0803$var$v = 0; $4be325f05acd0803$var$v < $4be325f05acd0803$var$keys.length; $4be325f05acd0803$var$v++){
    var $4be325f05acd0803$var$method = $4be325f05acd0803$var$keys[$4be325f05acd0803$var$v];
    if (!$4be325f05acd0803$var$Duplex.prototype[$4be325f05acd0803$var$method]) $4be325f05acd0803$var$Duplex.prototype[$4be325f05acd0803$var$method] = $gp40O.prototype[$4be325f05acd0803$var$method];
}
function $4be325f05acd0803$var$Duplex(options) {
    if (!(this instanceof $4be325f05acd0803$var$Duplex)) return new $4be325f05acd0803$var$Duplex(options);
    $dhZFU.call(this, options);
    $gp40O.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $4be325f05acd0803$var$onend);
        }
    }
}
Object.defineProperty($4be325f05acd0803$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($4be325f05acd0803$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($4be325f05acd0803$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $4be325f05acd0803$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($4be325f05acd0803$var$onEndNT, this);
}
function $4be325f05acd0803$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($4be325f05acd0803$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("gp40O", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
module.exports = $bf1217d5f1ff9463$var$Writable;
/* <replacement> */ function $bf1217d5f1ff9463$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $bf1217d5f1ff9463$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $bf1217d5f1ff9463$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $bf1217d5f1ff9463$var$Duplex;
/*</replacement>*/ $bf1217d5f1ff9463$var$Writable.WritableState = $bf1217d5f1ff9463$var$WritableState;

/*<replacement>*/ var $bf1217d5f1ff9463$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $2TqX2 = parcelRequire("2TqX2");

var $6ZWSX = parcelRequire("6ZWSX");
var $bf1217d5f1ff9463$require$Buffer = $6ZWSX.Buffer;
var $bf1217d5f1ff9463$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bf1217d5f1ff9463$var$_uint8ArrayToBuffer(chunk) {
    return $bf1217d5f1ff9463$require$Buffer.from(chunk);
}
function $bf1217d5f1ff9463$var$_isUint8Array(obj) {
    return $bf1217d5f1ff9463$require$Buffer.isBuffer(obj) || obj instanceof $bf1217d5f1ff9463$var$OurUint8Array;
}

var $K2gOp = parcelRequire("K2gOp");

var $alL6i = parcelRequire("alL6i");
var $bf1217d5f1ff9463$var$getHighWaterMark = $alL6i.getHighWaterMark;

var $kNdBK = parcelRequire("kNdBK");
var $bf1217d5f1ff9463$require$_require$codes = $kNdBK.codes;
var $bf1217d5f1ff9463$var$ERR_INVALID_ARG_TYPE = $bf1217d5f1ff9463$require$_require$codes.ERR_INVALID_ARG_TYPE, $bf1217d5f1ff9463$var$ERR_METHOD_NOT_IMPLEMENTED = $bf1217d5f1ff9463$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $bf1217d5f1ff9463$var$ERR_MULTIPLE_CALLBACK = $bf1217d5f1ff9463$require$_require$codes.ERR_MULTIPLE_CALLBACK, $bf1217d5f1ff9463$var$ERR_STREAM_CANNOT_PIPE = $bf1217d5f1ff9463$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $bf1217d5f1ff9463$var$ERR_STREAM_DESTROYED = $bf1217d5f1ff9463$require$_require$codes.ERR_STREAM_DESTROYED, $bf1217d5f1ff9463$var$ERR_STREAM_NULL_VALUES = $bf1217d5f1ff9463$require$_require$codes.ERR_STREAM_NULL_VALUES, $bf1217d5f1ff9463$var$ERR_STREAM_WRITE_AFTER_END = $bf1217d5f1ff9463$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $bf1217d5f1ff9463$var$ERR_UNKNOWN_ENCODING = $bf1217d5f1ff9463$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $bf1217d5f1ff9463$var$errorOrDestroy = $K2gOp.errorOrDestroy;

(parcelRequire("dlqwk"))($bf1217d5f1ff9463$var$Writable, $2TqX2);
function $bf1217d5f1ff9463$var$nop() {}

function $bf1217d5f1ff9463$var$WritableState(options, stream, isDuplex) {
    $bf1217d5f1ff9463$var$Duplex = $bf1217d5f1ff9463$var$Duplex || (parcelRequire("6vWFA"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $bf1217d5f1ff9463$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $bf1217d5f1ff9463$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $bf1217d5f1ff9463$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $bf1217d5f1ff9463$var$CorkedRequest(this);
}
$bf1217d5f1ff9463$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($bf1217d5f1ff9463$var$WritableState.prototype, 'buffer', {
            get: $bf1217d5f1ff9463$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $bf1217d5f1ff9463$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $bf1217d5f1ff9463$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($bf1217d5f1ff9463$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($bf1217d5f1ff9463$var$realHasInstance.call(this, object)) return true;
            if (this !== $bf1217d5f1ff9463$var$Writable) return false;
            return object && object._writableState instanceof $bf1217d5f1ff9463$var$WritableState;
        }
    });
} else $bf1217d5f1ff9463$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $bf1217d5f1ff9463$var$Writable(options) {
    $bf1217d5f1ff9463$var$Duplex = $bf1217d5f1ff9463$var$Duplex || (parcelRequire("6vWFA"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $bf1217d5f1ff9463$var$Duplex;
    if (!isDuplex && !$bf1217d5f1ff9463$var$realHasInstance.call($bf1217d5f1ff9463$var$Writable, this)) return new $bf1217d5f1ff9463$var$Writable(options);
    this._writableState = new $bf1217d5f1ff9463$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $2TqX2.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$bf1217d5f1ff9463$var$Writable.prototype.pipe = function() {
    $bf1217d5f1ff9463$var$errorOrDestroy(this, new $bf1217d5f1ff9463$var$ERR_STREAM_CANNOT_PIPE());
};
function $bf1217d5f1ff9463$var$writeAfterEnd(stream, cb) {
    var er = new $bf1217d5f1ff9463$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $bf1217d5f1ff9463$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $bf1217d5f1ff9463$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $bf1217d5f1ff9463$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $bf1217d5f1ff9463$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $bf1217d5f1ff9463$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$bf1217d5f1ff9463$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $bf1217d5f1ff9463$var$_isUint8Array(chunk);
    if (isBuf && !$bf1217d5f1ff9463$require$Buffer.isBuffer(chunk)) chunk = $bf1217d5f1ff9463$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $bf1217d5f1ff9463$var$nop;
    if (state.ending) $bf1217d5f1ff9463$var$writeAfterEnd(this, cb);
    else if (isBuf || $bf1217d5f1ff9463$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $bf1217d5f1ff9463$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$bf1217d5f1ff9463$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$bf1217d5f1ff9463$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bf1217d5f1ff9463$var$clearBuffer(this, state);
    }
};
$bf1217d5f1ff9463$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $bf1217d5f1ff9463$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($bf1217d5f1ff9463$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $bf1217d5f1ff9463$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $bf1217d5f1ff9463$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($bf1217d5f1ff9463$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $bf1217d5f1ff9463$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $bf1217d5f1ff9463$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $bf1217d5f1ff9463$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $bf1217d5f1ff9463$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $bf1217d5f1ff9463$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $bf1217d5f1ff9463$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($bf1217d5f1ff9463$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $bf1217d5f1ff9463$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $bf1217d5f1ff9463$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $bf1217d5f1ff9463$var$finishMaybe(stream, state);
    }
}
function $bf1217d5f1ff9463$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $bf1217d5f1ff9463$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $bf1217d5f1ff9463$var$ERR_MULTIPLE_CALLBACK();
    $bf1217d5f1ff9463$var$onwriteStateUpdate(state);
    if (er) $bf1217d5f1ff9463$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $bf1217d5f1ff9463$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bf1217d5f1ff9463$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($bf1217d5f1ff9463$var$afterWrite, stream, state, finished, cb);
        else $bf1217d5f1ff9463$var$afterWrite(stream, state, finished, cb);
    }
}
function $bf1217d5f1ff9463$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $bf1217d5f1ff9463$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $bf1217d5f1ff9463$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $bf1217d5f1ff9463$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $bf1217d5f1ff9463$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $bf1217d5f1ff9463$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $bf1217d5f1ff9463$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $bf1217d5f1ff9463$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$bf1217d5f1ff9463$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $bf1217d5f1ff9463$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$bf1217d5f1ff9463$var$Writable.prototype._writev = null;
$bf1217d5f1ff9463$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $bf1217d5f1ff9463$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($bf1217d5f1ff9463$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $bf1217d5f1ff9463$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $bf1217d5f1ff9463$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $bf1217d5f1ff9463$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $bf1217d5f1ff9463$var$finishMaybe(stream, state);
    });
}
function $bf1217d5f1ff9463$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($bf1217d5f1ff9463$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $bf1217d5f1ff9463$var$finishMaybe(stream, state) {
    var need = $bf1217d5f1ff9463$var$needFinish(state);
    if (need) {
        $bf1217d5f1ff9463$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $bf1217d5f1ff9463$var$endWritable(stream, state, cb) {
    state.ending = true;
    $bf1217d5f1ff9463$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $bf1217d5f1ff9463$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($bf1217d5f1ff9463$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$bf1217d5f1ff9463$var$Writable.prototype.destroy = $K2gOp.destroy;
$bf1217d5f1ff9463$var$Writable.prototype._undestroy = $K2gOp.undestroy;
$bf1217d5f1ff9463$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config('throwDeprecation')) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("1U9GM", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("5mvJP", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
'use strict';
var $3e77a060694be434$var$_Object$setPrototypeO;
function $3e77a060694be434$var$_defineProperty(obj, key, value) {
    key = $3e77a060694be434$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3e77a060694be434$var$_toPropertyKey(arg) {
    var key = $3e77a060694be434$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $3e77a060694be434$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6lWQa = parcelRequire("6lWQa");
var $3e77a060694be434$var$kLastResolve = Symbol('lastResolve');
var $3e77a060694be434$var$kLastReject = Symbol('lastReject');
var $3e77a060694be434$var$kError = Symbol('error');
var $3e77a060694be434$var$kEnded = Symbol('ended');
var $3e77a060694be434$var$kLastPromise = Symbol('lastPromise');
var $3e77a060694be434$var$kHandlePromise = Symbol('handlePromise');
var $3e77a060694be434$var$kStream = Symbol('stream');
function $3e77a060694be434$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $3e77a060694be434$var$readAndResolve(iter) {
    var resolve = iter[$3e77a060694be434$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$3e77a060694be434$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$3e77a060694be434$var$kLastPromise] = null;
            iter[$3e77a060694be434$var$kLastResolve] = null;
            iter[$3e77a060694be434$var$kLastReject] = null;
            resolve($3e77a060694be434$var$createIterResult(data, false));
        }
    }
}
function $3e77a060694be434$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($3e77a060694be434$var$readAndResolve, iter);
}
function $3e77a060694be434$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$3e77a060694be434$var$kEnded]) {
                resolve($3e77a060694be434$var$createIterResult(undefined, true));
                return;
            }
            iter[$3e77a060694be434$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $3e77a060694be434$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $3e77a060694be434$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($3e77a060694be434$var$_Object$setPrototypeO = {
    get stream () {
        return this[$3e77a060694be434$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$3e77a060694be434$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$3e77a060694be434$var$kEnded]) return Promise.resolve($3e77a060694be434$var$createIterResult(undefined, true));
        if (this[$3e77a060694be434$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$3e77a060694be434$var$kError]) reject(_this[$3e77a060694be434$var$kError]);
                else resolve($3e77a060694be434$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$3e77a060694be434$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($3e77a060694be434$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$3e77a060694be434$var$kStream].read();
            if (data !== null) return Promise.resolve($3e77a060694be434$var$createIterResult(data, false));
            promise = new Promise(this[$3e77a060694be434$var$kHandlePromise]);
        }
        this[$3e77a060694be434$var$kLastPromise] = promise;
        return promise;
    }
}, $3e77a060694be434$var$_defineProperty($3e77a060694be434$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $3e77a060694be434$var$_defineProperty($3e77a060694be434$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$3e77a060694be434$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($3e77a060694be434$var$createIterResult(undefined, true));
        });
    });
}), $3e77a060694be434$var$_Object$setPrototypeO), $3e77a060694be434$var$AsyncIteratorPrototype);
var $3e77a060694be434$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($3e77a060694be434$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $3e77a060694be434$var$_defineProperty(_Object$create, $3e77a060694be434$var$kStream, {
        value: stream,
        writable: true
    }), $3e77a060694be434$var$_defineProperty(_Object$create, $3e77a060694be434$var$kLastResolve, {
        value: null,
        writable: true
    }), $3e77a060694be434$var$_defineProperty(_Object$create, $3e77a060694be434$var$kLastReject, {
        value: null,
        writable: true
    }), $3e77a060694be434$var$_defineProperty(_Object$create, $3e77a060694be434$var$kError, {
        value: null,
        writable: true
    }), $3e77a060694be434$var$_defineProperty(_Object$create, $3e77a060694be434$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $3e77a060694be434$var$_defineProperty(_Object$create, $3e77a060694be434$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$3e77a060694be434$var$kStream].read();
            if (data) {
                iterator[$3e77a060694be434$var$kLastPromise] = null;
                iterator[$3e77a060694be434$var$kLastResolve] = null;
                iterator[$3e77a060694be434$var$kLastReject] = null;
                resolve($3e77a060694be434$var$createIterResult(data, false));
            } else {
                iterator[$3e77a060694be434$var$kLastResolve] = resolve;
                iterator[$3e77a060694be434$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$3e77a060694be434$var$kLastPromise] = null;
    $6lWQa(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$3e77a060694be434$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$3e77a060694be434$var$kLastPromise] = null;
                iterator[$3e77a060694be434$var$kLastResolve] = null;
                iterator[$3e77a060694be434$var$kLastReject] = null;
                reject(err);
            }
            iterator[$3e77a060694be434$var$kError] = err;
            return;
        }
        var resolve = iterator[$3e77a060694be434$var$kLastResolve];
        if (resolve !== null) {
            iterator[$3e77a060694be434$var$kLastPromise] = null;
            iterator[$3e77a060694be434$var$kLastResolve] = null;
            iterator[$3e77a060694be434$var$kLastReject] = null;
            resolve($3e77a060694be434$var$createIterResult(undefined, true));
        }
        iterator[$3e77a060694be434$var$kEnded] = true;
    });
    stream.on('readable', $3e77a060694be434$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $3e77a060694be434$var$createReadableStreamAsyncIterator;

});
parcelRegister("6lWQa", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $4a0258b4ff47a36e$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("kNdBK")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $4a0258b4ff47a36e$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $4a0258b4ff47a36e$var$noop() {}
function $4a0258b4ff47a36e$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $4a0258b4ff47a36e$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $4a0258b4ff47a36e$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $4a0258b4ff47a36e$var$once(callback || $4a0258b4ff47a36e$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $4a0258b4ff47a36e$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $4a0258b4ff47a36e$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($4a0258b4ff47a36e$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $4a0258b4ff47a36e$var$eos;

});


parcelRegister("izXhK", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("HoDDH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $082720edd81c8df0$var$Transform;

var $kNdBK = parcelRequire("kNdBK");
var $082720edd81c8df0$require$_require$codes = $kNdBK.codes;
var $082720edd81c8df0$var$ERR_METHOD_NOT_IMPLEMENTED = $082720edd81c8df0$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $082720edd81c8df0$var$ERR_MULTIPLE_CALLBACK = $082720edd81c8df0$require$_require$codes.ERR_MULTIPLE_CALLBACK, $082720edd81c8df0$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $082720edd81c8df0$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $082720edd81c8df0$var$ERR_TRANSFORM_WITH_LENGTH_0 = $082720edd81c8df0$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $6vWFA = parcelRequire("6vWFA");

(parcelRequire("dlqwk"))($082720edd81c8df0$var$Transform, $6vWFA);
function $082720edd81c8df0$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $082720edd81c8df0$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $082720edd81c8df0$var$Transform(options) {
    if (!(this instanceof $082720edd81c8df0$var$Transform)) return new $082720edd81c8df0$var$Transform(options);
    $6vWFA.call(this, options);
    this._transformState = {
        afterTransform: $082720edd81c8df0$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $082720edd81c8df0$var$prefinish);
}
function $082720edd81c8df0$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $082720edd81c8df0$var$done(_this, er, data);
    });
    else $082720edd81c8df0$var$done(this, null, null);
}
$082720edd81c8df0$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $6vWFA.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$082720edd81c8df0$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $082720edd81c8df0$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$082720edd81c8df0$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$082720edd81c8df0$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$082720edd81c8df0$var$Transform.prototype._destroy = function(err, cb) {
    $6vWFA.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $082720edd81c8df0$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $082720edd81c8df0$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $082720edd81c8df0$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("7TAGp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $5bfa1ff76e5b7fac$var$PassThrough;

var $HoDDH = parcelRequire("HoDDH");

(parcelRequire("dlqwk"))($5bfa1ff76e5b7fac$var$PassThrough, $HoDDH);
function $5bfa1ff76e5b7fac$var$PassThrough(options) {
    if (!(this instanceof $5bfa1ff76e5b7fac$var$PassThrough)) return new $5bfa1ff76e5b7fac$var$PassThrough(options);
    $HoDDH.call(this, options);
}
$5bfa1ff76e5b7fac$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("hVXSr", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $d0e634de459a4351$var$eos;
function $d0e634de459a4351$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $kNdBK = parcelRequire("kNdBK");
var $d0e634de459a4351$require$_require$codes = $kNdBK.codes;
var $d0e634de459a4351$var$ERR_MISSING_ARGS = $d0e634de459a4351$require$_require$codes.ERR_MISSING_ARGS, $d0e634de459a4351$var$ERR_STREAM_DESTROYED = $d0e634de459a4351$require$_require$codes.ERR_STREAM_DESTROYED;
function $d0e634de459a4351$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $d0e634de459a4351$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $d0e634de459a4351$var$destroyer(stream, reading, writing, callback) {
    callback = $d0e634de459a4351$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($d0e634de459a4351$var$eos === undefined) $d0e634de459a4351$var$eos = (parcelRequire("6lWQa"));
    $d0e634de459a4351$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($d0e634de459a4351$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $d0e634de459a4351$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $d0e634de459a4351$var$call(fn) {
    fn();
}
function $d0e634de459a4351$var$pipe(from, to) {
    return from.pipe(to);
}
function $d0e634de459a4351$var$popCallback(streams) {
    if (!streams.length) return $d0e634de459a4351$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $d0e634de459a4351$var$noop;
    return streams.pop();
}
function $d0e634de459a4351$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $d0e634de459a4351$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $d0e634de459a4351$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $d0e634de459a4351$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($d0e634de459a4351$var$call);
            if (reading) return;
            destroys.forEach($d0e634de459a4351$var$call);
            callback(error);
        });
    });
    return streams.reduce($d0e634de459a4351$var$pipe);
}
module.exports = $d0e634de459a4351$var$pipeline;

});


parcelRegister("kQFso", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $f2d8d27ce802ed82$require$Buffer = $6ZWSX.Buffer;
var $f2d8d27ce802ed82$var$toString = Object.prototype.toString;
var $f2d8d27ce802ed82$var$isModern = typeof $f2d8d27ce802ed82$require$Buffer !== 'undefined' && typeof $f2d8d27ce802ed82$require$Buffer.alloc === 'function' && typeof $f2d8d27ce802ed82$require$Buffer.allocUnsafe === 'function' && typeof $f2d8d27ce802ed82$require$Buffer.from === 'function';
function $f2d8d27ce802ed82$var$isArrayBuffer(input) {
    return $f2d8d27ce802ed82$var$toString.call(input).slice(8, -1) === 'ArrayBuffer';
}
function $f2d8d27ce802ed82$var$fromArrayBuffer(obj, byteOffset, length) {
    byteOffset >>>= 0;
    var maxLength = obj.byteLength - byteOffset;
    if (maxLength < 0) throw new RangeError("'offset' is out of bounds");
    if (length === undefined) length = maxLength;
    else {
        length >>>= 0;
        if (length > maxLength) throw new RangeError("'length' is out of bounds");
    }
    return $f2d8d27ce802ed82$var$isModern ? $f2d8d27ce802ed82$require$Buffer.from(obj.slice(byteOffset, byteOffset + length)) : new $f2d8d27ce802ed82$require$Buffer(new Uint8Array(obj.slice(byteOffset, byteOffset + length)));
}
function $f2d8d27ce802ed82$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f2d8d27ce802ed82$require$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    return $f2d8d27ce802ed82$var$isModern ? $f2d8d27ce802ed82$require$Buffer.from(string, encoding) : new $f2d8d27ce802ed82$require$Buffer(string, encoding);
}
function $f2d8d27ce802ed82$var$bufferFrom(value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('"value" argument must not be a number');
    if ($f2d8d27ce802ed82$var$isArrayBuffer(value)) return $f2d8d27ce802ed82$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'string') return $f2d8d27ce802ed82$var$fromString(value, encodingOrOffset);
    return $f2d8d27ce802ed82$var$isModern ? $f2d8d27ce802ed82$require$Buffer.from(value) : new $f2d8d27ce802ed82$require$Buffer(value);
}
module.exports = $f2d8d27ce802ed82$var$bufferFrom;

});

parcelRegister("jN9B6", function(module, exports) {

var $argvn = parcelRequire("argvn");

var $awrqI = parcelRequire("awrqI");

var $gehx0 = parcelRequire("gehx0");

var $eHpGI = parcelRequire("eHpGI");
var teoria;
// never thought I would write this, but: Legacy support
function intervalConstructor(from, to) {
    // Construct a Interval object from string representation
    if (typeof from === 'string') return $awrqI.toCoord(from);
    if (typeof to === 'string' && from instanceof $argvn) return $awrqI.from(from, $awrqI.toCoord(to));
    if (to instanceof $awrqI && from instanceof $argvn) return $awrqI.from(from, to);
    if (to instanceof $argvn && from instanceof $argvn) return $awrqI.between(from, to);
    throw new Error('Invalid parameters');
}
intervalConstructor.toCoord = $awrqI.toCoord;
intervalConstructor.from = $awrqI.from;
intervalConstructor.between = $awrqI.between;
intervalConstructor.invert = $awrqI.invert;
function noteConstructor(name, duration) {
    if (typeof name === 'string') return $argvn.fromString(name, duration);
    else return new $argvn(name, duration);
}
noteConstructor.fromString = $argvn.fromString;
noteConstructor.fromKey = $argvn.fromKey;
noteConstructor.fromFrequency = $argvn.fromFrequency;
noteConstructor.fromMIDI = $argvn.fromMIDI;
function chordConstructor(name, symbol) {
    if (typeof name === 'string') {
        var root, octave;
        root = name.match(/^([a-h])(x|#|bb|b?)/i);
        if (root && root[0]) {
            octave = typeof symbol === 'number' ? symbol.toString(10) : '4';
            return new $gehx0($argvn.fromString(root[0].toLowerCase() + octave), name.substr(root[0].length));
        }
    } else if (name instanceof $argvn) return new $gehx0(name, symbol);
    throw new Error('Invalid Chord. Couldn\'t find note name');
}
function scaleConstructor(tonic, scale) {
    tonic = tonic instanceof $argvn ? tonic : teoria.note(tonic);
    return new $eHpGI(tonic, scale);
}
teoria = {
    note: noteConstructor,
    chord: chordConstructor,
    interval: intervalConstructor,
    scale: scaleConstructor,
    Note: $argvn,
    Chord: $gehx0,
    Scale: $eHpGI,
    Interval: $awrqI
};

(parcelRequire("cV5PZ"))(teoria);
exports = module.exports = teoria;

});
parcelRegister("argvn", function(module, exports) {

var $5Er1Y = parcelRequire("5Er1Y");

var $dpkLU = parcelRequire("dpkLU");

var $2C9QC = parcelRequire("2C9QC");

var $h2em1 = parcelRequire("h2em1");

var $8GtdR = parcelRequire("8GtdR");

var $awrqI = parcelRequire("awrqI");
function $79993a8eceaf3bc8$var$pad(str, ch, len) {
    for(; len > 0; len--)str += ch;
    return str;
}
function $79993a8eceaf3bc8$var$Note(coord, duration) {
    if (!(this instanceof $79993a8eceaf3bc8$var$Note)) return new $79993a8eceaf3bc8$var$Note(coord, duration);
    duration = duration || {};
    this.duration = {
        value: duration.value || 4,
        dots: duration.dots || 0
    };
    this.coord = coord;
}
$79993a8eceaf3bc8$var$Note.prototype = {
    octave: function() {
        return this.coord[0] + $h2em1.A4[0] - $h2em1.notes[this.name()][0] + this.accidentalValue() * 4;
    },
    name: function() {
        var value = this.accidentalValue();
        var idx = this.coord[1] + $h2em1.A4[1] - value * 7 + 1;
        return $h2em1.fifths[idx];
    },
    accidentalValue: function() {
        return Math.round((this.coord[1] + $h2em1.A4[1] - 2) / 7);
    },
    accidental: function() {
        return $h2em1.accidentals[this.accidentalValue() + 2];
    },
    /**
   * Returns the key number of the note
   */ key: function(white) {
        if (white) return this.coord[0] * 7 + this.coord[1] * 4 + 29;
        else return this.coord[0] * 12 + this.coord[1] * 7 + 49;
    },
    /**
  * Returns a number ranging from 0-127 representing a MIDI note value
  */ midi: function() {
        return this.key() + 20;
    },
    /**
   * Calculates and returns the frequency of the note.
   * Optional concert pitch (def. 440)
   */ fq: function(concertPitch) {
        return $2C9QC(this.coord, concertPitch);
    },
    /**
   * Returns the pitch class index (chroma) of the note
   */ chroma: function() {
        var value = ($8GtdR.sum($8GtdR.mul(this.coord, [
            12,
            7
        ])) - 3) % 12;
        return value < 0 ? value + 12 : value;
    },
    interval: function(interval) {
        if (typeof interval === 'string') interval = $awrqI.toCoord(interval);
        if (interval instanceof $awrqI) return new $79993a8eceaf3bc8$var$Note($8GtdR.add(this.coord, interval.coord), this.duration);
        else if (interval instanceof $79993a8eceaf3bc8$var$Note) return new $awrqI($8GtdR.sub(interval.coord, this.coord));
    },
    transpose: function(interval) {
        this.coord = $8GtdR.add(this.coord, interval.coord);
        return this;
    },
    /**
   * Returns the Helmholtz notation form of the note (fx C,, d' F# g#'')
   */ helmholtz: function() {
        var octave = this.octave();
        var name = this.name();
        name = octave < 3 ? name.toUpperCase() : name.toLowerCase();
        var padchar = octave < 3 ? ',' : '\'';
        var padcount = octave < 2 ? 2 - octave : octave - 3;
        return $79993a8eceaf3bc8$var$pad(name + this.accidental(), padchar, padcount);
    },
    /**
   * Returns the scientific notation form of the note (fx E4, Bb3, C#7 etc.)
   */ scientific: function() {
        return this.name().toUpperCase() + this.accidental() + this.octave();
    },
    /**
   * Returns notes that are enharmonic with this note.
   */ enharmonics: function(oneaccidental) {
        var key = this.key(), limit = oneaccidental ? 2 : 3;
        return [
            'm3',
            'm2',
            'm-2',
            'm-3'
        ].map(this.interval.bind(this)).filter(function(note) {
            var acc = note.accidentalValue();
            var diff = key - (note.key() - acc);
            if (diff < limit && diff > -limit) {
                var product = $8GtdR.mul($h2em1.sharp, diff - acc);
                note.coord = $8GtdR.add(note.coord, product);
                return true;
            }
        });
    },
    solfege: function(scale, showOctaves) {
        var interval = scale.tonic.interval(this), solfege, stroke, count;
        if (interval.direction() === 'down') interval = interval.invert();
        if (showOctaves) {
            count = (this.key(true) - scale.tonic.key(true)) / 7;
            count = count >= 0 ? Math.floor(count) : -Math.ceil(-count);
            stroke = count >= 0 ? '\'' : ',';
        }
        solfege = $h2em1.intervalSolfege[interval.simple(true).toString()];
        return showOctaves ? $79993a8eceaf3bc8$var$pad(solfege, stroke, Math.abs(count)) : solfege;
    },
    scaleDegree: function(scale) {
        var inter = scale.tonic.interval(this);
        // If the direction is down, or we're dealing with an octave - invert it
        if (inter.direction() === 'down' || inter.coord[1] === 0 && inter.coord[0] !== 0) inter = inter.invert();
        inter = inter.simple(true).coord;
        return scale.scale.reduce(function(index, current, i) {
            var coord = $awrqI.toCoord(current).coord;
            return coord[0] === inter[0] && coord[1] === inter[1] ? i + 1 : index;
        }, 0);
    },
    /**
   * Returns the name of the duration value,
   * such as 'whole', 'quarter', 'sixteenth' etc.
   */ durationName: function() {
        return $h2em1.durations[this.duration.value];
    },
    /**
   * Returns the duration of the note (including dots)
   * in seconds. The first argument is the tempo in beats
   * per minute, the second is the beat unit (i.e. the
   * lower numeral in a time signature).
   */ durationInSeconds: function(bpm, beatUnit) {
        var secs = 60 / bpm / (this.duration.value / 4) / (beatUnit / 4);
        return secs * 2 - secs / Math.pow(2, this.duration.dots);
    },
    /**
   * Returns the name of the note, with an optional display of octave number
   */ toString: function(dont) {
        return this.name() + this.accidental() + (dont ? '' : this.octave());
    }
};
$79993a8eceaf3bc8$var$Note.fromString = function(name, dur) {
    var coord = $5Er1Y(name);
    if (!coord) coord = $dpkLU(name);
    return new $79993a8eceaf3bc8$var$Note(coord, dur);
};
$79993a8eceaf3bc8$var$Note.fromKey = function(key) {
    var octave = Math.floor((key - 4) / 12);
    var distance = key - octave * 12 - 4;
    var name = $h2em1.fifths[(2 * Math.round(distance / 2) + 1) % 7];
    var subDiff = $8GtdR.sub($h2em1.notes[name], $h2em1.A4);
    var note = $8GtdR.add(subDiff, [
        octave + 1,
        0
    ]);
    var diff = key - 49 - $8GtdR.sum($8GtdR.mul(note, [
        12,
        7
    ]));
    var arg = diff ? $8GtdR.add(note, $8GtdR.mul($h2em1.sharp, diff)) : note;
    return new $79993a8eceaf3bc8$var$Note(arg);
};
$79993a8eceaf3bc8$var$Note.fromFrequency = function(fq, concertPitch) {
    var key, cents, originalFq;
    concertPitch = concertPitch || 440;
    key = 49 + 12 * ((Math.log(fq) - Math.log(concertPitch)) / Math.log(2));
    key = Math.round(key);
    originalFq = concertPitch * Math.pow(2, (key - 49) / 12);
    cents = 1200 * (Math.log(fq / originalFq) / Math.log(2));
    return {
        note: $79993a8eceaf3bc8$var$Note.fromKey(key),
        cents: cents
    };
};
$79993a8eceaf3bc8$var$Note.fromMIDI = function(note) {
    return $79993a8eceaf3bc8$var$Note.fromKey(note - 20);
};
module.exports = $79993a8eceaf3bc8$var$Note;

});
parcelRegister("5Er1Y", function(module, exports) {

var $3x0b3 = parcelRequire("3x0b3");

var $dL4QZ = parcelRequire("dL4QZ");
module.exports = function scientific(name) {
    var format = /^([a-h])(x|#|bb|b?)(-?\d*)/i;
    var parser = name.match(format);
    if (!(parser && name === parser[0] && parser[3].length)) return;
    var noteName = parser[1];
    var octave = +parser[3];
    var accidental = parser[2].length ? parser[2].toLowerCase() : '';
    var accidentalValue = $dL4QZ.interval(accidental);
    var coord = $3x0b3(noteName.toLowerCase());
    coord[0] += octave;
    coord[0] += accidentalValue[0] - $3x0b3.A4[0];
    coord[1] += accidentalValue[1] - $3x0b3.A4[1];
    return coord;
};

});
parcelRegister("3x0b3", function(module, exports) {
// First coord is octaves, second is fifths. Distances are relative to c
var $2924976526a24900$var$notes = {
    c: [
        0,
        0
    ],
    d: [
        -1,
        2
    ],
    e: [
        -2,
        4
    ],
    f: [
        1,
        -1
    ],
    g: [
        0,
        1
    ],
    a: [
        -1,
        3
    ],
    b: [
        -2,
        5
    ],
    h: [
        -2,
        5
    ]
};
module.exports = function(name) {
    return name in $2924976526a24900$var$notes ? [
        $2924976526a24900$var$notes[name][0],
        $2924976526a24900$var$notes[name][1]
    ] : null;
};
module.exports.notes = $2924976526a24900$var$notes;
module.exports.A4 = [
    3,
    3
]; // Relative to C0 (scientic notation, ~16.35Hz)
module.exports.sharp = [
    -4,
    7
];

});

parcelRegister("dL4QZ", function(module, exports) {
var $a0436dfced01da09$var$accidentalValues = {
    'bb': -2,
    'b': -1,
    '': 0,
    '#': 1,
    'x': 2
};
module.exports = function accidentalNumber(acc) {
    return $a0436dfced01da09$var$accidentalValues[acc];
};
module.exports.interval = function accidentalInterval(acc) {
    var val = $a0436dfced01da09$var$accidentalValues[acc];
    return [
        -4 * val,
        7 * val
    ];
};

});


parcelRegister("dpkLU", function(module, exports) {

var $3x0b3 = parcelRequire("3x0b3");

var $dL4QZ = parcelRequire("dL4QZ");
module.exports = function helmholtz(name) {
    var name = name.replace(/\u2032/g, "'").replace(/\u0375/g, ',');
    var parts = name.match(/^(,*)([a-h])(x|#|bb|b?)([,\']*)$/i);
    if (!parts || name !== parts[0]) throw new Error('Invalid formatting');
    var note = parts[2];
    var octaveFirst = parts[1];
    var octaveLast = parts[4];
    var lower = note === note.toLowerCase();
    var octave;
    if (octaveFirst) {
        if (lower) throw new Error('Invalid formatting - found commas before lowercase note');
        octave = 2 - octaveFirst.length;
    } else if (octaveLast) {
        if (octaveLast.match(/^'+$/) && lower) octave = 3 + octaveLast.length;
        else if (octaveLast.match(/^,+$/) && !lower) octave = 2 - octaveLast.length;
        else throw new Error("Invalid formatting - mismatch between octave indicator and letter case");
    } else octave = lower ? 3 : 2;
    var accidentalValue = $dL4QZ.interval(parts[3].toLowerCase());
    var coord = $3x0b3(note.toLowerCase());
    coord[0] += octave;
    coord[0] += accidentalValue[0] - $3x0b3.A4[0];
    coord[1] += accidentalValue[1] - $3x0b3.A4[1];
    return coord;
};

});

parcelRegister("2C9QC", function(module, exports) {
module.exports = function(coord, stdPitch) {
    if (typeof coord === 'number') {
        stdPitch = coord;
        return function(coord) {
            return stdPitch * Math.pow(2, (coord[0] * 12 + coord[1] * 7) / 12);
        };
    }
    stdPitch = stdPitch || 440;
    return stdPitch * Math.pow(2, (coord[0] * 12 + coord[1] * 7) / 12);
};

});

parcelRegister("h2em1", function(module, exports) {
// Note coordinates [octave, fifth] relative to C
module.exports = {
    notes: {
        c: [
            0,
            0
        ],
        d: [
            -1,
            2
        ],
        e: [
            -2,
            4
        ],
        f: [
            1,
            -1
        ],
        g: [
            0,
            1
        ],
        a: [
            -1,
            3
        ],
        b: [
            -2,
            5
        ],
        h: [
            -2,
            5
        ]
    },
    intervals: {
        unison: [
            0,
            0
        ],
        second: [
            3,
            -5
        ],
        third: [
            2,
            -3
        ],
        fourth: [
            1,
            -1
        ],
        fifth: [
            0,
            1
        ],
        sixth: [
            3,
            -4
        ],
        seventh: [
            2,
            -2
        ],
        octave: [
            1,
            0
        ]
    },
    intervalFromFifth: [
        'second',
        'sixth',
        'third',
        'seventh',
        'fourth',
        'unison',
        'fifth'
    ],
    intervalsIndex: [
        'unison',
        'second',
        'third',
        'fourth',
        'fifth',
        'sixth',
        'seventh',
        'octave',
        'ninth',
        'tenth',
        'eleventh',
        'twelfth',
        'thirteenth',
        'fourteenth',
        'fifteenth'
    ],
    // linear index to fifth = (2 * index + 1) % 7
    fifths: [
        'f',
        'c',
        'g',
        'd',
        'a',
        'e',
        'b'
    ],
    accidentals: [
        'bb',
        'b',
        '',
        '#',
        'x'
    ],
    sharp: [
        -4,
        7
    ],
    A4: [
        3,
        3
    ],
    durations: {
        '0.25': 'longa',
        '0.5': 'breve',
        '1': 'whole',
        '2': 'half',
        '4': 'quarter',
        '8': 'eighth',
        '16': 'sixteenth',
        '32': 'thirty-second',
        '64': 'sixty-fourth',
        '128': 'hundred-twenty-eighth'
    },
    qualityLong: {
        P: 'perfect',
        M: 'major',
        m: 'minor',
        A: 'augmented',
        AA: 'doubly augmented',
        d: 'diminished',
        dd: 'doubly diminished'
    },
    alterations: {
        perfect: [
            'dd',
            'd',
            'P',
            'A',
            'AA'
        ],
        minor: [
            'dd',
            'd',
            'm',
            'M',
            'A',
            'AA'
        ]
    },
    symbols: {
        'min': [
            'm3',
            'P5'
        ],
        'm': [
            'm3',
            'P5'
        ],
        '-': [
            'm3',
            'P5'
        ],
        'M': [
            'M3',
            'P5'
        ],
        '': [
            'M3',
            'P5'
        ],
        '+': [
            'M3',
            'A5'
        ],
        'aug': [
            'M3',
            'A5'
        ],
        'dim': [
            'm3',
            'd5'
        ],
        'o': [
            'm3',
            'd5'
        ],
        'maj': [
            'M3',
            'P5',
            'M7'
        ],
        'dom': [
            'M3',
            'P5',
            'm7'
        ],
        "\xf8": [
            'm3',
            'd5',
            'm7'
        ],
        '5': [
            'P5'
        ]
    },
    chordShort: {
        'major': 'M',
        'minor': 'm',
        'augmented': 'aug',
        'diminished': 'dim',
        'half-diminished': '7b5',
        'power': '5',
        'dominant': '7'
    },
    stepNumber: {
        'unison': 1,
        'first': 1,
        'second': 2,
        'third': 3,
        'fourth': 4,
        'fifth': 5,
        'sixth': 6,
        'seventh': 7,
        'octave': 8,
        'ninth': 9,
        'eleventh': 11,
        'thirteenth': 13
    },
    // Adjusted Shearer syllables - Chromatic solfege system
    // Some intervals are not provided for. These include:
    // dd2 - Doubly diminished second
    // dd3 - Doubly diminished third
    // AA3 - Doubly augmented third
    // dd6 - Doubly diminished sixth
    // dd7 - Doubly diminished seventh
    // AA7 - Doubly augmented seventh
    intervalSolfege: {
        'dd1': 'daw',
        'd1': 'de',
        'P1': 'do',
        'A1': 'di',
        'AA1': 'dai',
        'd2': 'raw',
        'm2': 'ra',
        'M2': 're',
        'A2': 'ri',
        'AA2': 'rai',
        'd3': 'maw',
        'm3': 'me',
        'M3': 'mi',
        'A3': 'mai',
        'dd4': 'faw',
        'd4': 'fe',
        'P4': 'fa',
        'A4': 'fi',
        'AA4': 'fai',
        'dd5': 'saw',
        'd5': 'se',
        'P5': 'so',
        'A5': 'si',
        'AA5': 'sai',
        'd6': 'law',
        'm6': 'le',
        'M6': 'la',
        'A6': 'li',
        'AA6': 'lai',
        'd7': 'taw',
        'm7': 'te',
        'M7': 'ti',
        'A7': 'tai',
        'dd8': 'daw',
        'd8': 'de',
        'P8': 'do',
        'A8': 'di',
        'AA8': 'dai'
    }
};

});

parcelRegister("8GtdR", function(module, exports) {
module.exports = {
    add: function(note, interval) {
        return [
            note[0] + interval[0],
            note[1] + interval[1]
        ];
    },
    sub: function(note, interval) {
        return [
            note[0] - interval[0],
            note[1] - interval[1]
        ];
    },
    mul: function(note, interval) {
        if (typeof interval === 'number') return [
            note[0] * interval,
            note[1] * interval
        ];
        else return [
            note[0] * interval[0],
            note[1] * interval[1]
        ];
    },
    sum: function(coord) {
        return coord[0] + coord[1];
    }
};

});

parcelRegister("awrqI", function(module, exports) {

var $h2em1 = parcelRequire("h2em1");

var $8GtdR = parcelRequire("8GtdR");

var $4mYh1 = parcelRequire("4mYh1");
function $7a922b8de6cc3b25$var$Interval(coord) {
    if (!(this instanceof $7a922b8de6cc3b25$var$Interval)) return new $7a922b8de6cc3b25$var$Interval(coord);
    this.coord = coord;
}
$7a922b8de6cc3b25$var$Interval.prototype = {
    name: function() {
        return $h2em1.intervalsIndex[this.number() - 1];
    },
    semitones: function() {
        return $8GtdR.sum($8GtdR.mul(this.coord, [
            12,
            7
        ]));
    },
    number: function() {
        return Math.abs(this.value());
    },
    value: function() {
        var toMultiply = Math.floor((this.coord[1] - 2) / 7) + 1;
        var product = $8GtdR.mul($h2em1.sharp, toMultiply);
        var without = $8GtdR.sub(this.coord, product);
        var i = $h2em1.intervalFromFifth[without[1] + 5];
        var diff = without[0] - $h2em1.intervals[i][0];
        var val = $h2em1.stepNumber[i] + diff * 7;
        return val > 0 ? val : val - 2;
    },
    type: function() {
        return $h2em1.intervals[this.base()][0] <= 1 ? 'perfect' : 'minor';
    },
    base: function() {
        var product = $8GtdR.mul($h2em1.sharp, this.qualityValue());
        var fifth = $8GtdR.sub(this.coord, product)[1];
        fifth = this.value() > 0 ? fifth + 5 : -(fifth - 5) % 7;
        fifth = fifth < 0 ? $h2em1.intervalFromFifth.length + fifth : fifth;
        var name = $h2em1.intervalFromFifth[fifth];
        if (name === 'unison' && this.number() >= 8) name = 'octave';
        return name;
    },
    direction: function(dir) {
        if (dir) {
            var is = this.value() >= 1 ? 'up' : 'down';
            if (is !== dir) this.coord = $8GtdR.mul(this.coord, -1);
            return this;
        } else return this.value() >= 1 ? 'up' : 'down';
    },
    simple: function(ignore) {
        // Get the (upwards) base interval (with quality)
        var simple = $h2em1.intervals[this.base()];
        var toAdd = $8GtdR.mul($h2em1.sharp, this.qualityValue());
        simple = $8GtdR.add(simple, toAdd);
        // Turn it around if necessary
        if (!ignore) simple = this.direction() === 'down' ? $8GtdR.mul(simple, -1) : simple;
        return new $7a922b8de6cc3b25$var$Interval(simple);
    },
    isCompound: function() {
        return this.number() > 8;
    },
    octaves: function() {
        var toSubtract, without, octaves;
        if (this.direction() === 'up') {
            toSubtract = $8GtdR.mul($h2em1.sharp, this.qualityValue());
            without = $8GtdR.sub(this.coord, toSubtract);
            octaves = without[0] - $h2em1.intervals[this.base()][0];
        } else {
            toSubtract = $8GtdR.mul($h2em1.sharp, -this.qualityValue());
            without = $8GtdR.sub(this.coord, toSubtract);
            octaves = -(without[0] + $h2em1.intervals[this.base()][0]);
        }
        return octaves;
    },
    invert: function() {
        var i = this.base();
        var qual = this.qualityValue();
        var acc = this.type() === 'minor' ? -(qual - 1) : -qual;
        var idx = 9 - $h2em1.stepNumber[i] - 1;
        var coord = $h2em1.intervals[$h2em1.intervalsIndex[idx]];
        coord = $8GtdR.add(coord, $8GtdR.mul($h2em1.sharp, acc));
        return new $7a922b8de6cc3b25$var$Interval(coord);
    },
    quality: function(lng) {
        var quality = $h2em1.alterations[this.type()][this.qualityValue() + 2];
        return lng ? $h2em1.qualityLong[quality] : quality;
    },
    qualityValue: function() {
        if (this.direction() === 'down') return Math.floor((-this.coord[1] - 2) / 7) + 1;
        else return Math.floor((this.coord[1] - 2) / 7) + 1;
    },
    equal: function(interval) {
        return this.coord[0] === interval.coord[0] && this.coord[1] === interval.coord[1];
    },
    greater: function(interval) {
        var semi = this.semitones();
        var isemi = interval.semitones();
        // If equal in absolute size, measure which interval is bigger
        // For example P4 is bigger than A3
        return semi === isemi ? this.number() > interval.number() : semi > isemi;
    },
    smaller: function(interval) {
        return !this.equal(interval) && !this.greater(interval);
    },
    add: function(interval) {
        return new $7a922b8de6cc3b25$var$Interval($8GtdR.add(this.coord, interval.coord));
    },
    toString: function(ignore) {
        // If given true, return the positive value
        var number = ignore ? this.number() : this.value();
        return this.quality() + number;
    }
};
$7a922b8de6cc3b25$var$Interval.toCoord = function(simple) {
    var coord = $4mYh1(simple);
    if (!coord) throw new Error('Invalid simple format interval');
    return new $7a922b8de6cc3b25$var$Interval(coord);
};
$7a922b8de6cc3b25$var$Interval.from = function(from, to) {
    return from.interval(to);
};
$7a922b8de6cc3b25$var$Interval.between = function(from, to) {
    return new $7a922b8de6cc3b25$var$Interval($8GtdR.sub(to.coord, from.coord));
};
$7a922b8de6cc3b25$var$Interval.invert = function(sInterval) {
    return $7a922b8de6cc3b25$var$Interval.toCoord(sInterval).invert().toString();
};
module.exports = $7a922b8de6cc3b25$var$Interval;

});
parcelRegister("4mYh1", function(module, exports) {
var $32e7f88fafa2304c$var$pattern = /^(AA|A|P|M|m|d|dd)(-?\d+)$/;
// The interval it takes to raise a note a semitone
var $32e7f88fafa2304c$var$sharp = [
    -4,
    7
];
var $32e7f88fafa2304c$var$pAlts = [
    'dd',
    'd',
    'P',
    'A',
    'AA'
];
var $32e7f88fafa2304c$var$mAlts = [
    'dd',
    'd',
    'm',
    'M',
    'A',
    'AA'
];
var $32e7f88fafa2304c$var$baseIntervals = [
    [
        0,
        0
    ],
    [
        3,
        -5
    ],
    [
        2,
        -3
    ],
    [
        1,
        -1
    ],
    [
        0,
        1
    ],
    [
        3,
        -4
    ],
    [
        2,
        -2
    ],
    [
        1,
        0
    ]
];
module.exports = function(simple) {
    var parser = simple.match($32e7f88fafa2304c$var$pattern);
    if (!parser) return null;
    var quality = parser[1];
    var number = +parser[2];
    var sign = number < 0 ? -1 : 1;
    number = sign < 0 ? -number : number;
    var lower = number > 8 ? number % 7 || 7 : number;
    var octaves = (number - lower) / 7;
    var base = $32e7f88fafa2304c$var$baseIntervals[lower - 1];
    var alts = base[0] <= 1 ? $32e7f88fafa2304c$var$pAlts : $32e7f88fafa2304c$var$mAlts;
    var alt = alts.indexOf(quality) - 2;
    // this happens, if the alteration wasn't suitable for this type
    // of interval, such as P2 or M5 (no "perfect second" or "major fifth")
    if (alt === -3) return null;
    return [
        sign * (base[0] + octaves + $32e7f88fafa2304c$var$sharp[0] * alt),
        sign * (base[1] + $32e7f88fafa2304c$var$sharp[1] * alt)
    ];
};
// Copy to avoid overwriting internal base intervals
module.exports.coords = $32e7f88fafa2304c$var$baseIntervals.slice(0);

});



parcelRegister("gehx0", function(module, exports) {

var $5Q8h2 = parcelRequire("5Q8h2");

var $h2em1 = parcelRequire("h2em1");

var $argvn = parcelRequire("argvn");

var $awrqI = parcelRequire("awrqI");
function $bd0b8d7c391eddc4$var$Chord(root, name) {
    if (!(this instanceof $bd0b8d7c391eddc4$var$Chord)) return new $bd0b8d7c391eddc4$var$Chord(root, name);
    name = name || '';
    this.name = root.name().toUpperCase() + root.accidental() + name;
    this.symbol = name;
    this.root = root;
    this.intervals = [];
    this._voicing = [];
    var bass = name.split('/');
    if (bass.length === 2 && bass[1].trim() !== '9') {
        name = bass[0];
        bass = bass[1].trim();
    } else bass = null;
    this.intervals = $5Q8h2(name).map($awrqI.toCoord);
    this._voicing = this.intervals.slice();
    if (bass) {
        var intervals = this.intervals, bassInterval, note;
        // Make sure the bass is atop of the root note
        note = $argvn.fromString(bass + (root.octave() + 1)); // crude
        bassInterval = $awrqI.between(root, note);
        bass = bassInterval.simple();
        bassInterval = bassInterval.invert().direction('down');
        this._voicing = [
            bassInterval
        ];
        for(var i = 0, length = intervals.length; i < length; i++)if (!intervals[i].simple().equal(bass)) this._voicing.push(intervals[i]);
    }
}
$bd0b8d7c391eddc4$var$Chord.prototype = {
    notes: function() {
        var root = this.root;
        return this.voicing().map(function(interval) {
            return root.interval(interval);
        });
    },
    simple: function() {
        return this.notes().map(function(n) {
            return n.toString(true);
        });
    },
    bass: function() {
        return this.root.interval(this._voicing[0]);
    },
    voicing: function(voicing) {
        // Get the voicing
        if (!voicing) return this._voicing;
        // Set the voicing
        this._voicing = [];
        for(var i = 0, length = voicing.length; i < length; i++)this._voicing[i] = $awrqI.toCoord(voicing[i]);
        return this;
    },
    resetVoicing: function() {
        this._voicing = this.intervals;
    },
    dominant: function(additional) {
        additional = additional || '';
        return new $bd0b8d7c391eddc4$var$Chord(this.root.interval('P5'), additional);
    },
    subdominant: function(additional) {
        additional = additional || '';
        return new $bd0b8d7c391eddc4$var$Chord(this.root.interval('P4'), additional);
    },
    parallel: function(additional) {
        additional = additional || '';
        var quality = this.quality();
        if (this.chordType() !== 'triad' || quality === 'diminished' || quality === 'augmented') throw new Error('Only major/minor triads have parallel chords');
        if (quality === 'major') return new $bd0b8d7c391eddc4$var$Chord(this.root.interval('m3', 'down'), 'm');
        else return new $bd0b8d7c391eddc4$var$Chord(this.root.interval('m3', 'up'));
    },
    quality: function() {
        var third, fifth, seventh, intervals = this.intervals;
        for(var i = 0, length = intervals.length; i < length; i++){
            if (intervals[i].number() === 3) third = intervals[i];
            else if (intervals[i].number() === 5) fifth = intervals[i];
            else if (intervals[i].number() === 7) seventh = intervals[i];
        }
        if (!third) return;
        third = third.direction() === 'down' ? third.invert() : third;
        third = third.simple().toString();
        if (fifth) {
            fifth = fifth.direction === 'down' ? fifth.invert() : fifth;
            fifth = fifth.simple().toString();
        }
        if (seventh) {
            seventh = seventh.direction === 'down' ? seventh.invert() : seventh;
            seventh = seventh.simple().toString();
        }
        if (third === 'M3') {
            if (fifth === 'A5') return 'augmented';
            else if (fifth === 'P5') return seventh === 'm7' ? 'dominant' : 'major';
            return 'major';
        } else if (third === 'm3') {
            if (fifth === 'P5') return 'minor';
            else if (fifth === 'd5') return seventh === 'm7' ? 'half-diminished' : 'diminished';
            return 'minor';
        }
    },
    chordType: function() {
        var length = this.intervals.length, interval, has, invert, i, name;
        if (length === 2) return 'dyad';
        else if (length === 3) {
            has = {
                unison: false,
                third: false,
                fifth: false
            };
            for(i = 0; i < length; i++){
                interval = this.intervals[i];
                invert = interval.invert();
                if (interval.base() in has) has[interval.base()] = true;
                else if (invert.base() in has) has[invert.base()] = true;
            }
            name = has.unison && has.third && has.fifth ? 'triad' : 'trichord';
        } else if (length === 4) {
            has = {
                unison: false,
                third: false,
                fifth: false,
                seventh: false
            };
            for(i = 0; i < length; i++){
                interval = this.intervals[i];
                invert = interval.invert();
                if (interval.base() in has) has[interval.base()] = true;
                else if (invert.base() in has) has[invert.base()] = true;
            }
            if (has.unison && has.third && has.fifth && has.seventh) name = 'tetrad';
        }
        return name || 'unknown';
    },
    get: function(interval) {
        if (typeof interval === 'string' && interval in $h2em1.stepNumber) {
            var intervals = this.intervals, i, length;
            interval = $h2em1.stepNumber[interval];
            for(i = 0, length = intervals.length; i < length; i++){
                if (intervals[i].number() === interval) return this.root.interval(intervals[i]);
            }
            return null;
        } else throw new Error('Invalid interval name');
    },
    interval: function(interval) {
        return new $bd0b8d7c391eddc4$var$Chord(this.root.interval(interval), this.symbol);
    },
    transpose: function(interval) {
        this.root.transpose(interval);
        this.name = this.root.name().toUpperCase() + this.root.accidental() + this.symbol;
        return this;
    },
    toString: function() {
        return this.name;
    }
};
module.exports = $bd0b8d7c391eddc4$var$Chord;

});
parcelRegister("5Q8h2", function(module, exports) {
var $44083a0f63cca094$var$SYMBOLS = {
    'm': [
        'm3',
        'P5'
    ],
    'mi': [
        'm3',
        'P5'
    ],
    'min': [
        'm3',
        'P5'
    ],
    '-': [
        'm3',
        'P5'
    ],
    'M': [
        'M3',
        'P5'
    ],
    'ma': [
        'M3',
        'P5'
    ],
    '': [
        'M3',
        'P5'
    ],
    '+': [
        'M3',
        'A5'
    ],
    'aug': [
        'M3',
        'A5'
    ],
    'dim': [
        'm3',
        'd5'
    ],
    'o': [
        'm3',
        'd5'
    ],
    'maj': [
        'M3',
        'P5',
        'M7'
    ],
    'dom': [
        'M3',
        'P5',
        'm7'
    ],
    "\xf8": [
        'm3',
        'd5',
        'm7'
    ],
    '5': [
        'P5'
    ],
    '6/9': [
        'M3',
        'P5',
        'M6',
        'M9'
    ]
};
module.exports = function(symbol) {
    var c, parsing = 'quality', additionals = [], name, chordLength = 2;
    var notes = [
        'P1',
        'M3',
        'P5',
        'm7',
        'M9',
        'P11',
        'M13'
    ];
    var explicitMajor = false;
    function setChord(name) {
        var intervals = $44083a0f63cca094$var$SYMBOLS[name];
        for(var i = 0, len = intervals.length; i < len; i++)notes[i + 1] = intervals[i];
        chordLength = intervals.length;
    }
    // Remove whitespace, commas and parentheses
    symbol = symbol.replace(/[,\s\(\)]/g, '');
    for(var i = 0, len = symbol.length; i < len; i++){
        if (!(c = symbol[i])) return;
        if (parsing === 'quality') {
            var sub3 = i + 2 < len ? symbol.substr(i, 3).toLowerCase() : null;
            var sub2 = i + 1 < len ? symbol.substr(i, 2).toLowerCase() : null;
            if (sub3 in $44083a0f63cca094$var$SYMBOLS) name = sub3;
            else if (sub2 in $44083a0f63cca094$var$SYMBOLS) name = sub2;
            else if (c in $44083a0f63cca094$var$SYMBOLS) name = c;
            else name = '';
            if (name) setChord(name);
            if (name === 'M' || name === 'ma' || name === 'maj') explicitMajor = true;
            i += name.length - 1;
            parsing = 'extension';
        } else if (parsing === 'extension') {
            c = c === '1' && symbol[i + 1] ? +symbol.substr(i, 2) : +c;
            if (!isNaN(c) && c !== 6) {
                chordLength = (c - 1) / 2;
                if (chordLength !== Math.round(chordLength)) return new Error('Invalid interval extension: ' + c.toString(10));
                if (name === 'o' || name === 'dim') notes[3] = 'd7';
                else if (explicitMajor) notes[3] = 'M7';
                i += c >= 10 ? 1 : 0;
            } else if (c === 6) {
                notes[3] = 'M6';
                chordLength = Math.max(3, chordLength);
            } else i -= 1;
            parsing = 'alterations';
        } else if (parsing === 'alterations') {
            var alterations = symbol.substr(i).split(/(#|b|add|maj|sus|M)/i), next, flat = false, sharp = false;
            if (alterations.length === 1) return new Error('Invalid alteration');
            else if (alterations[0].length !== 0) return new Error('Invalid token: \'' + alterations[0] + '\'');
            var ignore = false;
            alterations.forEach(function(alt, i, arr) {
                if (ignore || !alt.length) return ignore = false;
                var next = arr[i + 1], lower = alt.toLowerCase();
                if (alt === 'M' || lower === 'maj') {
                    if (next === '7') ignore = true;
                    chordLength = Math.max(3, chordLength);
                    notes[3] = 'M7';
                } else if (lower === 'sus') {
                    var type = 'P4';
                    if (next === '2' || next === '4') {
                        ignore = true;
                        if (next === '2') type = 'M2';
                    }
                    notes[1] = type; // Replace third with M2 or P4
                } else if (lower === 'add') {
                    if (next === '9') additionals.push('M9');
                    else if (next === '11') additionals.push('P11');
                    else if (next === '13') additionals.push('M13');
                    ignore = true;
                } else if (lower === 'b') flat = true;
                else if (lower === '#') sharp = true;
                else {
                    var token = +alt, quality, intPos;
                    if (isNaN(token) || String(token).length !== alt.length) return new Error('Invalid token: \'' + alt + '\'');
                    if (token === 6) {
                        if (sharp) notes[3] = 'A6';
                        else if (flat) notes[3] = 'm6';
                        else notes[3] = 'M6';
                        chordLength = Math.max(3, chordLength);
                        return;
                    }
                    // Calculate the position in the 'note' array
                    intPos = (token - 1) / 2;
                    if (chordLength < intPos) chordLength = intPos;
                    if (token < 5 || token === 7 || intPos !== Math.round(intPos)) return new Error('Invalid interval alteration: ' + token);
                    quality = notes[intPos][0];
                    // Alterate the quality of the interval according the accidentals
                    if (sharp) {
                        if (quality === 'd') quality = 'm';
                        else if (quality === 'm') quality = 'M';
                        else if (quality === 'M' || quality === 'P') quality = 'A';
                    } else if (flat) {
                        if (quality === 'A') quality = 'M';
                        else if (quality === 'M') quality = 'm';
                        else if (quality === 'm' || quality === 'P') quality = 'd';
                    }
                    sharp = flat = false;
                    notes[intPos] = quality + token;
                }
            });
            parsing = 'ended';
        } else if (parsing === 'ended') break;
    }
    return notes.slice(0, chordLength + 1).concat(additionals);
};

});


parcelRegister("eHpGI", function(module, exports) {

var $h2em1 = parcelRequire("h2em1");

var $awrqI = parcelRequire("awrqI");
var $ab3901f367e28613$var$scales = {
    aeolian: [
        'P1',
        'M2',
        'm3',
        'P4',
        'P5',
        'm6',
        'm7'
    ],
    blues: [
        'P1',
        'm3',
        'P4',
        'd5',
        'P5',
        'm7'
    ],
    chromatic: [
        'P1',
        'm2',
        'M2',
        'm3',
        'M3',
        'P4',
        'A4',
        'P5',
        'm6',
        'M6',
        'm7',
        'M7'
    ],
    dorian: [
        'P1',
        'M2',
        'm3',
        'P4',
        'P5',
        'M6',
        'm7'
    ],
    doubleharmonic: [
        'P1',
        'm2',
        'M3',
        'P4',
        'P5',
        'm6',
        'M7'
    ],
    harmonicminor: [
        'P1',
        'M2',
        'm3',
        'P4',
        'P5',
        'm6',
        'M7'
    ],
    ionian: [
        'P1',
        'M2',
        'M3',
        'P4',
        'P5',
        'M6',
        'M7'
    ],
    locrian: [
        'P1',
        'm2',
        'm3',
        'P4',
        'd5',
        'm6',
        'm7'
    ],
    lydian: [
        'P1',
        'M2',
        'M3',
        'A4',
        'P5',
        'M6',
        'M7'
    ],
    majorpentatonic: [
        'P1',
        'M2',
        'M3',
        'P5',
        'M6'
    ],
    melodicminor: [
        'P1',
        'M2',
        'm3',
        'P4',
        'P5',
        'M6',
        'M7'
    ],
    minorpentatonic: [
        'P1',
        'm3',
        'P4',
        'P5',
        'm7'
    ],
    mixolydian: [
        'P1',
        'M2',
        'M3',
        'P4',
        'P5',
        'M6',
        'm7'
    ],
    phrygian: [
        'P1',
        'm2',
        'm3',
        'P4',
        'P5',
        'm6',
        'm7'
    ],
    wholetone: [
        'P1',
        'M2',
        'M3',
        'A4',
        'A5',
        'A6'
    ]
};
// synonyms
$ab3901f367e28613$var$scales.harmonicchromatic = $ab3901f367e28613$var$scales.chromatic;
$ab3901f367e28613$var$scales.minor = $ab3901f367e28613$var$scales.aeolian;
$ab3901f367e28613$var$scales.major = $ab3901f367e28613$var$scales.ionian;
$ab3901f367e28613$var$scales.flamenco = $ab3901f367e28613$var$scales.doubleharmonic;
function $ab3901f367e28613$var$Scale(tonic, scale) {
    if (!(this instanceof $ab3901f367e28613$var$Scale)) return new $ab3901f367e28613$var$Scale(tonic, scale);
    var scaleName, i;
    if (!('coord' in tonic)) throw new Error('Invalid Tonic');
    if (typeof scale === 'string') {
        scaleName = scale;
        scale = $ab3901f367e28613$var$scales[scale];
        if (!scale) throw new Error('Invalid Scale');
    } else for(i in $ab3901f367e28613$var$scales){
        if ($ab3901f367e28613$var$scales.hasOwnProperty(i)) {
            if ($ab3901f367e28613$var$scales[i].toString() === scale.toString()) {
                scaleName = i;
                break;
            }
        }
    }
    this.name = scaleName;
    this.tonic = tonic;
    this.scale = scale;
}
$ab3901f367e28613$var$Scale.prototype = {
    notes: function() {
        var notes = [];
        for(var i = 0, length = this.scale.length; i < length; i++)notes.push(this.tonic.interval(this.scale[i]));
        return notes;
    },
    simple: function() {
        return this.notes().map(function(n) {
            return n.toString(true);
        });
    },
    type: function() {
        var length = this.scale.length - 2;
        if (length < 8) return [
            'di',
            'tri',
            'tetra',
            'penta',
            'hexa',
            'hepta',
            'octa'
        ][length] + 'tonic';
    },
    get: function(i) {
        var isStepStr = typeof i === 'string' && i in $h2em1.stepNumber;
        i = isStepStr ? $h2em1.stepNumber[i] : i;
        var len = this.scale.length;
        var interval, octaves;
        if (i < 0) {
            interval = this.scale[i % len + len - 1];
            octaves = Math.floor((i - 1) / len);
        } else if (i % len === 0) {
            interval = this.scale[len - 1];
            octaves = i / len - 1;
        } else {
            interval = this.scale[i % len - 1];
            octaves = Math.floor(i / len);
        }
        return this.tonic.interval(interval).interval(new $awrqI([
            octaves,
            0
        ]));
    },
    solfege: function(index, showOctaves) {
        if (index) return this.get(index).solfege(this, showOctaves);
        return this.notes().map(function(n) {
            return n.solfege(this, showOctaves);
        });
    },
    interval: function(interval) {
        interval = typeof interval === 'string' ? $awrqI.toCoord(interval) : interval;
        return new $ab3901f367e28613$var$Scale(this.tonic.interval(interval), this.scale);
    },
    transpose: function(interval) {
        var scale = this.interval(interval);
        this.scale = scale.scale;
        this.tonic = scale.tonic;
        return this;
    }
};
$ab3901f367e28613$var$Scale.KNOWN_SCALES = Object.keys($ab3901f367e28613$var$scales);
module.exports = $ab3901f367e28613$var$Scale;

});

parcelRegister("cV5PZ", function(module, exports) {

var $h2em1 = parcelRequire("h2em1");
module.exports = function(teoria) {
    var Note = teoria.Note;
    var Chord = teoria.Chord;
    var Scale = teoria.Scale;
    Note.prototype.chord = function(chord) {
        var isShortChord = chord in $h2em1.chordShort;
        chord = isShortChord ? $h2em1.chordShort[chord] : chord;
        return new Chord(this, chord);
    };
    Note.prototype.scale = function(scale) {
        return new Scale(this, scale);
    };
};

});


parcelRegister("kJWRP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f195ac6af4853fa1$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $f195ac6af4853fa1$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $f195ac6af4853fa1$var$longerTimeoutBrowsers = [
    'Edge',
    'Trident',
    'Firefox'
];
var $f195ac6af4853fa1$var$timeoutDuration = 0;
for(var $f195ac6af4853fa1$var$i = 0; $f195ac6af4853fa1$var$i < $f195ac6af4853fa1$var$longerTimeoutBrowsers.length; $f195ac6af4853fa1$var$i += 1)if ($f195ac6af4853fa1$var$isBrowser && navigator.userAgent.indexOf($f195ac6af4853fa1$var$longerTimeoutBrowsers[$f195ac6af4853fa1$var$i]) >= 0) {
    $f195ac6af4853fa1$var$timeoutDuration = 1;
    break;
}
function $f195ac6af4853fa1$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $f195ac6af4853fa1$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $f195ac6af4853fa1$var$timeoutDuration);
        }
    };
}
var $f195ac6af4853fa1$var$supportsMicroTasks = $f195ac6af4853fa1$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $f195ac6af4853fa1$var$debounce = $f195ac6af4853fa1$var$supportsMicroTasks ? $f195ac6af4853fa1$var$microtaskDebounce : $f195ac6af4853fa1$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $f195ac6af4853fa1$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $f195ac6af4853fa1$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var css = getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $f195ac6af4853fa1$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $f195ac6af4853fa1$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $f195ac6af4853fa1$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $f195ac6af4853fa1$var$getScrollParent($f195ac6af4853fa1$var$getParentNode(element));
}
var $f195ac6af4853fa1$var$isIE11 = $f195ac6af4853fa1$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $f195ac6af4853fa1$var$isIE10 = $f195ac6af4853fa1$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $f195ac6af4853fa1$var$isIE(version) {
    if (version === 11) return $f195ac6af4853fa1$var$isIE11;
    if (version === 10) return $f195ac6af4853fa1$var$isIE10;
    return $f195ac6af4853fa1$var$isIE11 || $f195ac6af4853fa1$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $f195ac6af4853fa1$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $f195ac6af4853fa1$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $f195ac6af4853fa1$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $f195ac6af4853fa1$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $f195ac6af4853fa1$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $f195ac6af4853fa1$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $f195ac6af4853fa1$var$getRoot(node) {
    if (node.parentNode !== null) return $f195ac6af4853fa1$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $f195ac6af4853fa1$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($f195ac6af4853fa1$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $f195ac6af4853fa1$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $f195ac6af4853fa1$var$getRoot(element1);
    if (element1root.host) return $f195ac6af4853fa1$var$findCommonOffsetParent(element1root.host, element2);
    else return $f195ac6af4853fa1$var$findCommonOffsetParent(element1, $f195ac6af4853fa1$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $f195ac6af4853fa1$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $f195ac6af4853fa1$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $f195ac6af4853fa1$var$getScroll(element, 'top');
    var scrollLeft = $f195ac6af4853fa1$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $f195ac6af4853fa1$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}
function $f195ac6af4853fa1$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $f195ac6af4853fa1$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $f195ac6af4853fa1$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $f195ac6af4853fa1$var$isIE(10) && getComputedStyle(html);
    return {
        height: $f195ac6af4853fa1$var$getSize('Height', body, html, computedStyle),
        width: $f195ac6af4853fa1$var$getSize('Width', body, html, computedStyle)
    };
}
var $f195ac6af4853fa1$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $f195ac6af4853fa1$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $f195ac6af4853fa1$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $f195ac6af4853fa1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $f195ac6af4853fa1$var$getClientRect(offsets) {
    return $f195ac6af4853fa1$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $f195ac6af4853fa1$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($f195ac6af4853fa1$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $f195ac6af4853fa1$var$getScroll(element, 'top');
            var scrollLeft = $f195ac6af4853fa1$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $f195ac6af4853fa1$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.right - result.left;
    var height = sizes.height || element.clientHeight || result.bottom - result.top;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $f195ac6af4853fa1$var$getStyleComputedProperty(element);
        horizScrollbar -= $f195ac6af4853fa1$var$getBordersSize(styles, 'x');
        vertScrollbar -= $f195ac6af4853fa1$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $f195ac6af4853fa1$var$getClientRect(result);
}
function $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $f195ac6af4853fa1$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $f195ac6af4853fa1$var$getBoundingClientRect(children);
    var parentRect = $f195ac6af4853fa1$var$getBoundingClientRect(parent);
    var scrollParent = $f195ac6af4853fa1$var$getScrollParent(children);
    var styles = $f195ac6af4853fa1$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $f195ac6af4853fa1$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop, 10);
        var marginLeft = parseFloat(styles.marginLeft, 10);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $f195ac6af4853fa1$var$includeScroll(offsets, parent);
    return offsets;
}
function $f195ac6af4853fa1$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $f195ac6af4853fa1$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $f195ac6af4853fa1$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $f195ac6af4853fa1$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $f195ac6af4853fa1$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($f195ac6af4853fa1$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    return $f195ac6af4853fa1$var$isFixed($f195ac6af4853fa1$var$getParentNode(element));
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $f195ac6af4853fa1$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $f195ac6af4853fa1$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $f195ac6af4853fa1$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $f195ac6af4853fa1$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $f195ac6af4853fa1$var$getFixedPositionOffsetParent(popper) : $f195ac6af4853fa1$var$findCommonOffsetParent(popper, reference);
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $f195ac6af4853fa1$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $f195ac6af4853fa1$var$getScrollParent($f195ac6af4853fa1$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$f195ac6af4853fa1$var$isFixed(offsetParent)) {
            var _getWindowSizes = $f195ac6af4853fa1$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $f195ac6af4853fa1$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $f195ac6af4853fa1$var$_extends({
            key: key
        }, rects[key], {
            area: $f195ac6af4853fa1$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $f195ac6af4853fa1$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $f195ac6af4853fa1$var$getFixedPositionOffsetParent(popper) : $f195ac6af4853fa1$var$findCommonOffsetParent(popper, reference);
    return $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $f195ac6af4853fa1$var$getOuterSizes(element) {
    var styles = getComputedStyle(element);
    var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $f195ac6af4853fa1$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $f195ac6af4853fa1$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $f195ac6af4853fa1$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$f195ac6af4853fa1$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $f195ac6af4853fa1$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $f195ac6af4853fa1$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $f195ac6af4853fa1$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $f195ac6af4853fa1$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $f195ac6af4853fa1$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $f195ac6af4853fa1$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $f195ac6af4853fa1$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $f195ac6af4853fa1$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $f195ac6af4853fa1$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $f195ac6af4853fa1$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $f195ac6af4853fa1$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $f195ac6af4853fa1$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $f195ac6af4853fa1$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($f195ac6af4853fa1$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$f195ac6af4853fa1$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicity asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $f195ac6af4853fa1$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $f195ac6af4853fa1$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $f195ac6af4853fa1$var$attachToScrollParents($f195ac6af4853fa1$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $f195ac6af4853fa1$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $f195ac6af4853fa1$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $f195ac6af4853fa1$var$getScrollParent(reference);
    $f195ac6af4853fa1$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $f195ac6af4853fa1$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $f195ac6af4853fa1$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $f195ac6af4853fa1$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $f195ac6af4853fa1$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $f195ac6af4853fa1$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $f195ac6af4853fa1$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $f195ac6af4853fa1$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $f195ac6af4853fa1$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $f195ac6af4853fa1$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $f195ac6af4853fa1$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $f195ac6af4853fa1$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $f195ac6af4853fa1$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $f195ac6af4853fa1$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $f195ac6af4853fa1$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $f195ac6af4853fa1$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $f195ac6af4853fa1$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $f195ac6af4853fa1$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $f195ac6af4853fa1$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $f195ac6af4853fa1$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    // Avoid blurry text by using full pixel integers.
    // For pixel-perfect positioning, top/bottom prefers rounded
    // values, while left/right prefers floored values.
    var offsets = {
        left: Math.floor(popper.left),
        top: Math.round(popper.top),
        bottom: Math.round(popper.bottom),
        right: Math.floor(popper.right)
    };
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $f195ac6af4853fa1$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $f195ac6af4853fa1$var$_extends({}, attributes, data.attributes);
    data.styles = $f195ac6af4853fa1$var$_extends({}, styles, data.styles);
    data.arrowStyles = $f195ac6af4853fa1$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $f195ac6af4853fa1$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $f195ac6af4853fa1$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$f195ac6af4853fa1$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $f195ac6af4853fa1$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $f195ac6af4853fa1$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $f195ac6af4853fa1$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $f195ac6af4853fa1$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $f195ac6af4853fa1$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $f195ac6af4853fa1$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $f195ac6af4853fa1$var$validPlacements = $f195ac6af4853fa1$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $f195ac6af4853fa1$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $f195ac6af4853fa1$var$validPlacements.indexOf(placement);
    var arr = $f195ac6af4853fa1$var$validPlacements.slice(index + 1).concat($f195ac6af4853fa1$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $f195ac6af4853fa1$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($f195ac6af4853fa1$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $f195ac6af4853fa1$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $f195ac6af4853fa1$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $f195ac6af4853fa1$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $f195ac6af4853fa1$var$clockwise(placement);
            break;
        case $f195ac6af4853fa1$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $f195ac6af4853fa1$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $f195ac6af4853fa1$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $f195ac6af4853fa1$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $f195ac6af4853fa1$var$_extends({}, data.offsets.popper, $f195ac6af4853fa1$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $f195ac6af4853fa1$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $f195ac6af4853fa1$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $f195ac6af4853fa1$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $f195ac6af4853fa1$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($f195ac6af4853fa1$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $f195ac6af4853fa1$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($f195ac6af4853fa1$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($f195ac6af4853fa1$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $f195ac6af4853fa1$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $f195ac6af4853fa1$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $f195ac6af4853fa1$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $f195ac6af4853fa1$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $f195ac6af4853fa1$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $f195ac6af4853fa1$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $f195ac6af4853fa1$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $f195ac6af4853fa1$var$defineProperty({}, side, reference[side]),
            end: $f195ac6af4853fa1$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $f195ac6af4853fa1$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$hide(data) {
    if (!$f195ac6af4853fa1$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $f195ac6af4853fa1$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $f195ac6af4853fa1$var$getOppositePlacement(placement);
    data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $f195ac6af4853fa1$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport'
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$applyStyle,
        /** @prop {Function} */ onLoad: $f195ac6af4853fa1$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $f195ac6af4853fa1$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $f195ac6af4853fa1$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $f195ac6af4853fa1$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $f195ac6af4853fa1$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $f195ac6af4853fa1$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $f195ac6af4853fa1$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($f195ac6af4853fa1$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $f195ac6af4853fa1$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $f195ac6af4853fa1$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $f195ac6af4853fa1$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $f195ac6af4853fa1$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $f195ac6af4853fa1$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $f195ac6af4853fa1$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $f195ac6af4853fa1$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $f195ac6af4853fa1$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $f195ac6af4853fa1$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$f195ac6af4853fa1$var$Popper.placements = $f195ac6af4853fa1$var$placements;
$f195ac6af4853fa1$var$Popper.Defaults = $f195ac6af4853fa1$var$Defaults;
var $f195ac6af4853fa1$export$2e2bcd8739ae039 = $f195ac6af4853fa1$var$Popper;

});

var $f89d8ffbdc18f2ab$export$c9d39ca3bcd93abb;
var $f89d8ffbdc18f2ab$export$b791fe48eec8032a;
/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    'use strict';
    /** Global Methods **/ /***************************************************************************/ /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */ var HowlerGlobal1 = function() {
        this.init();
    };
    HowlerGlobal1.prototype = {
        /**
     * Initialize the global Howler object.
     * @return {Howler}
     */ init: function() {
            var self = this || Howler1;
            // Create a global ID counter.
            self._counter = 1000;
            // Pool of unlocked HTML5 Audio objects.
            self._html5AudioPool = [];
            self.html5PoolSize = 10;
            // Internal properties.
            self._codecs = {};
            self._howls = [];
            self._muted = false;
            self._volume = 1;
            self._canPlayEvent = 'canplaythrough';
            self._navigator = typeof window !== 'undefined' && window.navigator ? window.navigator : null;
            // Public properties.
            self.masterGain = null;
            self.noAudio = false;
            self.usingWebAudio = true;
            self.autoSuspend = true;
            self.ctx = null;
            // Set to false to disable the auto audio unlocker.
            self.autoUnlock = true;
            // Setup the various state values for global tracking.
            self._setup();
            return self;
        },
        /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */ volume: function(vol) {
            var self = this || Howler1;
            vol = parseFloat(vol);
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
                self._volume = vol;
                // Don't update any of the nodes if we are muted.
                if (self._muted) return self;
                // When using Web Audio, we just need to adjust the master gain.
                if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                // Loop through and change volume for all HTML5 audio nodes.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and change the volumes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node) sound._node.volume = sound._volume * vol;
                    }
                }
                return self;
            }
            return self._volume;
        },
        /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */ mute: function(muted) {
            var self = this || Howler1;
            // If we don't have an AudioContext created yet, run the setup.
            if (!self.ctx) setupAudioContext();
            self._muted = muted;
            // With Web Audio, we just need to mute the master gain.
            if (self.usingWebAudio) self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler1.ctx.currentTime);
            // Loop through and mute all HTML5 Audio nodes.
            for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                // Get all of the sounds in this Howl group.
                var ids = self._howls[i]._getSoundIds();
                // Loop through all sounds and mark the audio node as muted.
                for(var j = 0; j < ids.length; j++){
                    var sound = self._howls[i]._soundById(ids[j]);
                    if (sound && sound._node) sound._node.muted = muted ? true : sound._muted;
                }
            }
            return self;
        },
        /**
     * Handle stopping all sounds globally.
     */ stop: function() {
            var self = this || Howler1;
            // Loop through all Howls and stop them.
            for(var i = 0; i < self._howls.length; i++)self._howls[i].stop();
            return self;
        },
        /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */ unload: function() {
            var self = this || Howler1;
            for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].unload();
            // Create a new AudioContext to make sure it is fully reset.
            if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
                self.ctx.close();
                self.ctx = null;
                setupAudioContext();
            }
            return self;
        },
        /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */ codecs: function(ext) {
            return (this || Howler1)._codecs[ext.replace(/^x-/, '')];
        },
        /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */ _setup: function() {
            var self = this || Howler1;
            // Keeps track of the suspend/resume state of the AudioContext.
            self.state = self.ctx ? self.ctx.state || 'suspended' : 'suspended';
            // Automatically begin the 30-second suspend process
            self._autoSuspend();
            // Check if audio is available.
            if (!self.usingWebAudio) {
                // No audio is available on this system if noAudio is set to true.
                if (typeof Audio !== 'undefined') try {
                    var test = new Audio();
                    // Check if the canplaythrough event is available.
                    if (typeof test.oncanplaythrough === 'undefined') self._canPlayEvent = 'canplay';
                } catch (e) {
                    self.noAudio = true;
                }
                else self.noAudio = true;
            }
            // Test to make sure audio isn't disabled in Internet Explorer.
            try {
                var test = new Audio();
                if (test.muted) self.noAudio = true;
            } catch (e) {}
            // Check for supported codecs.
            if (!self.noAudio) self._setupCodecs();
            return self;
        },
        /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */ _setupCodecs: function() {
            var self = this || Howler1;
            var audioTest = null;
            // Must wrap in a try/catch because IE11 in server mode throws an error.
            try {
                audioTest = typeof Audio !== 'undefined' ? new Audio() : null;
            } catch (err) {
                return self;
            }
            if (!audioTest || typeof audioTest.canPlayType !== 'function') return self;
            var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');
            // Opera version <33 has mixed MP3 support, so we need to check for and block it.
            var ua = self._navigator ? self._navigator.userAgent : '';
            var checkOpera = ua.match(/OPR\/(\d+)/g);
            var isOldOpera = checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33;
            var checkSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
            var safariVersion = ua.match(/Version\/(.*?) /);
            var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
            self._codecs = {
                mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
                mpeg: !!mpegTest,
                opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
                ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
                oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
                wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType('audio/wav')).replace(/^no$/, ''),
                aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
                caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
                m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                m4b: !!(audioTest.canPlayType('audio/x-m4b;') || audioTest.canPlayType('audio/m4b;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
                weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
                webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
                dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
                flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
            };
            return self;
        },
        /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */ _unlockAudio: function() {
            var self = this || Howler1;
            // Only run this if Web Audio is supported and it hasn't already been unlocked.
            if (self._audioUnlocked || !self.ctx) return;
            self._audioUnlocked = false;
            self.autoUnlock = false;
            // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
            // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
            // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
            if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
                self._mobileUnloaded = true;
                self.unload();
            }
            // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
            // http://stackoverflow.com/questions/24119684
            self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);
            // Call this method on touch start to create and play a buffer,
            // then check if the audio actually played to determine if
            // audio has now been unlocked on iOS, Android, etc.
            var unlock = function(e) {
                // Create a pool of unlocked HTML5 Audio objects that can
                // be used for playing sounds without user interaction. HTML5
                // Audio objects must be individually unlocked, as opposed
                // to the WebAudio API which only needs a single activation.
                // This must occur before WebAudio setup or the source.onended
                // event will not fire.
                while(self._html5AudioPool.length < self.html5PoolSize)try {
                    var audioNode = new Audio();
                    // Mark this Audio object as unlocked to ensure it can get returned
                    // to the unlocked pool when released.
                    audioNode._unlocked = true;
                    // Add the audio node to the pool.
                    self._releaseHtml5Audio(audioNode);
                } catch (e) {
                    self.noAudio = true;
                    break;
                }
                // Loop through any assigned audio nodes and unlock them.
                for(var i = 0; i < self._howls.length; i++)if (!self._howls[i]._webAudio) {
                    // Get all of the sounds in this Howl group.
                    var ids = self._howls[i]._getSoundIds();
                    // Loop through all sounds and unlock the audio nodes.
                    for(var j = 0; j < ids.length; j++){
                        var sound = self._howls[i]._soundById(ids[j]);
                        if (sound && sound._node && !sound._node._unlocked) {
                            sound._node._unlocked = true;
                            sound._node.load();
                        }
                    }
                }
                // Fix Android can not play in suspend state.
                self._autoResume();
                // Create an empty buffer.
                var source = self.ctx.createBufferSource();
                source.buffer = self._scratchBuffer;
                source.connect(self.ctx.destination);
                // Play the empty buffer.
                if (typeof source.start === 'undefined') source.noteOn(0);
                else source.start(0);
                // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
                if (typeof self.ctx.resume === 'function') self.ctx.resume();
                // Setup a timeout to check that we are unlocked on the next event loop.
                source.onended = function() {
                    source.disconnect(0);
                    // Update the unlocked state and prevent this check from happening again.
                    self._audioUnlocked = true;
                    // Remove the touch start listener.
                    document.removeEventListener('touchstart', unlock, true);
                    document.removeEventListener('touchend', unlock, true);
                    document.removeEventListener('click', unlock, true);
                    document.removeEventListener('keydown', unlock, true);
                    // Let all sounds know that audio has been unlocked.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit('unlock');
                };
            };
            // Setup a touch start listener to attempt an unlock in.
            document.addEventListener('touchstart', unlock, true);
            document.addEventListener('touchend', unlock, true);
            document.addEventListener('click', unlock, true);
            document.addEventListener('keydown', unlock, true);
            return self;
        },
        /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */ _obtainHtml5Audio: function() {
            var self = this || Howler1;
            // Return the next object from the pool if one exists.
            if (self._html5AudioPool.length) return self._html5AudioPool.pop();
            //.Check if the audio is locked and throw a warning.
            var testPlay = new Audio().play();
            if (testPlay && typeof Promise !== 'undefined' && (testPlay instanceof Promise || typeof testPlay.then === 'function')) testPlay.catch(function() {
                console.warn('HTML5 Audio pool exhausted, returning potentially locked audio object.');
            });
            return new Audio();
        },
        /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */ _releaseHtml5Audio: function(audio) {
            var self = this || Howler1;
            // Don't add audio to the pool if we don't know if it has been unlocked.
            if (audio._unlocked) self._html5AudioPool.push(audio);
            return self;
        },
        /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */ _autoSuspend: function() {
            var self = this;
            if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler1.usingWebAudio) return;
            // Check if any sounds are playing.
            for(var i = 0; i < self._howls.length; i++){
                if (self._howls[i]._webAudio) for(var j = 0; j < self._howls[i]._sounds.length; j++){
                    if (!self._howls[i]._sounds[j]._paused) return self;
                }
            }
            if (self._suspendTimer) clearTimeout(self._suspendTimer);
            // If no sound has played after 30 seconds, suspend the context.
            self._suspendTimer = setTimeout(function() {
                if (!self.autoSuspend) return;
                self._suspendTimer = null;
                self.state = 'suspending';
                // Handle updating the state of the audio context after suspending.
                var handleSuspension = function() {
                    self.state = 'suspended';
                    if (self._resumeAfterSuspend) {
                        delete self._resumeAfterSuspend;
                        self._autoResume();
                    }
                };
                // Either the state gets suspended or it is interrupted.
                // Either way, we need to update the state to suspended.
                self.ctx.suspend().then(handleSuspension, handleSuspension);
            }, 30000);
            return self;
        },
        /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */ _autoResume: function() {
            var self = this;
            if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler1.usingWebAudio) return;
            if (self.state === 'running' && self.ctx.state !== 'interrupted' && self._suspendTimer) {
                clearTimeout(self._suspendTimer);
                self._suspendTimer = null;
            } else if (self.state === 'suspended' || self.state === 'running' && self.ctx.state === 'interrupted') {
                self.ctx.resume().then(function() {
                    self.state = 'running';
                    // Emit to all Howls that the audio has resumed.
                    for(var i = 0; i < self._howls.length; i++)self._howls[i]._emit('resume');
                });
                if (self._suspendTimer) {
                    clearTimeout(self._suspendTimer);
                    self._suspendTimer = null;
                }
            } else if (self.state === 'suspending') self._resumeAfterSuspend = true;
            return self;
        }
    };
    // Setup the global audio controller.
    var Howler1 = new HowlerGlobal1();
    /** Group Methods **/ /***************************************************************************/ /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */ var Howl1 = function(o) {
        var self = this;
        // Throw an error if no source is provided.
        if (!o.src || o.src.length === 0) {
            console.error('An array of source files must be passed with any new Howl.');
            return;
        }
        self.init(o);
    };
    Howl1.prototype = {
        /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */ init: function(o) {
            var self = this;
            // If we don't have an AudioContext created yet, run the setup.
            if (!Howler1.ctx) setupAudioContext();
            // Setup user-defined default properties.
            self._autoplay = o.autoplay || false;
            self._format = typeof o.format !== 'string' ? o.format : [
                o.format
            ];
            self._html5 = o.html5 || false;
            self._muted = o.mute || false;
            self._loop = o.loop || false;
            self._pool = o.pool || 5;
            self._preload = typeof o.preload === 'boolean' || o.preload === 'metadata' ? o.preload : true;
            self._rate = o.rate || 1;
            self._sprite = o.sprite || {};
            self._src = typeof o.src !== 'string' ? o.src : [
                o.src
            ];
            self._volume = o.volume !== undefined ? o.volume : 1;
            self._xhr = {
                method: o.xhr && o.xhr.method ? o.xhr.method : 'GET',
                headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
                withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
            };
            // Setup all other default properties.
            self._duration = 0;
            self._state = 'unloaded';
            self._sounds = [];
            self._endTimers = {};
            self._queue = [];
            self._playLock = false;
            // Setup event listeners.
            self._onend = o.onend ? [
                {
                    fn: o.onend
                }
            ] : [];
            self._onfade = o.onfade ? [
                {
                    fn: o.onfade
                }
            ] : [];
            self._onload = o.onload ? [
                {
                    fn: o.onload
                }
            ] : [];
            self._onloaderror = o.onloaderror ? [
                {
                    fn: o.onloaderror
                }
            ] : [];
            self._onplayerror = o.onplayerror ? [
                {
                    fn: o.onplayerror
                }
            ] : [];
            self._onpause = o.onpause ? [
                {
                    fn: o.onpause
                }
            ] : [];
            self._onplay = o.onplay ? [
                {
                    fn: o.onplay
                }
            ] : [];
            self._onstop = o.onstop ? [
                {
                    fn: o.onstop
                }
            ] : [];
            self._onmute = o.onmute ? [
                {
                    fn: o.onmute
                }
            ] : [];
            self._onvolume = o.onvolume ? [
                {
                    fn: o.onvolume
                }
            ] : [];
            self._onrate = o.onrate ? [
                {
                    fn: o.onrate
                }
            ] : [];
            self._onseek = o.onseek ? [
                {
                    fn: o.onseek
                }
            ] : [];
            self._onunlock = o.onunlock ? [
                {
                    fn: o.onunlock
                }
            ] : [];
            self._onresume = [];
            // Web Audio or HTML5 Audio?
            self._webAudio = Howler1.usingWebAudio && !self._html5;
            // Automatically try to enable audio.
            if (typeof Howler1.ctx !== 'undefined' && Howler1.ctx && Howler1.autoUnlock) Howler1._unlockAudio();
            // Keep track of this Howl group in the global controller.
            Howler1._howls.push(self);
            // If they selected autoplay, add a play event to the load queue.
            if (self._autoplay) self._queue.push({
                event: 'play',
                action: function() {
                    self.play();
                }
            });
            // Load the source file unless otherwise specified.
            if (self._preload && self._preload !== 'none') self.load();
            return self;
        },
        /**
     * Load the audio file.
     * @return {Howler}
     */ load: function() {
            var self = this;
            var url = null;
            // If no audio is available, quit immediately.
            if (Howler1.noAudio) {
                self._emit('loaderror', null, 'No audio support.');
                return;
            }
            // Make sure our source is in an array.
            if (typeof self._src === 'string') self._src = [
                self._src
            ];
            // Loop through the sources and pick the first one that is compatible.
            for(var i = 0; i < self._src.length; i++){
                var ext, str;
                if (self._format && self._format[i]) // If an extension was specified, use that instead.
                ext = self._format[i];
                else {
                    // Make sure the source is a string.
                    str = self._src[i];
                    if (typeof str !== 'string') {
                        self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
                        continue;
                    }
                    // Extract the file extension from the URL or base64 data URI.
                    ext = /^data:audio\/([^;,]+);/i.exec(str);
                    if (!ext) ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
                    if (ext) ext = ext[1].toLowerCase();
                }
                // Log a warning if no extension was found.
                if (!ext) console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
                // Check if this extension is available.
                if (ext && Howler1.codecs(ext)) {
                    url = self._src[i];
                    break;
                }
            }
            if (!url) {
                self._emit('loaderror', null, 'No codec support for selected audio sources.');
                return;
            }
            self._src = url;
            self._state = 'loading';
            // If the hosting page is HTTPS and the source isn't,
            // drop down to HTML5 Audio to avoid Mixed Content errors.
            if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
                self._html5 = true;
                self._webAudio = false;
            }
            // Create a new sound object and add it to the pool.
            new Sound1(self);
            // Load and decode the audio data for playback.
            if (self._webAudio) loadBuffer(self);
            return self;
        },
        /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */ play: function(sprite, internal) {
            var self = this;
            var id = null;
            // Determine if a sprite, sound id or nothing was passed
            if (typeof sprite === 'number') {
                id = sprite;
                sprite = null;
            } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) // If the passed sprite doesn't exist, do nothing.
            return null;
            else if (typeof sprite === 'undefined') {
                // Use the default sound sprite (plays the full audio length).
                sprite = '__default';
                // Check if there is a single paused sound that isn't ended.
                // If there is, play that sound. If not, continue as usual.
                if (!self._playLock) {
                    var num = 0;
                    for(var i = 0; i < self._sounds.length; i++)if (self._sounds[i]._paused && !self._sounds[i]._ended) {
                        num++;
                        id = self._sounds[i]._id;
                    }
                    if (num === 1) sprite = null;
                    else id = null;
                }
            }
            // Get the selected node, or get one from the pool.
            var sound = id ? self._soundById(id) : self._inactiveSound();
            // If the sound doesn't exist, do nothing.
            if (!sound) return null;
            // Select the sprite definition.
            if (id && !sprite) sprite = sound._sprite || '__default';
            // If the sound hasn't loaded, we must wait to get the audio's duration.
            // We also need to wait to make sure we don't run into race conditions with
            // the order of function calls.
            if (self._state !== 'loaded') {
                // Set the sprite value on this sound.
                sound._sprite = sprite;
                // Mark this sound as not ended in case another sound is played before this one loads.
                sound._ended = false;
                // Add the sound to the queue to be played on load.
                var soundId = sound._id;
                self._queue.push({
                    event: 'play',
                    action: function() {
                        self.play(soundId);
                    }
                });
                return soundId;
            }
            // Don't play the sound if an id was passed and it is already playing.
            if (id && !sound._paused) {
                // Trigger the play event, in order to keep iterating through queue.
                if (!internal) self._loadQueue('play');
                return sound._id;
            }
            // Make sure the AudioContext isn't suspended, and resume it if it is.
            if (self._webAudio) Howler1._autoResume();
            // Determine how long to play for and where to start playing.
            var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
            var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
            var timeout = duration * 1000 / Math.abs(sound._rate);
            var start = self._sprite[sprite][0] / 1000;
            var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
            sound._sprite = sprite;
            // Mark the sound as ended instantly so that this async playback
            // doesn't get grabbed by another call to play while this one waits to start.
            sound._ended = false;
            // Update the parameters of the sound.
            var setParams = function() {
                sound._paused = false;
                sound._seek = seek;
                sound._start = start;
                sound._stop = stop;
                sound._loop = !!(sound._loop || self._sprite[sprite][2]);
            };
            // End the sound instantly if seek is at the end.
            if (seek >= stop) {
                self._ended(sound);
                return;
            }
            // Begin the actual playback.
            var node = sound._node;
            if (self._webAudio) {
                // Fire this when the sound is ready to play to begin Web Audio playback.
                var playWebAudio = function() {
                    self._playLock = false;
                    setParams();
                    self._refreshBuffer(sound);
                    // Setup the playback params.
                    var vol = sound._muted || self._muted ? 0 : sound._volume;
                    node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                    sound._playStart = Howler1.ctx.currentTime;
                    // Play the sound using the supported method.
                    if (typeof node.bufferSource.start === 'undefined') sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
                    else sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
                    // Start a new timer if none is present.
                    if (timeout !== Infinity) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                    if (!internal) setTimeout(function() {
                        self._emit('play', sound._id);
                        self._loadQueue();
                    }, 0);
                };
                if (Howler1.state === 'running' && Howler1.ctx.state !== 'interrupted') playWebAudio();
                else {
                    self._playLock = true;
                    // Wait for the audio context to resume before playing.
                    self.once('resume', playWebAudio);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            } else {
                // Fire this when the sound is ready to play to begin HTML5 Audio playback.
                var playHtml5 = function() {
                    node.currentTime = seek;
                    node.muted = sound._muted || self._muted || Howler1._muted || node.muted;
                    node.volume = sound._volume * Howler1.volume();
                    node.playbackRate = sound._rate;
                    // Some browsers will throw an error if this is called without user interaction.
                    try {
                        var play = node.play();
                        // Support older browsers that don't support promises, and thus don't have this issue.
                        if (play && typeof Promise !== 'undefined' && (play instanceof Promise || typeof play.then === 'function')) {
                            // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
                            self._playLock = true;
                            // Set param values immediately.
                            setParams();
                            // Releases the lock and executes queued actions.
                            play.then(function() {
                                self._playLock = false;
                                node._unlocked = true;
                                if (!internal) self._emit('play', sound._id);
                                else self._loadQueue();
                            }).catch(function() {
                                self._playLock = false;
                                self._emit('playerror', sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                // Reset the ended and paused values.
                                sound._ended = true;
                                sound._paused = true;
                            });
                        } else if (!internal) {
                            self._playLock = false;
                            setParams();
                            self._emit('play', sound._id);
                        }
                        // Setting rate before playing won't work in IE, so we set it again here.
                        node.playbackRate = sound._rate;
                        // If the node is still paused, then we can assume there was a playback issue.
                        if (node.paused) {
                            self._emit('playerror', sound._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                            return;
                        }
                        // Setup the end timer on sprites or listen for the ended event.
                        if (sprite !== '__default' || sound._loop) self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
                        else {
                            self._endTimers[sound._id] = function() {
                                // Fire ended on this audio node.
                                self._ended(sound);
                                // Clear this listener.
                                node.removeEventListener('ended', self._endTimers[sound._id], false);
                            };
                            node.addEventListener('ended', self._endTimers[sound._id], false);
                        }
                    } catch (err) {
                        self._emit('playerror', sound._id, err);
                    }
                };
                // If this is streaming audio, make sure the src is set and load again.
                if (node.src === 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA') {
                    node.src = self._src;
                    node.load();
                }
                // Play immediately if ready, or wait for the 'canplaythrough'e vent.
                var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler1._navigator.isCocoonJS;
                if (node.readyState >= 3 || loadedNoReadyState) playHtml5();
                else {
                    self._playLock = true;
                    self._state = 'loading';
                    var listener = function() {
                        self._state = 'loaded';
                        // Begin playback.
                        playHtml5();
                        // Clear this listener.
                        node.removeEventListener(Howler1._canPlayEvent, listener, false);
                    };
                    node.addEventListener(Howler1._canPlayEvent, listener, false);
                    // Cancel the end timer.
                    self._clearTimer(sound._id);
                }
            }
            return sound._id;
        },
        /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */ pause: function(id) {
            var self = this;
            // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'pause',
                    action: function() {
                        self.pause(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be paused.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound && !sound._paused) {
                    // Reset the seek position.
                    sound._seek = self.seek(ids[i]);
                    sound._rateSeek = 0;
                    sound._paused = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) {
                            // Make sure the sound has been created.
                            if (!sound._node.bufferSource) continue;
                            if (typeof sound._node.bufferSource.stop === 'undefined') sound._node.bufferSource.noteOff(0);
                            else sound._node.bufferSource.stop(0);
                            // Clean up the buffer source.
                            self._cleanBuffer(sound._node);
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) sound._node.pause();
                    }
                }
                // Fire the pause event, unless `true` is passed as the 2nd argument.
                if (!arguments[1]) self._emit('pause', sound ? sound._id : null);
            }
            return self;
        },
        /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */ stop: function(id, internal) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to stop when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'stop',
                    action: function() {
                        self.stop(id);
                    }
                });
                return self;
            }
            // If no id is passed, get all ID's to be stopped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Clear the end timer.
                self._clearTimer(ids[i]);
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    // Reset the seek position.
                    sound._seek = sound._start || 0;
                    sound._rateSeek = 0;
                    sound._paused = true;
                    sound._ended = true;
                    // Stop currently running fades.
                    self._stopFade(ids[i]);
                    if (sound._node) {
                        if (self._webAudio) // Make sure the sound's AudioBufferSourceNode has been created.
                        {
                            if (sound._node.bufferSource) {
                                if (typeof sound._node.bufferSource.stop === 'undefined') sound._node.bufferSource.noteOff(0);
                                else sound._node.bufferSource.stop(0);
                                // Clean up the buffer source.
                                self._cleanBuffer(sound._node);
                            }
                        } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
                            sound._node.currentTime = sound._start || 0;
                            sound._node.pause();
                            // If this is a live stream, stop download once the audio is stopped.
                            if (sound._node.duration === Infinity) self._clearSound(sound._node);
                        }
                    }
                    if (!internal) self._emit('stop', sound._id);
                }
            }
            return self;
        },
        /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */ mute: function(muted, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to mute when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'mute',
                    action: function() {
                        self.mute(muted, id);
                    }
                });
                return self;
            }
            // If applying mute/unmute to all sounds, update the group's value.
            if (typeof id === 'undefined') {
                if (typeof muted === 'boolean') self._muted = muted;
                else return self._muted;
            }
            // If no id is passed, get all ID's to be muted.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                if (sound) {
                    sound._muted = muted;
                    // Cancel active fade and set the volume to the end value.
                    if (sound._interval) self._stopFade(sound._id);
                    if (self._webAudio && sound._node) sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler1.ctx.currentTime);
                    else if (sound._node) sound._node.muted = Howler1._muted ? true : muted;
                    self._emit('mute', sound._id);
                }
            }
            return self;
        },
        /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */ volume: function() {
            var self = this;
            var args = arguments;
            var vol, id;
            // Determine the values based on arguments.
            if (args.length === 0) // Return the value of the groups' volume.
            return self._volume;
            else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
                // First check if this is an ID, and if not, assume it is a new volume.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else vol = parseFloat(args[0]);
            } else if (args.length >= 2) {
                vol = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the volume or return the current volume.
            var sound;
            if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
                // If the sound hasn't loaded, add it to the load queue to change volume when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        event: 'volume',
                        action: function() {
                            self.volume.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group volume.
                if (typeof id === 'undefined') self._volume = vol;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        sound._volume = vol;
                        // Stop currently running fades.
                        if (!args[2]) self._stopFade(id[i]);
                        if (self._webAudio && sound._node && !sound._muted) sound._node.gain.setValueAtTime(vol, Howler1.ctx.currentTime);
                        else if (sound._node && !sound._muted) sound._node.volume = vol * Howler1.volume();
                        self._emit('volume', sound._id);
                    }
                }
            } else {
                sound = id ? self._soundById(id) : self._sounds[0];
                return sound ? sound._volume : 0;
            }
            return self;
        },
        /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */ fade: function(from, to, len, id) {
            var self = this;
            // If the sound hasn't loaded, add it to the load queue to fade when capable.
            if (self._state !== 'loaded' || self._playLock) {
                self._queue.push({
                    event: 'fade',
                    action: function() {
                        self.fade(from, to, len, id);
                    }
                });
                return self;
            }
            // Make sure the to/from/len values are numbers.
            from = Math.min(Math.max(0, parseFloat(from)), 1);
            to = Math.min(Math.max(0, parseFloat(to)), 1);
            len = parseFloat(len);
            // Set the volume to the start position.
            self.volume(from, id);
            // Fade the volume of one or all sounds.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                // Get the sound.
                var sound = self._soundById(ids[i]);
                // Create a linear fade or fall back to timeouts with HTML5 Audio.
                if (sound) {
                    // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
                    if (!id) self._stopFade(ids[i]);
                    // If we are using Web Audio, let the native methods do the actual fade.
                    if (self._webAudio && !sound._muted) {
                        var currentTime = Howler1.ctx.currentTime;
                        var end = currentTime + len / 1000;
                        sound._volume = from;
                        sound._node.gain.setValueAtTime(from, currentTime);
                        sound._node.gain.linearRampToValueAtTime(to, end);
                    }
                    self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
                }
            }
            return self;
        },
        /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */ _startFadeInterval: function(sound, from, to, len, id, isGroup) {
            var self = this;
            var vol = from;
            var diff = to - from;
            var steps = Math.abs(diff / 0.01);
            var stepLen = Math.max(4, steps > 0 ? len / steps : len);
            var lastTick = Date.now();
            // Store the value being faded to.
            sound._fadeTo = to;
            // Update the volume value on each interval tick.
            sound._interval = setInterval(function() {
                // Update the volume based on the time since the last tick.
                var tick = (Date.now() - lastTick) / len;
                lastTick = Date.now();
                vol += diff * tick;
                // Round to within 2 decimal points.
                vol = Math.round(vol * 100) / 100;
                // Make sure the volume is in the right bounds.
                if (diff < 0) vol = Math.max(to, vol);
                else vol = Math.min(to, vol);
                // Change the volume.
                if (self._webAudio) sound._volume = vol;
                else self.volume(vol, sound._id, true);
                // Set the group's volume.
                if (isGroup) self._volume = vol;
                // When the fade is complete, stop it and fire event.
                if (to < from && vol <= to || to > from && vol >= to) {
                    clearInterval(sound._interval);
                    sound._interval = null;
                    sound._fadeTo = null;
                    self.volume(to, sound._id);
                    self._emit('fade', sound._id);
                }
            }, stepLen);
        },
        /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */ _stopFade: function(id) {
            var self = this;
            var sound = self._soundById(id);
            if (sound && sound._interval) {
                if (self._webAudio) sound._node.gain.cancelScheduledValues(Howler1.ctx.currentTime);
                clearInterval(sound._interval);
                sound._interval = null;
                self.volume(sound._fadeTo, id);
                sound._fadeTo = null;
                self._emit('fade', id);
            }
            return self;
        },
        /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */ loop: function() {
            var self = this;
            var args = arguments;
            var loop, id, sound;
            // Determine the values for loop and id.
            if (args.length === 0) // Return the grou's loop value.
            return self._loop;
            else if (args.length === 1) {
                if (typeof args[0] === 'boolean') {
                    loop = args[0];
                    self._loop = loop;
                } else {
                    // Return this sound's loop value.
                    sound = self._soundById(parseInt(args[0], 10));
                    return sound ? sound._loop : false;
                }
            } else if (args.length === 2) {
                loop = args[0];
                id = parseInt(args[1], 10);
            }
            // If no id is passed, get all ID's to be looped.
            var ids = self._getSoundIds(id);
            for(var i = 0; i < ids.length; i++){
                sound = self._soundById(ids[i]);
                if (sound) {
                    sound._loop = loop;
                    if (self._webAudio && sound._node && sound._node.bufferSource) {
                        sound._node.bufferSource.loop = loop;
                        if (loop) {
                            sound._node.bufferSource.loopStart = sound._start || 0;
                            sound._node.bufferSource.loopEnd = sound._stop;
                            // If playing, restart playback to ensure looping updates.
                            if (self.playing(ids[i])) {
                                self.pause(ids[i], true);
                                self.play(ids[i], true);
                            }
                        }
                    }
                }
            }
            return self;
        },
        /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */ rate: function() {
            var self = this;
            var args = arguments;
            var rate, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current rate of the first node.
            id = self._sounds[0]._id;
            else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new rate value.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else rate = parseFloat(args[0]);
            } else if (args.length === 2) {
                rate = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // Update the playback rate or return the current value.
            var sound;
            if (typeof rate === 'number') {
                // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
                if (self._state !== 'loaded' || self._playLock) {
                    self._queue.push({
                        event: 'rate',
                        action: function() {
                            self.rate.apply(self, args);
                        }
                    });
                    return self;
                }
                // Set the group rate.
                if (typeof id === 'undefined') self._rate = rate;
                // Update one or all volumes.
                id = self._getSoundIds(id);
                for(var i = 0; i < id.length; i++){
                    // Get the sound.
                    sound = self._soundById(id[i]);
                    if (sound) {
                        // Keep track of our position when the rate changed and update the playback
                        // start position so we can properly adjust the seek position for time elapsed.
                        if (self.playing(id[i])) {
                            sound._rateSeek = self.seek(id[i]);
                            sound._playStart = self._webAudio ? Howler1.ctx.currentTime : sound._playStart;
                        }
                        sound._rate = rate;
                        // Change the playback rate.
                        if (self._webAudio && sound._node && sound._node.bufferSource) sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler1.ctx.currentTime);
                        else if (sound._node) sound._node.playbackRate = rate;
                        // Reset the timers.
                        var seek = self.seek(id[i]);
                        var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
                        var timeout = duration * 1000 / Math.abs(sound._rate);
                        // Start a new end timer if sound is already playing.
                        if (self._endTimers[id[i]] || !sound._paused) {
                            self._clearTimer(id[i]);
                            self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
                        }
                        self._emit('rate', sound._id);
                    }
                }
            } else {
                sound = self._soundById(id);
                return sound ? sound._rate : self._rate;
            }
            return self;
        },
        /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */ seek: function() {
            var self = this;
            var args = arguments;
            var seek, id;
            // Determine the values based on arguments.
            if (args.length === 0) // We will simply return the current position of the first node.
            {
                if (self._sounds.length) id = self._sounds[0]._id;
            } else if (args.length === 1) {
                // First check if this is an ID, and if not, assume it is a new seek position.
                var ids = self._getSoundIds();
                var index = ids.indexOf(args[0]);
                if (index >= 0) id = parseInt(args[0], 10);
                else if (self._sounds.length) {
                    id = self._sounds[0]._id;
                    seek = parseFloat(args[0]);
                }
            } else if (args.length === 2) {
                seek = parseFloat(args[0]);
                id = parseInt(args[1], 10);
            }
            // If there is no ID, bail out.
            if (typeof id === 'undefined') return 0;
            // If the sound hasn't loaded, add it to the load queue to seek when capable.
            if (typeof seek === 'number' && (self._state !== 'loaded' || self._playLock)) {
                self._queue.push({
                    event: 'seek',
                    action: function() {
                        self.seek.apply(self, args);
                    }
                });
                return self;
            }
            // Get the sound.
            var sound = self._soundById(id);
            if (sound) {
                if (typeof seek === 'number' && seek >= 0) {
                    // Pause the sound and update position for restarting playback.
                    var playing = self.playing(id);
                    if (playing) self.pause(id, true);
                    // Move the position of the track and cancel timer.
                    sound._seek = seek;
                    sound._ended = false;
                    self._clearTimer(id);
                    // Update the seek position for HTML5 Audio.
                    if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) sound._node.currentTime = seek;
                    // Seek and emit when ready.
                    var seekAndEmit = function() {
                        // Restart the playback if the sound was playing.
                        if (playing) self.play(id, true);
                        self._emit('seek', id);
                    };
                    // Wait for the play lock to be unset before emitting (HTML5 Audio).
                    if (playing && !self._webAudio) {
                        var emitSeek = function() {
                            if (!self._playLock) seekAndEmit();
                            else setTimeout(emitSeek, 0);
                        };
                        setTimeout(emitSeek, 0);
                    } else seekAndEmit();
                } else {
                    if (self._webAudio) {
                        var realTime = self.playing(id) ? Howler1.ctx.currentTime - sound._playStart : 0;
                        var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
                        return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
                    } else return sound._node.currentTime;
                }
            }
            return self;
        },
        /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */ playing: function(id) {
            var self = this;
            // Check the passed sound ID (if any).
            if (typeof id === 'number') {
                var sound = self._soundById(id);
                return sound ? !sound._paused : false;
            }
            // Otherwise, loop through all sounds and check if any are playing.
            for(var i = 0; i < self._sounds.length; i++){
                if (!self._sounds[i]._paused) return true;
            }
            return false;
        },
        /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */ duration: function(id) {
            var self = this;
            var duration = self._duration;
            // If we pass an ID, get the sound and return the sprite length.
            var sound = self._soundById(id);
            if (sound) duration = self._sprite[sound._sprite][1] / 1000;
            return duration;
        },
        /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */ state: function() {
            return this._state;
        },
        /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */ unload: function() {
            var self = this;
            // Stop playing any active sounds.
            var sounds = self._sounds;
            for(var i = 0; i < sounds.length; i++){
                // Stop the sound if it is currently playing.
                if (!sounds[i]._paused) self.stop(sounds[i]._id);
                // Remove the source or disconnect.
                if (!self._webAudio) {
                    // Set the source to 0-second silence to stop any downloading (except in IE).
                    self._clearSound(sounds[i]._node);
                    // Remove any event listeners.
                    sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
                    sounds[i]._node.removeEventListener(Howler1._canPlayEvent, sounds[i]._loadFn, false);
                    sounds[i]._node.removeEventListener('ended', sounds[i]._endFn, false);
                    // Release the Audio object back to the pool.
                    Howler1._releaseHtml5Audio(sounds[i]._node);
                }
                // Empty out all of the nodes.
                delete sounds[i]._node;
                // Make sure all timers are cleared out.
                self._clearTimer(sounds[i]._id);
            }
            // Remove the references in the global Howler object.
            var index = Howler1._howls.indexOf(self);
            if (index >= 0) Howler1._howls.splice(index, 1);
            // Delete this sound from the cache (if no other Howl is using it).
            var remCache = true;
            for(i = 0; i < Howler1._howls.length; i++)if (Howler1._howls[i]._src === self._src || self._src.indexOf(Howler1._howls[i]._src) >= 0) {
                remCache = false;
                break;
            }
            if (cache && remCache) delete cache[self._src];
            // Clear global errors.
            Howler1.noAudio = false;
            // Clear out `self`.
            self._state = 'unloaded';
            self._sounds = [];
            self = null;
            return null;
        },
        /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */ on: function(event, fn, id, once) {
            var self = this;
            var events = self['_on' + event];
            if (typeof fn === 'function') events.push(once ? {
                id: id,
                fn: fn,
                once: once
            } : {
                id: id,
                fn: fn
            });
            return self;
        },
        /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */ off: function(event, fn, id) {
            var self = this;
            var events = self['_on' + event];
            var i = 0;
            // Allow passing just an event and ID.
            if (typeof fn === 'number') {
                id = fn;
                fn = null;
            }
            if (fn || id) // Loop through event store and remove the passed function.
            for(i = 0; i < events.length; i++){
                var isId = id === events[i].id;
                if (fn === events[i].fn && isId || !fn && isId) {
                    events.splice(i, 1);
                    break;
                }
            }
            else if (event) // Clear out all events of this type.
            self['_on' + event] = [];
            else {
                // Clear out all events of every type.
                var keys = Object.keys(self);
                for(i = 0; i < keys.length; i++)if (keys[i].indexOf('_on') === 0 && Array.isArray(self[keys[i]])) self[keys[i]] = [];
            }
            return self;
        },
        /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */ once: function(event, fn, id) {
            var self = this;
            // Setup the event listener.
            self.on(event, fn, id, 1);
            return self;
        },
        /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */ _emit: function(event, id, msg) {
            var self = this;
            var events = self['_on' + event];
            // Loop through event store and fire all functions.
            for(var i = events.length - 1; i >= 0; i--)// Only fire the listener if the correct ID is used.
            if (!events[i].id || events[i].id === id || event === 'load') {
                setTimeout((function(fn) {
                    fn.call(this, id, msg);
                }).bind(self, events[i].fn), 0);
                // If this event was setup with `once`, remove it.
                if (events[i].once) self.off(event, events[i].fn, events[i].id);
            }
            // Pass the event type into load queue so that it can continue stepping.
            self._loadQueue(event);
            return self;
        },
        /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */ _loadQueue: function(event) {
            var self = this;
            if (self._queue.length > 0) {
                var task = self._queue[0];
                // Remove this task if a matching event was passed.
                if (task.event === event) {
                    self._queue.shift();
                    self._loadQueue();
                }
                // Run the task if no event type is passed.
                if (!event) task.action();
            }
            return self;
        },
        /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _ended: function(sound) {
            var self = this;
            var sprite = sound._sprite;
            // If we are using IE and there was network latency we may be clipping
            // audio before it completes playing. Lets check the node to make sure it
            // believes it has completed, before ending the playback.
            if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
                setTimeout(self._ended.bind(self, sound), 100);
                return self;
            }
            // Should this sound loop?
            var loop = !!(sound._loop || self._sprite[sprite][2]);
            // Fire the ended event.
            self._emit('end', sound._id);
            // Restart the playback for HTML5 Audio loop.
            if (!self._webAudio && loop) self.stop(sound._id, true).play(sound._id);
            // Restart this timer if on a Web Audio loop.
            if (self._webAudio && loop) {
                self._emit('play', sound._id);
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                sound._playStart = Howler1.ctx.currentTime;
                var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
                self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            // Mark the node as paused.
            if (self._webAudio && !loop) {
                sound._paused = true;
                sound._ended = true;
                sound._seek = sound._start || 0;
                sound._rateSeek = 0;
                self._clearTimer(sound._id);
                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
                // Attempt to auto-suspend AudioContext if no sounds are still playing.
                Howler1._autoSuspend();
            }
            // When using a sprite, end the track.
            if (!self._webAudio && !loop) self.stop(sound._id, true);
            return self;
        },
        /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */ _clearTimer: function(id) {
            var self = this;
            if (self._endTimers[id]) {
                // Clear the timeout or remove the ended listener.
                if (typeof self._endTimers[id] !== 'function') clearTimeout(self._endTimers[id]);
                else {
                    var sound = self._soundById(id);
                    if (sound && sound._node) sound._node.removeEventListener('ended', self._endTimers[id], false);
                }
                delete self._endTimers[id];
            }
            return self;
        },
        /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */ _soundById: function(id) {
            var self = this;
            // Loop through all sounds and find the one with this ID.
            for(var i = 0; i < self._sounds.length; i++){
                if (id === self._sounds[i]._id) return self._sounds[i];
            }
            return null;
        },
        /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */ _inactiveSound: function() {
            var self = this;
            self._drain();
            // Find the first inactive node to recycle.
            for(var i = 0; i < self._sounds.length; i++){
                if (self._sounds[i]._ended) return self._sounds[i].reset();
            }
            // If no inactive node was found, create a new one.
            return new Sound1(self);
        },
        /**
     * Drain excess inactive sounds from the pool.
     */ _drain: function() {
            var self = this;
            var limit = self._pool;
            var cnt = 0;
            var i = 0;
            // If there are less sounds than the max pool size, we are done.
            if (self._sounds.length < limit) return;
            // Count the number of inactive sounds.
            for(i = 0; i < self._sounds.length; i++)if (self._sounds[i]._ended) cnt++;
            // Remove excess inactive sounds, going in reverse order.
            for(i = self._sounds.length - 1; i >= 0; i--){
                if (cnt <= limit) return;
                if (self._sounds[i]._ended) {
                    // Disconnect the audio source when using Web Audio.
                    if (self._webAudio && self._sounds[i]._node) self._sounds[i]._node.disconnect(0);
                    // Remove sounds until we have the pool size.
                    self._sounds.splice(i, 1);
                    cnt--;
                }
            }
        },
        /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */ _getSoundIds: function(id) {
            var self = this;
            if (typeof id === 'undefined') {
                var ids = [];
                for(var i = 0; i < self._sounds.length; i++)ids.push(self._sounds[i]._id);
                return ids;
            } else return [
                id
            ];
        },
        /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */ _refreshBuffer: function(sound) {
            var self = this;
            // Setup the buffer source for playback.
            sound._node.bufferSource = Howler1.ctx.createBufferSource();
            sound._node.bufferSource.buffer = cache[self._src];
            // Connect to the correct node.
            if (sound._panner) sound._node.bufferSource.connect(sound._panner);
            else sound._node.bufferSource.connect(sound._node);
            // Setup looping and playback rate.
            sound._node.bufferSource.loop = sound._loop;
            if (sound._loop) {
                sound._node.bufferSource.loopStart = sound._start || 0;
                sound._node.bufferSource.loopEnd = sound._stop || 0;
            }
            sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler1.ctx.currentTime);
            return self;
        },
        /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */ _cleanBuffer: function(node) {
            var self = this;
            var isIOS = Howler1._navigator && Howler1._navigator.vendor.indexOf('Apple') >= 0;
            if (!node.bufferSource) return self;
            if (Howler1._scratchBuffer && node.bufferSource) {
                node.bufferSource.onended = null;
                node.bufferSource.disconnect(0);
                if (isIOS) try {
                    node.bufferSource.buffer = Howler1._scratchBuffer;
                } catch (e) {}
            }
            node.bufferSource = null;
            return self;
        },
        /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */ _clearSound: function(node) {
            var checkIE = /MSIE |Trident\//.test(Howler1._navigator && Howler1._navigator.userAgent);
            if (!checkIE) node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
        }
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */ var Sound1 = function(howl) {
        this._parent = howl;
        this.init();
    };
    Sound1.prototype = {
        /**
     * Initialize a new Sound object.
     * @return {Sound}
     */ init: function() {
            var self = this;
            var parent = self._parent;
            // Setup the default parameters.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = '__default';
            // Generate a unique ID for this sound.
            self._id = ++Howler1._counter;
            // Add itself to the parent's pool.
            parent._sounds.push(self);
            // Create the new node.
            self.create();
            return self;
        },
        /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */ create: function() {
            var self = this;
            var parent = self._parent;
            var volume = Howler1._muted || self._muted || self._parent._muted ? 0 : self._volume;
            if (parent._webAudio) {
                // Create the gain node for controlling volume (the source will connect to this).
                self._node = typeof Howler1.ctx.createGain === 'undefined' ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
                self._node.gain.setValueAtTime(volume, Howler1.ctx.currentTime);
                self._node.paused = true;
                self._node.connect(Howler1.masterGain);
            } else if (!Howler1.noAudio) {
                // Get an unlocked Audio object from the pool.
                self._node = Howler1._obtainHtml5Audio();
                // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
                self._errorFn = self._errorListener.bind(self);
                self._node.addEventListener('error', self._errorFn, false);
                // Listen for 'canplaythrough' event to let us know the sound is ready.
                self._loadFn = self._loadListener.bind(self);
                self._node.addEventListener(Howler1._canPlayEvent, self._loadFn, false);
                // Listen for the 'ended' event on the sound to account for edge-case where
                // a finite sound has a duration of Infinity.
                self._endFn = self._endListener.bind(self);
                self._node.addEventListener('ended', self._endFn, false);
                // Setup the new audio node.
                self._node.src = parent._src;
                self._node.preload = parent._preload === true ? 'auto' : parent._preload;
                self._node.volume = volume * Howler1.volume();
                // Begin loading the source.
                self._node.load();
            }
            return self;
        },
        /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */ reset: function() {
            var self = this;
            var parent = self._parent;
            // Reset all of the parameters of this sound.
            self._muted = parent._muted;
            self._loop = parent._loop;
            self._volume = parent._volume;
            self._rate = parent._rate;
            self._seek = 0;
            self._rateSeek = 0;
            self._paused = true;
            self._ended = true;
            self._sprite = '__default';
            // Generate a new ID so that it isn't confused with the previous sound.
            self._id = ++Howler1._counter;
            return self;
        },
        /**
     * HTML5 Audio error listener callback.
     */ _errorListener: function() {
            var self = this;
            // Fire an error event and pass back the code.
            self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);
            // Clear the event listener.
            self._node.removeEventListener('error', self._errorFn, false);
        },
        /**
     * HTML5 Audio canplaythrough listener callback.
     */ _loadListener: function() {
            var self = this;
            var parent = self._parent;
            // Round up the duration to account for the lower precision in HTML5 Audio.
            parent._duration = Math.ceil(self._node.duration * 10) / 10;
            // Setup a sprite if none is defined.
            if (Object.keys(parent._sprite).length === 0) parent._sprite = {
                __default: [
                    0,
                    parent._duration * 1000
                ]
            };
            if (parent._state !== 'loaded') {
                parent._state = 'loaded';
                parent._emit('load');
                parent._loadQueue();
            }
            // Clear the event listener.
            self._node.removeEventListener(Howler1._canPlayEvent, self._loadFn, false);
        },
        /**
     * HTML5 Audio ended listener callback.
     */ _endListener: function() {
            var self = this;
            var parent = self._parent;
            // Only handle the `ended`` event if the duration is Infinity.
            if (parent._duration === Infinity) {
                // Update the parent duration to match the real audio duration.
                // Round up the duration to account for the lower precision in HTML5 Audio.
                parent._duration = Math.ceil(self._node.duration * 10) / 10;
                // Update the sprite that corresponds to the real duration.
                if (parent._sprite.__default[1] === Infinity) parent._sprite.__default[1] = parent._duration * 1000;
                // Run the regular ended method.
                parent._ended(self);
            }
            // Clear the event listener since the duration is now correct.
            self._node.removeEventListener('ended', self._endFn, false);
        }
    };
    /** Helper Methods **/ /***************************************************************************/ var cache = {};
    /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */ var loadBuffer = function(self) {
        var url = self._src;
        // Check if the buffer has already been cached and use it instead.
        if (cache[url]) {
            // Set the duration from the cache.
            self._duration = cache[url].duration;
            // Load the sound into this Howl.
            loadSound(self);
            return;
        }
        if (/^data:[^;]+;base64,/.test(url)) {
            // Decode the base64 data URI without XHR, since some browsers don't support it.
            var data = atob(url.split(',')[1]);
            var dataView = new Uint8Array(data.length);
            for(var i = 0; i < data.length; ++i)dataView[i] = data.charCodeAt(i);
            decodeAudioData(dataView.buffer, self);
        } else {
            // Load the buffer from the URL.
            var xhr = new XMLHttpRequest();
            xhr.open(self._xhr.method, url, true);
            xhr.withCredentials = self._xhr.withCredentials;
            xhr.responseType = 'arraybuffer';
            // Apply any custom headers to the request.
            if (self._xhr.headers) Object.keys(self._xhr.headers).forEach(function(key) {
                xhr.setRequestHeader(key, self._xhr.headers[key]);
            });
            xhr.onload = function() {
                // Make sure we get a successful response back.
                var code = (xhr.status + '')[0];
                if (code !== '0' && code !== '2' && code !== '3') {
                    self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
                    return;
                }
                decodeAudioData(xhr.response, self);
            };
            xhr.onerror = function() {
                // If there is an error, switch to HTML5 Audio.
                if (self._webAudio) {
                    self._html5 = true;
                    self._webAudio = false;
                    self._sounds = [];
                    delete cache[url];
                    self.load();
                }
            };
            safeXhrSend(xhr);
        }
    };
    /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */ var safeXhrSend = function(xhr) {
        try {
            xhr.send();
        } catch (e) {
            xhr.onerror();
        }
    };
    /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */ var decodeAudioData = function(arraybuffer, self) {
        // Fire a load error if something broke.
        var error = function() {
            self._emit('loaderror', null, 'Decoding audio data failed.');
        };
        // Load the sound on success.
        var success = function(buffer) {
            if (buffer && self._sounds.length > 0) {
                cache[self._src] = buffer;
                loadSound(self, buffer);
            } else error();
        };
        // Decode the buffer into an audio source.
        if (typeof Promise !== 'undefined' && Howler1.ctx.decodeAudioData.length === 1) Howler1.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
        else Howler1.ctx.decodeAudioData(arraybuffer, success, error);
    };
    /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */ var loadSound = function(self, buffer) {
        // Set the duration.
        if (buffer && !self._duration) self._duration = buffer.duration;
        // Setup a sprite if none is defined.
        if (Object.keys(self._sprite).length === 0) self._sprite = {
            __default: [
                0,
                self._duration * 1000
            ]
        };
        // Fire the loaded event.
        if (self._state !== 'loaded') {
            self._state = 'loaded';
            self._emit('load');
            self._loadQueue();
        }
    };
    /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */ var setupAudioContext = function() {
        // If we have already detected that Web Audio isn't supported, don't run this step again.
        if (!Howler1.usingWebAudio) return;
        // Check if we are using Web Audio and setup the AudioContext if we are.
        try {
            if (typeof AudioContext !== 'undefined') Howler1.ctx = new AudioContext();
            else if (typeof webkitAudioContext !== 'undefined') Howler1.ctx = new webkitAudioContext();
            else Howler1.usingWebAudio = false;
        } catch (e) {
            Howler1.usingWebAudio = false;
        }
        // If the audio context creation still failed, set using web audio to false.
        if (!Howler1.ctx) Howler1.usingWebAudio = false;
        // Check if a webview is being used on iOS8 or earlier (rather than the browser).
        // If it is, disable Web Audio as it causes crashing.
        var iOS = /iP(hone|od|ad)/.test(Howler1._navigator && Howler1._navigator.platform);
        var appVersion = Howler1._navigator && Howler1._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = appVersion ? parseInt(appVersion[1], 10) : null;
        if (iOS && version && version < 9) {
            var safari = /safari/.test(Howler1._navigator && Howler1._navigator.userAgent.toLowerCase());
            if (Howler1._navigator && !safari) Howler1.usingWebAudio = false;
        }
        // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
        if (Howler1.usingWebAudio) {
            Howler1.masterGain = typeof Howler1.ctx.createGain === 'undefined' ? Howler1.ctx.createGainNode() : Howler1.ctx.createGain();
            Howler1.masterGain.gain.setValueAtTime(Howler1._muted ? 0 : Howler1._volume, Howler1.ctx.currentTime);
            Howler1.masterGain.connect(Howler1.ctx.destination);
        }
        // Re-run the setup on Howler.
        Howler1._setup();
    };
    // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
    if (typeof define === 'function' && define.amd) define([], function() {
        return {
            Howler: Howler1,
            Howl: Howl1
        };
    });
    $f89d8ffbdc18f2ab$export$c9d39ca3bcd93abb = Howler1;
    $f89d8ffbdc18f2ab$export$b791fe48eec8032a = Howl1;
    // Add to global in Node.js (for testing, etc).
    if (typeof $parcel$global !== 'undefined') {
        $parcel$global.HowlerGlobal = HowlerGlobal1;
        $parcel$global.Howler = Howler1;
        $parcel$global.Howl = Howl1;
        $parcel$global.Sound = Sound1;
    } else if (typeof window !== 'undefined') {
        window.HowlerGlobal = HowlerGlobal1;
        window.Howler = Howler1;
        window.Howl = Howl1;
        window.Sound = Sound1;
    }
})();
/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */ (function() {
    'use strict';
    // Setup default properties.
    HowlerGlobal.prototype._pos = [
        0,
        0,
        0
    ];
    HowlerGlobal.prototype._orientation = [
        0,
        0,
        -1,
        0,
        1,
        0
    ];
    /** Global Methods **/ /***************************************************************************/ /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */ HowlerGlobal.prototype.stereo = function(pan) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Loop through all Howls and update their stereo panning.
        for(var i = self._howls.length - 1; i >= 0; i--)self._howls[i].stereo(pan);
        return self;
    };
    /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */ HowlerGlobal.prototype.pos = function(x, y, z) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? self._pos[1] : y;
        z = typeof z !== 'number' ? self._pos[2] : z;
        if (typeof x === 'number') {
            self._pos = [
                x,
                y,
                z
            ];
            if (typeof self.ctx.listener.positionX !== 'undefined') {
                self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
                self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
        } else return self._pos;
        return self;
    };
    /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */ HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self.ctx || !self.ctx.listener) return self;
        // Set the defaults for optional 'y' & 'z'.
        var or = self._orientation;
        y = typeof y !== 'number' ? or[1] : y;
        z = typeof z !== 'number' ? or[2] : z;
        xUp = typeof xUp !== 'number' ? or[3] : xUp;
        yUp = typeof yUp !== 'number' ? or[4] : yUp;
        zUp = typeof zUp !== 'number' ? or[5] : zUp;
        if (typeof x === 'number') {
            self._orientation = [
                x,
                y,
                z,
                xUp,
                yUp,
                zUp
            ];
            if (typeof self.ctx.listener.forwardX !== 'undefined') {
                self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
                self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
            } else self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
        } else return or;
        return self;
    };
    /** Group Methods **/ /***************************************************************************/ /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */ Howl.prototype.init = function(_super) {
        return function(o) {
            var self = this;
            // Setup user-defined default properties.
            self._orientation = o.orientation || [
                1,
                0,
                0
            ];
            self._stereo = o.stereo || null;
            self._pos = o.pos || null;
            self._pannerAttr = {
                coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
                coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
                coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
                distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
                maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
                panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
                refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
                rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
            };
            // Setup event listeners.
            self._onstereo = o.onstereo ? [
                {
                    fn: o.onstereo
                }
            ] : [];
            self._onpos = o.onpos ? [
                {
                    fn: o.onpos
                }
            ] : [];
            self._onorientation = o.onorientation ? [
                {
                    fn: o.onorientation
                }
            ] : [];
            // Complete initilization with howler.js core's init function.
            return _super.call(this, o);
        };
    }(Howl.prototype.init);
    /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */ Howl.prototype.stereo = function(pan, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'stereo',
                action: function() {
                    self.stereo(pan, id);
                }
            });
            return self;
        }
        // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
        var pannerType = typeof Howler.ctx.createStereoPanner === 'undefined' ? 'spatial' : 'stereo';
        // Setup the group's stereo panning if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's stereo panning if no parameters are passed.
            if (typeof pan === 'number') {
                self._stereo = pan;
                self._pos = [
                    pan,
                    0,
                    0
                ];
            } else return self._stereo;
        }
        // Change the streo panning of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof pan === 'number') {
                    sound._stereo = pan;
                    sound._pos = [
                        pan,
                        0,
                        0
                    ];
                    if (sound._node) {
                        // If we are falling back, make sure the panningModel is equalpower.
                        sound._pannerAttr.panningModel = 'equalpower';
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || !sound._panner.pan) setupPanner(sound, pannerType);
                        if (pannerType === 'spatial') {
                            if (typeof sound._panner.positionX !== 'undefined') {
                                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
                            } else sound._panner.setPosition(pan, 0, 0);
                        } else sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
                    }
                    self._emit('stereo', sound._id);
                } else return sound._stereo;
            }
        }
        return self;
    };
    /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */ Howl.prototype.pos = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change position when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'pos',
                action: function() {
                    self.pos(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? 0 : y;
        z = typeof z !== 'number' ? -0.5 : z;
        // Setup the group's spatial position if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's spatial position if no parameters are passed.
            if (typeof x === 'number') self._pos = [
                x,
                y,
                z
            ];
            else return self._pos;
        }
        // Change the spatial position of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === 'number') {
                    sound._pos = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner || sound._panner.pan) setupPanner(sound, 'spatial');
                        if (typeof sound._panner.positionX !== 'undefined') {
                            sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setPosition(x, y, z);
                    }
                    self._emit('pos', sound._id);
                } else return sound._pos;
            }
        }
        return self;
    };
    /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */ Howl.prototype.orientation = function(x, y, z, id) {
        var self = this;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
        if (self._state !== 'loaded') {
            self._queue.push({
                event: 'orientation',
                action: function() {
                    self.orientation(x, y, z, id);
                }
            });
            return self;
        }
        // Set the defaults for optional 'y' & 'z'.
        y = typeof y !== 'number' ? self._orientation[1] : y;
        z = typeof z !== 'number' ? self._orientation[2] : z;
        // Setup the group's spatial orientation if no ID is passed.
        if (typeof id === 'undefined') {
            // Return the group's spatial orientation if no parameters are passed.
            if (typeof x === 'number') self._orientation = [
                x,
                y,
                z
            ];
            else return self._orientation;
        }
        // Change the spatial orientation of one or all sounds in group.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            // Get the sound.
            var sound = self._soundById(ids[i]);
            if (sound) {
                if (typeof x === 'number') {
                    sound._orientation = [
                        x,
                        y,
                        z
                    ];
                    if (sound._node) {
                        // Check if there is a panner setup and create a new one if not.
                        if (!sound._panner) {
                            // Make sure we have a position to setup the node with.
                            if (!sound._pos) sound._pos = self._pos || [
                                0,
                                0,
                                -0.5
                            ];
                            setupPanner(sound, 'spatial');
                        }
                        if (typeof sound._panner.orientationX !== 'undefined') {
                            sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
                            sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
                            sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
                        } else sound._panner.setOrientation(x, y, z);
                    }
                    self._emit('orientation', sound._id);
                } else return sound._orientation;
            }
        }
        return self;
    };
    /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */ Howl.prototype.pannerAttr = function() {
        var self = this;
        var args = arguments;
        var o, id, sound;
        // Stop right here if not using Web Audio.
        if (!self._webAudio) return self;
        // Determine the values based on arguments.
        if (args.length === 0) // Return the group's panner attribute values.
        return self._pannerAttr;
        else if (args.length === 1) {
            if (typeof args[0] === 'object') {
                o = args[0];
                // Set the grou's panner attribute values.
                if (typeof id === 'undefined') {
                    if (!o.pannerAttr) o.pannerAttr = {
                        coneInnerAngle: o.coneInnerAngle,
                        coneOuterAngle: o.coneOuterAngle,
                        coneOuterGain: o.coneOuterGain,
                        distanceModel: o.distanceModel,
                        maxDistance: o.maxDistance,
                        refDistance: o.refDistance,
                        rolloffFactor: o.rolloffFactor,
                        panningModel: o.panningModel
                    };
                    self._pannerAttr = {
                        coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
                        coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
                        coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
                        distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
                        maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
                        refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
                        rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
                        panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
                    };
                }
            } else {
                // Return this sound's panner attribute values.
                sound = self._soundById(parseInt(args[0], 10));
                return sound ? sound._pannerAttr : self._pannerAttr;
            }
        } else if (args.length === 2) {
            o = args[0];
            id = parseInt(args[1], 10);
        }
        // Update the values of the specified sounds.
        var ids = self._getSoundIds(id);
        for(var i = 0; i < ids.length; i++){
            sound = self._soundById(ids[i]);
            if (sound) {
                // Merge the new values into the sound.
                var pa = sound._pannerAttr;
                pa = {
                    coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
                    coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
                    coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
                    distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
                    maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
                    refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
                    rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
                    panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
                };
                // Create a new panner node if one doesn't already exist.
                var panner = sound._panner;
                if (!panner) {
                    // Make sure we have a position to setup the node with.
                    if (!sound._pos) sound._pos = self._pos || [
                        0,
                        0,
                        -0.5
                    ];
                    // Create a new panner node.
                    setupPanner(sound, 'spatial');
                    panner = sound._panner;
                }
                // Update the panner values or create a new panner if none exists.
                panner.coneInnerAngle = pa.coneInnerAngle;
                panner.coneOuterAngle = pa.coneOuterAngle;
                panner.coneOuterGain = pa.coneOuterGain;
                panner.distanceModel = pa.distanceModel;
                panner.maxDistance = pa.maxDistance;
                panner.refDistance = pa.refDistance;
                panner.rolloffFactor = pa.rolloffFactor;
                panner.panningModel = pa.panningModel;
            }
        }
        return self;
    };
    /** Single Sound Methods **/ /***************************************************************************/ /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */ Sound.prototype.init = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Setup user-defined default properties.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // Complete initilization with howler.js core Sound's init function.
            _super.call(this);
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
        };
    }(Sound.prototype.init);
    /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */ Sound.prototype.reset = function(_super) {
        return function() {
            var self = this;
            var parent = self._parent;
            // Reset all spatial plugin properties on this sound.
            self._orientation = parent._orientation;
            self._stereo = parent._stereo;
            self._pos = parent._pos;
            self._pannerAttr = parent._pannerAttr;
            // If a stereo or position was specified, set it up.
            if (self._stereo) parent.stereo(self._stereo);
            else if (self._pos) parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
            else if (self._panner) {
                // Disconnect the panner.
                self._panner.disconnect(0);
                self._panner = undefined;
                parent._refreshBuffer(self);
            }
            // Complete resetting of the sound.
            return _super.call(this);
        };
    }(Sound.prototype.reset);
    /** Helper Methods **/ /***************************************************************************/ /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */ var setupPanner = function(sound, type) {
        type = type || 'spatial';
        // Create the new panner node.
        if (type === 'spatial') {
            sound._panner = Howler.ctx.createPanner();
            sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
            sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
            sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
            sound._panner.distanceModel = sound._pannerAttr.distanceModel;
            sound._panner.maxDistance = sound._pannerAttr.maxDistance;
            sound._panner.refDistance = sound._pannerAttr.refDistance;
            sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
            sound._panner.panningModel = sound._pannerAttr.panningModel;
            if (typeof sound._panner.positionX !== 'undefined') {
                sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
            } else sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
            if (typeof sound._panner.orientationX !== 'undefined') {
                sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
                sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
                sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
            } else sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
        } else {
            sound._panner = Howler.ctx.createStereoPanner();
            sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
        }
        sound._panner.connect(sound._node);
        // Update the connections.
        if (!sound._paused) sound._parent.pause(sound._id, true).play(sound._id, true);
    };
})();


var $049c1069fcbd3f88$exports = {};
"use strict";
/**
 * Bit twiddling hacks for JavaScript.
 *
 * Author: Mikola Lysenko
 *
 * Ported from Stanford bit twiddling hack library:
 *    http://graphics.stanford.edu/~seander/bithacks.html
 */ //Constants
var $aaceb971cbaa76bf$export$419a26f2aa9da396;
var $aaceb971cbaa76bf$export$4f4b393a94aa2457;
var $aaceb971cbaa76bf$export$8bb31f9592676215;
//Returns -1, 0, +1 depending on sign of x
var $aaceb971cbaa76bf$export$c5552dfdbc7cec71;
//Computes absolute value of integer
var $aaceb971cbaa76bf$export$2335f513bbd82c6d;
//Computes minimum of integers x and y
var $aaceb971cbaa76bf$export$96ec731ed4dcb222;
//Computes maximum of integers x and y
var $aaceb971cbaa76bf$export$8960430cfd85939f;
//Checks if a number is a power of two
var $aaceb971cbaa76bf$export$eb50b9c078eb6ae7;
//Computes log base 2 of v
var $aaceb971cbaa76bf$export$b9fae0bba9d9094d;
//Computes log base 10 of v
var $aaceb971cbaa76bf$export$75e08744a3ff8516;
//Counts number of bits
var $aaceb971cbaa76bf$export$e504fb5dd3f0574f;
var $aaceb971cbaa76bf$export$89a884564c32f7f7;
//Rounds to next power of 2
var $aaceb971cbaa76bf$export$f0d90cf68bd426eb;
//Rounds down to previous power of 2
var $aaceb971cbaa76bf$export$9d423d818f6c4e8;
//Computes parity of word
var $aaceb971cbaa76bf$export$efe353078db02e10;
//Reverse bits in a 32 bit word
var $aaceb971cbaa76bf$export$66c1ae025e96b4bc;
//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
var $aaceb971cbaa76bf$export$4ba3408bd18f4427;
//Extracts the nth interleaved component
var $aaceb971cbaa76bf$export$7672fa14d84398bf;
//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
var $aaceb971cbaa76bf$export$2e5403465fcfe316;
//Extracts nth interleaved component of a 3-tuple
var $aaceb971cbaa76bf$export$bf2ef72ecb045638;
//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
var $aaceb971cbaa76bf$export$9f555377a7192b69;
"use strict";
"use restrict";
//Number of bits in an integer
var $aaceb971cbaa76bf$var$INT_BITS = 32;
$aaceb971cbaa76bf$export$419a26f2aa9da396 = $aaceb971cbaa76bf$var$INT_BITS;
$aaceb971cbaa76bf$export$4f4b393a94aa2457 = 0x7fffffff;
$aaceb971cbaa76bf$export$8bb31f9592676215 = -1 << $aaceb971cbaa76bf$var$INT_BITS - 1;
$aaceb971cbaa76bf$export$c5552dfdbc7cec71 = function(v) {
    return (v > 0) - (v < 0);
};
$aaceb971cbaa76bf$export$2335f513bbd82c6d = function(v) {
    var mask = v >> $aaceb971cbaa76bf$var$INT_BITS - 1;
    return (v ^ mask) - mask;
};
$aaceb971cbaa76bf$export$96ec731ed4dcb222 = function(x, y) {
    return y ^ (x ^ y) & -(x < y);
};
$aaceb971cbaa76bf$export$8960430cfd85939f = function(x, y) {
    return x ^ (x ^ y) & -(x < y);
};
$aaceb971cbaa76bf$export$eb50b9c078eb6ae7 = function(v) {
    return !(v & v - 1) && !!v;
};
$aaceb971cbaa76bf$export$b9fae0bba9d9094d = function(v) {
    var r, shift;
    r = (v > 0xFFFF) << 4;
    v >>>= r;
    shift = (v > 0xFF) << 3;
    v >>>= shift;
    r |= shift;
    shift = (v > 0xF) << 2;
    v >>>= shift;
    r |= shift;
    shift = (v > 0x3) << 1;
    v >>>= shift;
    r |= shift;
    return r | v >> 1;
};
$aaceb971cbaa76bf$export$75e08744a3ff8516 = function(v) {
    return v >= 1000000000 ? 9 : v >= 100000000 ? 8 : v >= 10000000 ? 7 : v >= 1000000 ? 6 : v >= 100000 ? 5 : v >= 10000 ? 4 : v >= 1000 ? 3 : v >= 100 ? 2 : v >= 10 ? 1 : 0;
};
$aaceb971cbaa76bf$export$e504fb5dd3f0574f = function(v) {
    v = v - (v >>> 1 & 0x55555555);
    v = (v & 0x33333333) + (v >>> 2 & 0x33333333);
    return (v + (v >>> 4) & 0xF0F0F0F) * 0x1010101 >>> 24;
};
//Counts number of trailing zeros
function $aaceb971cbaa76bf$var$countTrailingZeros(v) {
    var c = 32;
    v &= -v;
    if (v) c--;
    if (v & 0x0000FFFF) c -= 16;
    if (v & 0x00FF00FF) c -= 8;
    if (v & 0x0F0F0F0F) c -= 4;
    if (v & 0x33333333) c -= 2;
    if (v & 0x55555555) c -= 1;
    return c;
}
$aaceb971cbaa76bf$export$89a884564c32f7f7 = $aaceb971cbaa76bf$var$countTrailingZeros;
$aaceb971cbaa76bf$export$f0d90cf68bd426eb = function(v) {
    v += v === 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
};
$aaceb971cbaa76bf$export$9d423d818f6c4e8 = function(v) {
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v - (v >>> 1);
};
$aaceb971cbaa76bf$export$efe353078db02e10 = function(v) {
    v ^= v >>> 16;
    v ^= v >>> 8;
    v ^= v >>> 4;
    v &= 0xf;
    return 0x6996 >>> v & 1;
};
var $aaceb971cbaa76bf$var$REVERSE_TABLE = new Array(256);
(function(tab) {
    for(var i = 0; i < 256; ++i){
        var v = i, r = i, s = 7;
        for(v >>>= 1; v; v >>>= 1){
            r <<= 1;
            r |= v & 1;
            --s;
        }
        tab[i] = r << s & 0xff;
    }
})($aaceb971cbaa76bf$var$REVERSE_TABLE);
$aaceb971cbaa76bf$export$66c1ae025e96b4bc = function(v) {
    return $aaceb971cbaa76bf$var$REVERSE_TABLE[v & 0xff] << 24 | $aaceb971cbaa76bf$var$REVERSE_TABLE[v >>> 8 & 0xff] << 16 | $aaceb971cbaa76bf$var$REVERSE_TABLE[v >>> 16 & 0xff] << 8 | $aaceb971cbaa76bf$var$REVERSE_TABLE[v >>> 24 & 0xff];
};
$aaceb971cbaa76bf$export$4ba3408bd18f4427 = function(x, y) {
    x &= 0xFFFF;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y &= 0xFFFF;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
};
$aaceb971cbaa76bf$export$7672fa14d84398bf = function(v, n) {
    v = v >>> n & 0x55555555;
    v = (v | v >>> 1) & 0x33333333;
    v = (v | v >>> 2) & 0x0F0F0F0F;
    v = (v | v >>> 4) & 0x00FF00FF;
    v = (v | v >>> 16) & 0x000FFFF;
    return v << 16 >> 16;
};
$aaceb971cbaa76bf$export$2e5403465fcfe316 = function(x, y, z) {
    x &= 0x3FF;
    x = (x | x << 16) & 4278190335;
    x = (x | x << 8) & 251719695;
    x = (x | x << 4) & 3272356035;
    x = (x | x << 2) & 1227133513;
    y &= 0x3FF;
    y = (y | y << 16) & 4278190335;
    y = (y | y << 8) & 251719695;
    y = (y | y << 4) & 3272356035;
    y = (y | y << 2) & 1227133513;
    x |= y << 1;
    z &= 0x3FF;
    z = (z | z << 16) & 4278190335;
    z = (z | z << 8) & 251719695;
    z = (z | z << 4) & 3272356035;
    z = (z | z << 2) & 1227133513;
    return x | z << 2;
};
$aaceb971cbaa76bf$export$bf2ef72ecb045638 = function(v, n) {
    v = v >>> n & 1227133513;
    v = (v | v >>> 2) & 3272356035;
    v = (v | v >>> 4) & 251719695;
    v = (v | v >>> 8) & 4278190335;
    v = (v | v >>> 16) & 0x3FF;
    return v << 22 >> 22;
};
$aaceb971cbaa76bf$export$9f555377a7192b69 = function(v) {
    var t = v | v - 1;
    return t + 1 | (~t & -~t) - 1 >>> $aaceb971cbaa76bf$var$countTrailingZeros(v) + 1;
};


var $af06462ea02ec4b1$export$13e2de3c33d99539;
var $af06462ea02ec4b1$export$11fc1c4b04ba842c;
var $af06462ea02ec4b1$export$f5ead431d5bddd13;
var $af06462ea02ec4b1$export$d6ae10446123eda0;
var $af06462ea02ec4b1$export$e0d7dff56fa02f46;
var $af06462ea02ec4b1$export$badf6ea6e46c4075;
var $af06462ea02ec4b1$export$971146dcff607408;
var $af06462ea02ec4b1$export$781125fcc60e6b35;
var $af06462ea02ec4b1$export$faf8b381a7d1f026;
var $af06462ea02ec4b1$export$c26a3648f9f53f6c;
var $af06462ea02ec4b1$export$eb497d924a09cc2c;
var $af06462ea02ec4b1$export$73cdf697b53baa;
var $af06462ea02ec4b1$export$b2756c99e0338993;
var $af06462ea02ec4b1$export$9d0c804f255d59e1;
var $af06462ea02ec4b1$export$a24fefa6ccae86ec;
var $af06462ea02ec4b1$export$6fa553f58a2a31c2;
var $af06462ea02ec4b1$export$87c88a877180cdad;
var $af06462ea02ec4b1$export$4fc11d1e7c095d9c;
var $af06462ea02ec4b1$export$72dbf0325fb0f6aa;
var $af06462ea02ec4b1$export$5a2d51bea84dc88a;
var $af06462ea02ec4b1$export$8e4b75dc6bfe3d87;
var $af06462ea02ec4b1$export$97e0aa7cbfa04c72;
var $af06462ea02ec4b1$export$bf19141f00438a2e;
var $af06462ea02ec4b1$export$9492a022692715cc;
var $af06462ea02ec4b1$export$d0434a350fe26016;
var $af06462ea02ec4b1$export$c0265c4abfd8544d;
var $af06462ea02ec4b1$export$54d221d78667dc5b;
var $af06462ea02ec4b1$export$a917895a033466e4;
var $af06462ea02ec4b1$export$101cb185aa94caed;
var $af06462ea02ec4b1$export$76498f1e097fe8a6;
var $af06462ea02ec4b1$export$d2adf65b87e47523;

var $6ZWSX = parcelRequire("6ZWSX");
var $af06462ea02ec4b1$require$Buffer = $6ZWSX.Buffer;
'use strict';

var $76676385c1a0c3ff$exports = {};
"use strict";
function $76676385c1a0c3ff$var$dupe_array(count, value, i) {
    var c = count[i] | 0;
    if (c <= 0) return [];
    var result = new Array(c), j;
    if (i === count.length - 1) for(j = 0; j < c; ++j)result[j] = value;
    else for(j = 0; j < c; ++j)result[j] = $76676385c1a0c3ff$var$dupe_array(count, value, i + 1);
    return result;
}
function $76676385c1a0c3ff$var$dupe_number(count, value) {
    var result, i;
    result = new Array(count);
    for(i = 0; i < count; ++i)result[i] = value;
    return result;
}
function $76676385c1a0c3ff$var$dupe(count, value) {
    if (typeof value === "undefined") value = 0;
    switch(typeof count){
        case "number":
            if (count > 0) return $76676385c1a0c3ff$var$dupe_number(count | 0, value);
            break;
        case "object":
            if (typeof count.length === "number") return $76676385c1a0c3ff$var$dupe_array(count, value, 0);
            break;
    }
    return [];
}
$76676385c1a0c3ff$exports = $76676385c1a0c3ff$var$dupe;


//Legacy pool support
if (!$parcel$global.__TYPEDARRAY_POOL) $parcel$global.__TYPEDARRAY_POOL = {
    UINT8: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    UINT16: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    UINT32: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    INT8: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    INT16: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    INT32: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    FLOAT: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    DOUBLE: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    DATA: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    UINT8C: $76676385c1a0c3ff$exports([
        32,
        0
    ]),
    BUFFER: $76676385c1a0c3ff$exports([
        32,
        0
    ])
};
var $af06462ea02ec4b1$var$hasUint8C = typeof Uint8ClampedArray !== 'undefined';
var $af06462ea02ec4b1$var$POOL = $parcel$global.__TYPEDARRAY_POOL;
//Upgrade pool
if (!$af06462ea02ec4b1$var$POOL.UINT8C) $af06462ea02ec4b1$var$POOL.UINT8C = $76676385c1a0c3ff$exports([
    32,
    0
]);
if (!$af06462ea02ec4b1$var$POOL.BUFFER) $af06462ea02ec4b1$var$POOL.BUFFER = $76676385c1a0c3ff$exports([
    32,
    0
]);
//New technique: Only allocate from ArrayBufferView and Buffer
var $af06462ea02ec4b1$var$DATA = $af06462ea02ec4b1$var$POOL.DATA, $af06462ea02ec4b1$var$BUFFER = $af06462ea02ec4b1$var$POOL.BUFFER;
$af06462ea02ec4b1$export$13e2de3c33d99539 = function free(array) {
    if ($af06462ea02ec4b1$require$Buffer.isBuffer(array)) $af06462ea02ec4b1$var$BUFFER[$aaceb971cbaa76bf$export$b9fae0bba9d9094d(array.length)].push(array);
    else {
        if (Object.prototype.toString.call(array) !== '[object ArrayBuffer]') array = array.buffer;
        if (!array) return;
        var n = array.length || array.byteLength;
        var log_n = $aaceb971cbaa76bf$export$b9fae0bba9d9094d(n) | 0;
        $af06462ea02ec4b1$var$DATA[log_n].push(array);
    }
};
function $af06462ea02ec4b1$var$freeArrayBuffer(buffer) {
    if (!buffer) return;
    var n = buffer.length || buffer.byteLength;
    var log_n = $aaceb971cbaa76bf$export$b9fae0bba9d9094d(n);
    $af06462ea02ec4b1$var$DATA[log_n].push(buffer);
}
function $af06462ea02ec4b1$var$freeTypedArray(array) {
    $af06462ea02ec4b1$var$freeArrayBuffer(array.buffer);
}
$af06462ea02ec4b1$export$11fc1c4b04ba842c = $af06462ea02ec4b1$export$f5ead431d5bddd13 = $af06462ea02ec4b1$export$d6ae10446123eda0 = $af06462ea02ec4b1$export$e0d7dff56fa02f46 = $af06462ea02ec4b1$export$badf6ea6e46c4075 = $af06462ea02ec4b1$export$971146dcff607408 = $af06462ea02ec4b1$export$781125fcc60e6b35 = $af06462ea02ec4b1$export$faf8b381a7d1f026 = $af06462ea02ec4b1$export$c26a3648f9f53f6c = $af06462ea02ec4b1$export$eb497d924a09cc2c = $af06462ea02ec4b1$export$73cdf697b53baa = $af06462ea02ec4b1$export$b2756c99e0338993 = $af06462ea02ec4b1$var$freeTypedArray;
$af06462ea02ec4b1$export$9d0c804f255d59e1 = $af06462ea02ec4b1$var$freeArrayBuffer;
$af06462ea02ec4b1$export$a24fefa6ccae86ec = function freeBuffer(array) {
    $af06462ea02ec4b1$var$BUFFER[$aaceb971cbaa76bf$export$b9fae0bba9d9094d(array.length)].push(array);
};
$af06462ea02ec4b1$export$6fa553f58a2a31c2 = function malloc(n, dtype) {
    if (dtype === undefined || dtype === 'arraybuffer') return $af06462ea02ec4b1$var$mallocArrayBuffer(n);
    else switch(dtype){
        case 'uint8':
            return $af06462ea02ec4b1$var$mallocUint8(n);
        case 'uint16':
            return $af06462ea02ec4b1$var$mallocUint16(n);
        case 'uint32':
            return $af06462ea02ec4b1$var$mallocUint32(n);
        case 'int8':
            return $af06462ea02ec4b1$var$mallocInt8(n);
        case 'int16':
            return $af06462ea02ec4b1$var$mallocInt16(n);
        case 'int32':
            return $af06462ea02ec4b1$var$mallocInt32(n);
        case 'float':
        case 'float32':
            return $af06462ea02ec4b1$var$mallocFloat(n);
        case 'double':
        case 'float64':
            return $af06462ea02ec4b1$var$mallocDouble(n);
        case 'uint8_clamped':
            return $af06462ea02ec4b1$var$mallocUint8Clamped(n);
        case 'buffer':
            return $af06462ea02ec4b1$var$mallocBuffer(n);
        case 'data':
        case 'dataview':
            return $af06462ea02ec4b1$var$mallocDataView(n);
        default:
            return null;
    }
    return null;
};
function $af06462ea02ec4b1$var$mallocArrayBuffer(n) {
    var n = $aaceb971cbaa76bf$export$f0d90cf68bd426eb(n);
    var log_n = $aaceb971cbaa76bf$export$b9fae0bba9d9094d(n);
    var d = $af06462ea02ec4b1$var$DATA[log_n];
    if (d.length > 0) return d.pop();
    return new ArrayBuffer(n);
}
$af06462ea02ec4b1$export$87c88a877180cdad = $af06462ea02ec4b1$var$mallocArrayBuffer;
function $af06462ea02ec4b1$var$mallocUint8(n) {
    return new Uint8Array($af06462ea02ec4b1$var$mallocArrayBuffer(n), 0, n);
}
$af06462ea02ec4b1$export$4fc11d1e7c095d9c = $af06462ea02ec4b1$var$mallocUint8;
function $af06462ea02ec4b1$var$mallocUint16(n) {
    return new Uint16Array($af06462ea02ec4b1$var$mallocArrayBuffer(2 * n), 0, n);
}
$af06462ea02ec4b1$export$72dbf0325fb0f6aa = $af06462ea02ec4b1$var$mallocUint16;
function $af06462ea02ec4b1$var$mallocUint32(n) {
    return new Uint32Array($af06462ea02ec4b1$var$mallocArrayBuffer(4 * n), 0, n);
}
$af06462ea02ec4b1$export$5a2d51bea84dc88a = $af06462ea02ec4b1$var$mallocUint32;
function $af06462ea02ec4b1$var$mallocInt8(n) {
    return new Int8Array($af06462ea02ec4b1$var$mallocArrayBuffer(n), 0, n);
}
$af06462ea02ec4b1$export$8e4b75dc6bfe3d87 = $af06462ea02ec4b1$var$mallocInt8;
function $af06462ea02ec4b1$var$mallocInt16(n) {
    return new Int16Array($af06462ea02ec4b1$var$mallocArrayBuffer(2 * n), 0, n);
}
$af06462ea02ec4b1$export$97e0aa7cbfa04c72 = $af06462ea02ec4b1$var$mallocInt16;
function $af06462ea02ec4b1$var$mallocInt32(n) {
    return new Int32Array($af06462ea02ec4b1$var$mallocArrayBuffer(4 * n), 0, n);
}
$af06462ea02ec4b1$export$bf19141f00438a2e = $af06462ea02ec4b1$var$mallocInt32;
function $af06462ea02ec4b1$var$mallocFloat(n) {
    return new Float32Array($af06462ea02ec4b1$var$mallocArrayBuffer(4 * n), 0, n);
}
$af06462ea02ec4b1$export$9492a022692715cc = $af06462ea02ec4b1$export$d0434a350fe26016 = $af06462ea02ec4b1$var$mallocFloat;
function $af06462ea02ec4b1$var$mallocDouble(n) {
    return new Float64Array($af06462ea02ec4b1$var$mallocArrayBuffer(8 * n), 0, n);
}
$af06462ea02ec4b1$export$c0265c4abfd8544d = $af06462ea02ec4b1$export$54d221d78667dc5b = $af06462ea02ec4b1$var$mallocDouble;
function $af06462ea02ec4b1$var$mallocUint8Clamped(n) {
    if ($af06462ea02ec4b1$var$hasUint8C) return new Uint8ClampedArray($af06462ea02ec4b1$var$mallocArrayBuffer(n), 0, n);
    else return $af06462ea02ec4b1$var$mallocUint8(n);
}
$af06462ea02ec4b1$export$a917895a033466e4 = $af06462ea02ec4b1$var$mallocUint8Clamped;
function $af06462ea02ec4b1$var$mallocDataView(n) {
    return new DataView($af06462ea02ec4b1$var$mallocArrayBuffer(n), 0, n);
}
$af06462ea02ec4b1$export$101cb185aa94caed = $af06462ea02ec4b1$var$mallocDataView;
function $af06462ea02ec4b1$var$mallocBuffer(n) {
    n = $aaceb971cbaa76bf$export$f0d90cf68bd426eb(n);
    var log_n = $aaceb971cbaa76bf$export$b9fae0bba9d9094d(n);
    var cache = $af06462ea02ec4b1$var$BUFFER[log_n];
    if (cache.length > 0) return cache.pop();
    return new $af06462ea02ec4b1$require$Buffer(n);
}
$af06462ea02ec4b1$export$76498f1e097fe8a6 = $af06462ea02ec4b1$var$mallocBuffer;
$af06462ea02ec4b1$export$d2adf65b87e47523 = function clearCache() {
    for(var i = 0; i < 32; ++i){
        $af06462ea02ec4b1$var$POOL.UINT8[i].length = 0;
        $af06462ea02ec4b1$var$POOL.UINT16[i].length = 0;
        $af06462ea02ec4b1$var$POOL.UINT32[i].length = 0;
        $af06462ea02ec4b1$var$POOL.INT8[i].length = 0;
        $af06462ea02ec4b1$var$POOL.INT16[i].length = 0;
        $af06462ea02ec4b1$var$POOL.INT32[i].length = 0;
        $af06462ea02ec4b1$var$POOL.FLOAT[i].length = 0;
        $af06462ea02ec4b1$var$POOL.DOUBLE[i].length = 0;
        $af06462ea02ec4b1$var$POOL.UINT8C[i].length = 0;
        $af06462ea02ec4b1$var$DATA[i].length = 0;
        $af06462ea02ec4b1$var$BUFFER[i].length = 0;
    }
};


var $dff307a8ad5f5850$exports = {};
var $00e9fa4a9055036b$exports = {};
"use strict";
function $00e9fa4a9055036b$var$iota(n) {
    var result = new Array(n);
    for(var i = 0; i < n; ++i)result[i] = i;
    return result;
}
$00e9fa4a9055036b$exports = $00e9fa4a9055036b$var$iota;


var $58805e71bbbc0b37$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
$58805e71bbbc0b37$exports = function(obj) {
    return obj != null && ($58805e71bbbc0b37$var$isBuffer(obj) || $58805e71bbbc0b37$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $58805e71bbbc0b37$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $58805e71bbbc0b37$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && $58805e71bbbc0b37$var$isBuffer(obj.slice(0, 0));
}


var $dff307a8ad5f5850$var$hasTypedArrays = typeof Float64Array !== "undefined";
function $dff307a8ad5f5850$var$compare1st(a, b) {
    return a[0] - b[0];
}
function $dff307a8ad5f5850$var$order() {
    var stride = this.stride;
    var terms = new Array(stride.length);
    var i;
    for(i = 0; i < terms.length; ++i)terms[i] = [
        Math.abs(stride[i]),
        i
    ];
    terms.sort($dff307a8ad5f5850$var$compare1st);
    var result = new Array(terms.length);
    for(i = 0; i < result.length; ++i)result[i] = terms[i][1];
    return result;
}
function $dff307a8ad5f5850$var$compileConstructor(dtype, dimension) {
    var className = [
        "View",
        dimension,
        "d",
        dtype
    ].join("");
    if (dimension < 0) className = "View_Nil" + dtype;
    var useGetters = dtype === "generic";
    if (dimension === -1) {
        //Special case for trivial arrays
        var code = "function " + className + "(a){this.data=a;};\
var proto=" + className + ".prototype;\
proto.dtype='" + dtype + "';\
proto.index=function(){return -1};\
proto.size=0;\
proto.dimension=-1;\
proto.shape=proto.stride=proto.order=[];\
proto.lo=proto.hi=proto.transpose=proto.step=\
function(){return new " + className + "(this.data);};\
proto.get=proto.set=function(){};\
proto.pick=function(){return null};\
return function construct_" + className + "(a){return new " + className + "(a);}";
        var procedure = new Function(code);
        return procedure();
    } else if (dimension === 0) {
        //Special case for 0d arrays
        var code = "function " + className + "(a,d) {\
this.data = a;\
this.offset = d\
};\
var proto=" + className + ".prototype;\
proto.dtype='" + dtype + "';\
proto.index=function(){return this.offset};\
proto.dimension=0;\
proto.size=1;\
proto.shape=\
proto.stride=\
proto.order=[];\
proto.lo=\
proto.hi=\
proto.transpose=\
proto.step=function " + className + "_copy() {\
return new " + className + "(this.data,this.offset)\
};\
proto.pick=function " + className + "_pick(){\
return TrivialArray(this.data);\
};\
proto.valueOf=proto.get=function " + className + "_get(){\
return " + (useGetters ? "this.data.get(this.offset)" : "this.data[this.offset]") + "};\
proto.set=function " + className + "_set(v){\
return " + (useGetters ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v") + "\
};\
return function construct_" + className + "(a,b,c,d){return new " + className + "(a,d)}";
        var procedure = new Function("TrivialArray", code);
        return procedure($dff307a8ad5f5850$var$CACHED_CONSTRUCTORS[dtype][0]);
    }
    var code = [
        "'use strict'"
    ];
    //Create constructor for view
    var indices = $00e9fa4a9055036b$exports(dimension);
    var args = indices.map(function(i) {
        return "i" + i;
    });
    var index_str = "this.offset+" + indices.map(function(i) {
        return "this.stride[" + i + "]*i" + i;
    }).join("+");
    var shapeArg = indices.map(function(i) {
        return "b" + i;
    }).join(",");
    var strideArg = indices.map(function(i) {
        return "c" + i;
    }).join(",");
    code.push("function " + className + "(a," + shapeArg + "," + strideArg + ",d){this.data=a", "this.shape=[" + shapeArg + "]", "this.stride=[" + strideArg + "]", "this.offset=d|0}", "var proto=" + className + ".prototype", "proto.dtype='" + dtype + "'", "proto.dimension=" + dimension);
    //view.size:
    code.push("Object.defineProperty(proto,'size',{get:function " + className + "_size(){\
return " + indices.map(function(i) {
        return "this.shape[" + i + "]";
    }).join("*"), "}})");
    //view.order:
    if (dimension === 1) code.push("proto.order=[0]");
    else {
        code.push("Object.defineProperty(proto,'order',{get:");
        if (dimension < 4) {
            code.push("function " + className + "_order(){");
            if (dimension === 2) code.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})");
            else if (dimension === 3) code.push("var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);\
if(s0>s1){\
if(s1>s2){\
return [2,1,0];\
}else if(s0>s2){\
return [1,2,0];\
}else{\
return [1,0,2];\
}\
}else if(s0>s2){\
return [2,0,1];\
}else if(s2>s1){\
return [0,1,2];\
}else{\
return [0,2,1];\
}}})");
        } else code.push("ORDER})");
    }
    //view.set(i0, ..., v):
    code.push("proto.set=function " + className + "_set(" + args.join(",") + ",v){");
    if (useGetters) code.push("return this.data.set(" + index_str + ",v)}");
    else code.push("return this.data[" + index_str + "]=v}");
    //view.get(i0, ...):
    code.push("proto.get=function " + className + "_get(" + args.join(",") + "){");
    if (useGetters) code.push("return this.data.get(" + index_str + ")}");
    else code.push("return this.data[" + index_str + "]}");
    //view.index:
    code.push("proto.index=function " + className + "_index(", args.join(), "){return " + index_str + "}");
    //view.hi():
    code.push("proto.hi=function " + className + "_hi(" + args.join(",") + "){return new " + className + "(this.data," + indices.map(function(i) {
        return [
            "(typeof i",
            i,
            "!=='number'||i",
            i,
            "<0)?this.shape[",
            i,
            "]:i",
            i,
            "|0"
        ].join("");
    }).join(",") + "," + indices.map(function(i) {
        return "this.stride[" + i + "]";
    }).join(",") + ",this.offset)}");
    //view.lo():
    var a_vars = indices.map(function(i) {
        return "a" + i + "=this.shape[" + i + "]";
    });
    var c_vars = indices.map(function(i) {
        return "c" + i + "=this.stride[" + i + "]";
    });
    code.push("proto.lo=function " + className + "_lo(" + args.join(",") + "){var b=this.offset,d=0," + a_vars.join(",") + "," + c_vars.join(","));
    for(var i = 0; i < dimension; ++i)code.push("if(typeof i" + i + "==='number'&&i" + i + ">=0){\
d=i" + i + "|0;\
b+=c" + i + "*d;\
a" + i + "-=d}");
    code.push("return new " + className + "(this.data," + indices.map(function(i) {
        return "a" + i;
    }).join(",") + "," + indices.map(function(i) {
        return "c" + i;
    }).join(",") + ",b)}");
    //view.step():
    code.push("proto.step=function " + className + "_step(" + args.join(",") + "){var " + indices.map(function(i) {
        return "a" + i + "=this.shape[" + i + "]";
    }).join(",") + "," + indices.map(function(i) {
        return "b" + i + "=this.stride[" + i + "]";
    }).join(",") + ",c=this.offset,d=0,ceil=Math.ceil");
    for(var i = 0; i < dimension; ++i)code.push("if(typeof i" + i + "==='number'){\
d=i" + i + "|0;\
if(d<0){\
c+=b" + i + "*(a" + i + "-1);\
a" + i + "=ceil(-a" + i + "/d)\
}else{\
a" + i + "=ceil(a" + i + "/d)\
}\
b" + i + "*=d\
}");
    code.push("return new " + className + "(this.data," + indices.map(function(i) {
        return "a" + i;
    }).join(",") + "," + indices.map(function(i) {
        return "b" + i;
    }).join(",") + ",c)}");
    //view.transpose():
    var tShape = new Array(dimension);
    var tStride = new Array(dimension);
    for(var i = 0; i < dimension; ++i){
        tShape[i] = "a[i" + i + "]";
        tStride[i] = "b[i" + i + "]";
    }
    code.push("proto.transpose=function " + className + "_transpose(" + args + "){" + args.map(function(n, idx) {
        return n + "=(" + n + "===undefined?" + idx + ":" + n + "|0)";
    }).join(";"), "var a=this.shape,b=this.stride;return new " + className + "(this.data," + tShape.join(",") + "," + tStride.join(",") + ",this.offset)}");
    //view.pick():
    code.push("proto.pick=function " + className + "_pick(" + args + "){var a=[],b=[],c=this.offset");
    for(var i = 0; i < dimension; ++i)code.push("if(typeof i" + i + "==='number'&&i" + i + ">=0){c=(c+this.stride[" + i + "]*i" + i + ")|0}else{a.push(this.shape[" + i + "]);b.push(this.stride[" + i + "])}");
    code.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}");
    //Add return statement
    code.push("return function construct_" + className + "(data,shape,stride,offset){return new " + className + "(data," + indices.map(function(i) {
        return "shape[" + i + "]";
    }).join(",") + "," + indices.map(function(i) {
        return "stride[" + i + "]";
    }).join(",") + ",offset)}");
    //Compile procedure
    var procedure = new Function("CTOR_LIST", "ORDER", code.join("\n"));
    return procedure($dff307a8ad5f5850$var$CACHED_CONSTRUCTORS[dtype], $dff307a8ad5f5850$var$order);
}
function $dff307a8ad5f5850$var$arrayDType(data) {
    if ($58805e71bbbc0b37$exports(data)) return "buffer";
    if ($dff307a8ad5f5850$var$hasTypedArrays) switch(Object.prototype.toString.call(data)){
        case "[object Float64Array]":
            return "float64";
        case "[object Float32Array]":
            return "float32";
        case "[object Int8Array]":
            return "int8";
        case "[object Int16Array]":
            return "int16";
        case "[object Int32Array]":
            return "int32";
        case "[object Uint8Array]":
            return "uint8";
        case "[object Uint16Array]":
            return "uint16";
        case "[object Uint32Array]":
            return "uint32";
        case "[object Uint8ClampedArray]":
            return "uint8_clamped";
    }
    if (Array.isArray(data)) return "array";
    return "generic";
}
var $dff307a8ad5f5850$var$CACHED_CONSTRUCTORS = {
    "float32": [],
    "float64": [],
    "int8": [],
    "int16": [],
    "int32": [],
    "uint8": [],
    "uint16": [],
    "uint32": [],
    "array": [],
    "uint8_clamped": [],
    "buffer": [],
    "generic": []
};
function $dff307a8ad5f5850$var$wrappedNDArrayCtor(data, shape, stride, offset) {
    if (data === undefined) {
        var ctor = $dff307a8ad5f5850$var$CACHED_CONSTRUCTORS.array[0];
        return ctor([]);
    } else if (typeof data === "number") data = [
        data
    ];
    if (shape === undefined) shape = [
        data.length
    ];
    var d = shape.length;
    if (stride === undefined) {
        stride = new Array(d);
        for(var i = d - 1, sz = 1; i >= 0; --i){
            stride[i] = sz;
            sz *= shape[i];
        }
    }
    if (offset === undefined) {
        offset = 0;
        for(var i = 0; i < d; ++i)if (stride[i] < 0) offset -= (shape[i] - 1) * stride[i];
    }
    var dtype = $dff307a8ad5f5850$var$arrayDType(data);
    var ctor_list = $dff307a8ad5f5850$var$CACHED_CONSTRUCTORS[dtype];
    while(ctor_list.length <= d + 1)ctor_list.push($dff307a8ad5f5850$var$compileConstructor(dtype, ctor_list.length - 1));
    var ctor = ctor_list[d + 1];
    return ctor(data, shape, stride, offset);
}
$dff307a8ad5f5850$exports = $dff307a8ad5f5850$var$wrappedNDArrayCtor;


var $bd7058b3c940594f$exports = {};
"use strict";
var $b211879b1899badc$exports = {};
"use strict";
var $e83628607396a6e5$exports = {};
"use strict";
var $34f15ef9600f23fe$exports = {};
"use strict";
var $b8f37a992d095d53$exports = {};
"use strict";
function $b8f37a992d095d53$var$unique_pred(list, compare) {
    var ptr = 1, len = list.length, a = list[0], b = list[0];
    for(var i = 1; i < len; ++i){
        b = a;
        a = list[i];
        if (compare(a, b)) {
            if (i === ptr) {
                ptr++;
                continue;
            }
            list[ptr++] = a;
        }
    }
    list.length = ptr;
    return list;
}
function $b8f37a992d095d53$var$unique_eq(list) {
    var ptr = 1, len = list.length, a = list[0], b = list[0];
    for(var i = 1; i < len; ++i, b = a){
        b = a;
        a = list[i];
        if (a !== b) {
            if (i === ptr) {
                ptr++;
                continue;
            }
            list[ptr++] = a;
        }
    }
    list.length = ptr;
    return list;
}
function $b8f37a992d095d53$var$unique(list, compare, sorted) {
    if (list.length === 0) return list;
    if (compare) {
        if (!sorted) list.sort(compare);
        return $b8f37a992d095d53$var$unique_pred(list, compare);
    }
    if (!sorted) list.sort();
    return $b8f37a992d095d53$var$unique_eq(list);
}
$b8f37a992d095d53$exports = $b8f37a992d095d53$var$unique;


// This function generates very simple loops analogous to how you typically traverse arrays (the outermost loop corresponds to the slowest changing index, the innermost loop to the fastest changing index)
// TODO: If two arrays have the same strides (and offsets) there is potential for decreasing the number of "pointers" and related variables. The drawback is that the type signature would become more specific and that there would thus be less potential for caching, but it might still be worth it, especially when dealing with large numbers of arguments.
function $34f15ef9600f23fe$var$innerFill(order, proc, body) {
    var dimension = order.length, nargs = proc.arrayArgs.length, has_index = proc.indexArgs.length > 0, code = [], vars = [], idx = 0, pidx = 0, i, j;
    for(i = 0; i < dimension; ++i)vars.push([
        "i",
        i,
        "=0"
    ].join(""));
    //Compute scan deltas
    for(j = 0; j < nargs; ++j)for(i = 0; i < dimension; ++i){
        pidx = idx;
        idx = order[i];
        if (i === 0) vars.push([
            "d",
            j,
            "s",
            i,
            "=t",
            j,
            "p",
            idx
        ].join(""));
        else vars.push([
            "d",
            j,
            "s",
            i,
            "=(t",
            j,
            "p",
            idx,
            "-s",
            pidx,
            "*t",
            j,
            "p",
            pidx,
            ")"
        ].join(""));
    }
    if (vars.length > 0) code.push("var " + vars.join(","));
    //Scan loop
    for(i = dimension - 1; i >= 0; --i){
        idx = order[i];
        code.push([
            "for(i",
            i,
            "=0;i",
            i,
            "<s",
            idx,
            ";++i",
            i,
            "){"
        ].join(""));
    }
    //Push body of inner loop
    code.push(body);
    //Advance scan pointers
    for(i = 0; i < dimension; ++i){
        pidx = idx;
        idx = order[i];
        for(j = 0; j < nargs; ++j)code.push([
            "p",
            j,
            "+=d",
            j,
            "s",
            i
        ].join(""));
        if (has_index) {
            if (i > 0) code.push([
                "index[",
                pidx,
                "]-=s",
                pidx
            ].join(""));
            code.push([
                "++index[",
                idx,
                "]"
            ].join(""));
        }
        code.push("}");
    }
    return code.join("\n");
}
// Generate "outer" loops that loop over blocks of data, applying "inner" loops to the blocks by manipulating the local variables in such a way that the inner loop only "sees" the current block.
// TODO: If this is used, then the previous declaration (done by generateCwiseOp) of s* is essentially unnecessary.
//       I believe the s* are not used elsewhere (in particular, I don't think they're used in the pre/post parts and "shape" is defined independently), so it would be possible to make defining the s* dependent on what loop method is being used.
function $34f15ef9600f23fe$var$outerFill(matched, order, proc, body) {
    var dimension = order.length, nargs = proc.arrayArgs.length, blockSize = proc.blockSize, has_index = proc.indexArgs.length > 0, code = [];
    for(var i = 0; i < nargs; ++i)code.push([
        "var offset",
        i,
        "=p",
        i
    ].join(""));
    //Generate loops for unmatched dimensions
    // The order in which these dimensions are traversed is fairly arbitrary (from small stride to large stride, for the first argument)
    // TODO: It would be nice if the order in which these loops are placed would also be somehow "optimal" (at the very least we should check that it really doesn't hurt us if they're not).
    for(var i = matched; i < dimension; ++i){
        code.push([
            "for(var j" + i + "=SS[",
            order[i],
            "]|0;j",
            i,
            ">0;){"
        ].join("")) // Iterate back to front
        ;
        code.push([
            "if(j",
            i,
            "<",
            blockSize,
            "){"
        ].join("")) // Either decrease j by blockSize (s = blockSize), or set it to zero (after setting s = j).
        ;
        code.push([
            "s",
            order[i],
            "=j",
            i
        ].join(""));
        code.push([
            "j",
            i,
            "=0"
        ].join(""));
        code.push([
            "}else{s",
            order[i],
            "=",
            blockSize
        ].join(""));
        code.push([
            "j",
            i,
            "-=",
            blockSize,
            "}"
        ].join(""));
        if (has_index) code.push([
            "index[",
            order[i],
            "]=j",
            i
        ].join(""));
    }
    for(var i = 0; i < nargs; ++i){
        var indexStr = [
            "offset" + i
        ];
        for(var j = matched; j < dimension; ++j)indexStr.push([
            "j",
            j,
            "*t",
            i,
            "p",
            order[j]
        ].join(""));
        code.push([
            "p",
            i,
            "=(",
            indexStr.join("+"),
            ")"
        ].join(""));
    }
    code.push($34f15ef9600f23fe$var$innerFill(order, proc, body));
    for(var i = matched; i < dimension; ++i)code.push("}");
    return code.join("\n");
}
//Count the number of compatible inner orders
// This is the length of the longest common prefix of the arrays in orders.
// Each array in orders lists the dimensions of the correspond ndarray in order of increasing stride.
// This is thus the maximum number of dimensions that can be efficiently traversed by simple nested loops for all arrays.
function $34f15ef9600f23fe$var$countMatches(orders) {
    var matched = 0, dimension = orders[0].length;
    while(matched < dimension){
        for(var j = 1; j < orders.length; ++j){
            if (orders[j][matched] !== orders[0][matched]) return matched;
        }
        ++matched;
    }
    return matched;
}
//Processes a block according to the given data types
// Replaces variable names by different ones, either "local" ones (that are then ferried in and out of the given array) or ones matching the arguments that the function performing the ultimate loop will accept.
function $34f15ef9600f23fe$var$processBlock(block, proc, dtypes) {
    var code = block.body;
    var pre = [];
    var post = [];
    for(var i = 0; i < block.args.length; ++i){
        var carg = block.args[i];
        if (carg.count <= 0) continue;
        var re = new RegExp(carg.name, "g");
        var ptrStr = "";
        var arrNum = proc.arrayArgs.indexOf(i);
        switch(proc.argTypes[i]){
            case "offset":
                var offArgIndex = proc.offsetArgIndex.indexOf(i);
                var offArg = proc.offsetArgs[offArgIndex];
                arrNum = offArg.array;
                ptrStr = "+q" + offArgIndex // Adds offset to the "pointer" in the array
                ;
            case "array":
                ptrStr = "p" + arrNum + ptrStr;
                var localStr = "l" + i;
                var arrStr = "a" + arrNum;
                if (proc.arrayBlockIndices[arrNum] === 0) {
                    if (carg.count === 1) {
                        if (dtypes[arrNum] === "generic") {
                            if (carg.lvalue) {
                                pre.push([
                                    "var ",
                                    localStr,
                                    "=",
                                    arrStr,
                                    ".get(",
                                    ptrStr,
                                    ")"
                                ].join("")) // Is this necessary if the argument is ONLY used as an lvalue? (keep in mind that we can have a += something, so we would actually need to check carg.rvalue)
                                ;
                                code = code.replace(re, localStr);
                                post.push([
                                    arrStr,
                                    ".set(",
                                    ptrStr,
                                    ",",
                                    localStr,
                                    ")"
                                ].join(""));
                            } else code = code.replace(re, [
                                arrStr,
                                ".get(",
                                ptrStr,
                                ")"
                            ].join(""));
                        } else code = code.replace(re, [
                            arrStr,
                            "[",
                            ptrStr,
                            "]"
                        ].join(""));
                    } else if (dtypes[arrNum] === "generic") {
                        pre.push([
                            "var ",
                            localStr,
                            "=",
                            arrStr,
                            ".get(",
                            ptrStr,
                            ")"
                        ].join("")) // TODO: Could we optimize by checking for carg.rvalue?
                        ;
                        code = code.replace(re, localStr);
                        if (carg.lvalue) post.push([
                            arrStr,
                            ".set(",
                            ptrStr,
                            ",",
                            localStr,
                            ")"
                        ].join(""));
                    } else {
                        pre.push([
                            "var ",
                            localStr,
                            "=",
                            arrStr,
                            "[",
                            ptrStr,
                            "]"
                        ].join("")) // TODO: Could we optimize by checking for carg.rvalue?
                        ;
                        code = code.replace(re, localStr);
                        if (carg.lvalue) post.push([
                            arrStr,
                            "[",
                            ptrStr,
                            "]=",
                            localStr
                        ].join(""));
                    }
                } else {
                    var reStrArr = [
                        carg.name
                    ], ptrStrArr = [
                        ptrStr
                    ];
                    for(var j = 0; j < Math.abs(proc.arrayBlockIndices[arrNum]); j++){
                        reStrArr.push("\\s*\\[([^\\]]+)\\]");
                        ptrStrArr.push("$" + (j + 1) + "*t" + arrNum + "b" + j) // Matched index times stride
                        ;
                    }
                    re = new RegExp(reStrArr.join(""), "g");
                    ptrStr = ptrStrArr.join("+");
                    if (dtypes[arrNum] === "generic") /*if(carg.lvalue) {
              pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join("")) // Is this necessary if the argument is ONLY used as an lvalue? (keep in mind that we can have a += something, so we would actually need to check carg.rvalue)
              code = code.replace(re, localStr)
              post.push([arrStr, ".set(", ptrStr, ",", localStr,")"].join(""))
            } else {
              code = code.replace(re, [arrStr, ".get(", ptrStr, ")"].join(""))
            }*/ throw new Error("cwise: Generic arrays not supported in combination with blocks!");
                    else // This does not produce any local variables, even if variables are used multiple times. It would be possible to do so, but it would complicate things quite a bit.
                    code = code.replace(re, [
                        arrStr,
                        "[",
                        ptrStr,
                        "]"
                    ].join(""));
                }
                break;
            case "scalar":
                code = code.replace(re, "Y" + proc.scalarArgs.indexOf(i));
                break;
            case "index":
                code = code.replace(re, "index");
                break;
            case "shape":
                code = code.replace(re, "shape");
                break;
        }
    }
    return [
        pre.join("\n"),
        code,
        post.join("\n")
    ].join("\n").trim();
}
function $34f15ef9600f23fe$var$typeSummary(dtypes) {
    var summary = new Array(dtypes.length);
    var allEqual = true;
    for(var i = 0; i < dtypes.length; ++i){
        var t = dtypes[i];
        var digits = t.match(/\d+/);
        if (!digits) digits = "";
        else digits = digits[0];
        if (t.charAt(0) === 0) summary[i] = "u" + t.charAt(1) + digits;
        else summary[i] = t.charAt(0) + digits;
        if (i > 0) allEqual = allEqual && summary[i] === summary[i - 1];
    }
    if (allEqual) return summary[0];
    return summary.join("");
}
//Generates a cwise operator
function $34f15ef9600f23fe$var$generateCWiseOp(proc, typesig) {
    //Compute dimension
    // Arrays get put first in typesig, and there are two entries per array (dtype and order), so this gets the number of dimensions in the first array arg.
    var dimension = typesig[1].length - Math.abs(proc.arrayBlockIndices[0]) | 0;
    var orders = new Array(proc.arrayArgs.length);
    var dtypes = new Array(proc.arrayArgs.length);
    for(var i = 0; i < proc.arrayArgs.length; ++i){
        dtypes[i] = typesig[2 * i];
        orders[i] = typesig[2 * i + 1];
    }
    //Determine where block and loop indices start and end
    var blockBegin = [], blockEnd = [] // These indices are exposed as blocks
    ;
    var loopBegin = [], loopEnd = [] // These indices are iterated over
    ;
    var loopOrders = [] // orders restricted to the loop indices
    ;
    for(var i = 0; i < proc.arrayArgs.length; ++i){
        if (proc.arrayBlockIndices[i] < 0) {
            loopBegin.push(0);
            loopEnd.push(dimension);
            blockBegin.push(dimension);
            blockEnd.push(dimension + proc.arrayBlockIndices[i]);
        } else {
            loopBegin.push(proc.arrayBlockIndices[i]) // Non-negative
            ;
            loopEnd.push(proc.arrayBlockIndices[i] + dimension);
            blockBegin.push(0);
            blockEnd.push(proc.arrayBlockIndices[i]);
        }
        var newOrder = [];
        for(var j = 0; j < orders[i].length; j++)if (loopBegin[i] <= orders[i][j] && orders[i][j] < loopEnd[i]) newOrder.push(orders[i][j] - loopBegin[i]) // If this is a loop index, put it in newOrder, subtracting loopBegin, to make sure that all loopOrders are using a common set of indices.
        ;
        loopOrders.push(newOrder);
    }
    //First create arguments for procedure
    var arglist = [
        "SS"
    ] // SS is the overall shape over which we iterate
    ;
    var code = [
        "'use strict'"
    ];
    var vars = [];
    for(var j = 0; j < dimension; ++j)vars.push([
        "s",
        j,
        "=SS[",
        j,
        "]"
    ].join("")) // The limits for each dimension.
    ;
    for(var i = 0; i < proc.arrayArgs.length; ++i){
        arglist.push("a" + i) // Actual data array
        ;
        arglist.push("t" + i) // Strides
        ;
        arglist.push("p" + i) // Offset in the array at which the data starts (also used for iterating over the data)
        ;
        for(var j = 0; j < dimension; ++j)vars.push([
            "t",
            i,
            "p",
            j,
            "=t",
            i,
            "[",
            loopBegin[i] + j,
            "]"
        ].join(""));
        for(var j = 0; j < Math.abs(proc.arrayBlockIndices[i]); ++j)vars.push([
            "t",
            i,
            "b",
            j,
            "=t",
            i,
            "[",
            blockBegin[i] + j,
            "]"
        ].join(""));
    }
    for(var i = 0; i < proc.scalarArgs.length; ++i)arglist.push("Y" + i);
    if (proc.shapeArgs.length > 0) vars.push("shape=SS.slice(0)") // Makes the shape over which we iterate available to the user defined functions (so you can use width/height for example)
    ;
    if (proc.indexArgs.length > 0) {
        // Prepare an array to keep track of the (logical) indices, initialized to dimension zeroes.
        var zeros = new Array(dimension);
        for(var i = 0; i < dimension; ++i)zeros[i] = "0";
        vars.push([
            "index=[",
            zeros.join(","),
            "]"
        ].join(""));
    }
    for(var i = 0; i < proc.offsetArgs.length; ++i){
        var off_arg = proc.offsetArgs[i];
        var init_string = [];
        for(var j = 0; j < off_arg.offset.length; ++j){
            if (off_arg.offset[j] === 0) continue;
            else if (off_arg.offset[j] === 1) init_string.push([
                "t",
                off_arg.array,
                "p",
                j
            ].join(""));
            else init_string.push([
                off_arg.offset[j],
                "*t",
                off_arg.array,
                "p",
                j
            ].join(""));
        }
        if (init_string.length === 0) vars.push("q" + i + "=0");
        else vars.push([
            "q",
            i,
            "=",
            init_string.join("+")
        ].join(""));
    }
    //Prepare this variables
    var thisVars = $b8f37a992d095d53$exports([].concat(proc.pre.thisVars).concat(proc.body.thisVars).concat(proc.post.thisVars));
    vars = vars.concat(thisVars);
    if (vars.length > 0) code.push("var " + vars.join(","));
    for(var i = 0; i < proc.arrayArgs.length; ++i)code.push("p" + i + "|=0");
    //Inline prelude
    if (proc.pre.body.length > 3) code.push($34f15ef9600f23fe$var$processBlock(proc.pre, proc, dtypes));
    //Process body
    var body = $34f15ef9600f23fe$var$processBlock(proc.body, proc, dtypes);
    var matched = $34f15ef9600f23fe$var$countMatches(loopOrders);
    if (matched < dimension) code.push($34f15ef9600f23fe$var$outerFill(matched, loopOrders[0], proc, body)) // TODO: Rather than passing loopOrders[0], it might be interesting to look at passing an order that represents the majority of the arguments for example.
    ;
    else code.push($34f15ef9600f23fe$var$innerFill(loopOrders[0], proc, body));
    //Inline epilog
    if (proc.post.body.length > 3) code.push($34f15ef9600f23fe$var$processBlock(proc.post, proc, dtypes));
    if (proc.debug) console.log("-----Generated cwise routine for ", typesig, ":\n" + code.join("\n") + "\n----------");
    var loopName = [
        proc.funcName || "unnamed",
        "_cwise_loop_",
        orders[0].join("s"),
        "m",
        matched,
        $34f15ef9600f23fe$var$typeSummary(dtypes)
    ].join("");
    var f = new Function([
        "function ",
        loopName,
        "(",
        arglist.join(","),
        "){",
        code.join("\n"),
        "} return ",
        loopName
    ].join(""));
    return f();
}
$34f15ef9600f23fe$exports = $34f15ef9600f23fe$var$generateCWiseOp;


function $e83628607396a6e5$var$createThunk(proc) {
    var code = [
        "'use strict'",
        "var CACHED={}"
    ];
    var vars = [];
    var thunkName = proc.funcName + "_cwise_thunk";
    //Build thunk
    code.push([
        "return function ",
        thunkName,
        "(",
        proc.shimArgs.join(","),
        "){"
    ].join(""));
    var typesig = [];
    var string_typesig = [];
    var proc_args = [
        [
            "array",
            proc.arrayArgs[0],
            ".shape.slice(",
            Math.max(0, proc.arrayBlockIndices[0]),
            proc.arrayBlockIndices[0] < 0 ? "," + proc.arrayBlockIndices[0] + ")" : ")"
        ].join("")
    ];
    var shapeLengthConditions = [], shapeConditions = [];
    // Process array arguments
    for(var i = 0; i < proc.arrayArgs.length; ++i){
        var j = proc.arrayArgs[i];
        vars.push([
            "t",
            j,
            "=array",
            j,
            ".dtype,",
            "r",
            j,
            "=array",
            j,
            ".order"
        ].join(""));
        typesig.push("t" + j);
        typesig.push("r" + j);
        string_typesig.push("t" + j);
        string_typesig.push("r" + j + ".join()");
        proc_args.push("array" + j + ".data");
        proc_args.push("array" + j + ".stride");
        proc_args.push("array" + j + ".offset|0");
        if (i > 0) {
            shapeLengthConditions.push("array" + proc.arrayArgs[0] + ".shape.length===array" + j + ".shape.length+" + (Math.abs(proc.arrayBlockIndices[0]) - Math.abs(proc.arrayBlockIndices[i])));
            shapeConditions.push("array" + proc.arrayArgs[0] + ".shape[shapeIndex+" + Math.max(0, proc.arrayBlockIndices[0]) + "]===array" + j + ".shape[shapeIndex+" + Math.max(0, proc.arrayBlockIndices[i]) + "]");
        }
    }
    // Check for shape equality
    if (proc.arrayArgs.length > 1) {
        code.push("if (!(" + shapeLengthConditions.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same dimensionality!')");
        code.push("for(var shapeIndex=array" + proc.arrayArgs[0] + ".shape.length-" + Math.abs(proc.arrayBlockIndices[0]) + "; shapeIndex-->0;) {");
        code.push("if (!(" + shapeConditions.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same shape!')");
        code.push("}");
    }
    // Process scalar arguments
    for(var i = 0; i < proc.scalarArgs.length; ++i)proc_args.push("scalar" + proc.scalarArgs[i]);
    // Check for cached function (and if not present, generate it)
    vars.push([
        "type=[",
        string_typesig.join(","),
        "].join()"
    ].join(""));
    vars.push("proc=CACHED[type]");
    code.push("var " + vars.join(","));
    code.push([
        "if(!proc){",
        "CACHED[type]=proc=compile([",
        typesig.join(","),
        "])}",
        "return proc(",
        proc_args.join(","),
        ")}"
    ].join(""));
    if (proc.debug) console.log("-----Generated thunk:\n" + code.join("\n") + "\n----------");
    //Compile thunk
    var thunk = new Function("compile", code.join("\n"));
    return thunk($34f15ef9600f23fe$exports.bind(undefined, proc));
}
$e83628607396a6e5$exports = $e83628607396a6e5$var$createThunk;


function $b211879b1899badc$var$Procedure() {
    this.argTypes = [];
    this.shimArgs = [];
    this.arrayArgs = [];
    this.arrayBlockIndices = [];
    this.scalarArgs = [];
    this.offsetArgs = [];
    this.offsetArgIndex = [];
    this.indexArgs = [];
    this.shapeArgs = [];
    this.funcName = "";
    this.pre = null;
    this.body = null;
    this.post = null;
    this.debug = false;
}
function $b211879b1899badc$var$compileCwise(user_args) {
    //Create procedure
    var proc = new $b211879b1899badc$var$Procedure();
    //Parse blocks
    proc.pre = user_args.pre;
    proc.body = user_args.body;
    proc.post = user_args.post;
    //Parse arguments
    var proc_args = user_args.args.slice(0);
    proc.argTypes = proc_args;
    for(var i = 0; i < proc_args.length; ++i){
        var arg_type = proc_args[i];
        if (arg_type === "array" || typeof arg_type === "object" && arg_type.blockIndices) {
            proc.argTypes[i] = "array";
            proc.arrayArgs.push(i);
            proc.arrayBlockIndices.push(arg_type.blockIndices ? arg_type.blockIndices : 0);
            proc.shimArgs.push("array" + i);
            if (i < proc.pre.args.length && proc.pre.args[i].count > 0) throw new Error("cwise: pre() block may not reference array args");
            if (i < proc.post.args.length && proc.post.args[i].count > 0) throw new Error("cwise: post() block may not reference array args");
        } else if (arg_type === "scalar") {
            proc.scalarArgs.push(i);
            proc.shimArgs.push("scalar" + i);
        } else if (arg_type === "index") {
            proc.indexArgs.push(i);
            if (i < proc.pre.args.length && proc.pre.args[i].count > 0) throw new Error("cwise: pre() block may not reference array index");
            if (i < proc.body.args.length && proc.body.args[i].lvalue) throw new Error("cwise: body() block may not write to array index");
            if (i < proc.post.args.length && proc.post.args[i].count > 0) throw new Error("cwise: post() block may not reference array index");
        } else if (arg_type === "shape") {
            proc.shapeArgs.push(i);
            if (i < proc.pre.args.length && proc.pre.args[i].lvalue) throw new Error("cwise: pre() block may not write to array shape");
            if (i < proc.body.args.length && proc.body.args[i].lvalue) throw new Error("cwise: body() block may not write to array shape");
            if (i < proc.post.args.length && proc.post.args[i].lvalue) throw new Error("cwise: post() block may not write to array shape");
        } else if (typeof arg_type === "object" && arg_type.offset) {
            proc.argTypes[i] = "offset";
            proc.offsetArgs.push({
                array: arg_type.array,
                offset: arg_type.offset
            });
            proc.offsetArgIndex.push(i);
        } else throw new Error("cwise: Unknown argument type " + proc_args[i]);
    }
    //Make sure at least one array argument was specified
    if (proc.arrayArgs.length <= 0) throw new Error("cwise: No array arguments specified");
    //Make sure arguments are correct
    if (proc.pre.args.length > proc_args.length) throw new Error("cwise: Too many arguments in pre() block");
    if (proc.body.args.length > proc_args.length) throw new Error("cwise: Too many arguments in body() block");
    if (proc.post.args.length > proc_args.length) throw new Error("cwise: Too many arguments in post() block");
    //Check debug flag
    proc.debug = !!user_args.printCode || !!user_args.debug;
    //Retrieve name
    proc.funcName = user_args.funcName || "cwise";
    //Read in block size
    proc.blockSize = user_args.blockSize || 64;
    return $e83628607396a6e5$exports(proc);
}
$b211879b1899badc$exports = $b211879b1899badc$var$compileCwise;


var $bd7058b3c940594f$var$EmptyProc = {
    body: "",
    args: [],
    thisVars: [],
    localVars: []
};
function $bd7058b3c940594f$var$fixup(x) {
    if (!x) return $bd7058b3c940594f$var$EmptyProc;
    for(var i = 0; i < x.args.length; ++i){
        var a = x.args[i];
        if (i === 0) x.args[i] = {
            name: a,
            lvalue: true,
            rvalue: !!x.rvalue,
            count: x.count || 1
        };
        else x.args[i] = {
            name: a,
            lvalue: false,
            rvalue: true,
            count: 1
        };
    }
    if (!x.thisVars) x.thisVars = [];
    if (!x.localVars) x.localVars = [];
    return x;
}
function $bd7058b3c940594f$var$pcompile(user_args) {
    return $b211879b1899badc$exports({
        args: user_args.args,
        pre: $bd7058b3c940594f$var$fixup(user_args.pre),
        body: $bd7058b3c940594f$var$fixup(user_args.body),
        post: $bd7058b3c940594f$var$fixup(user_args.proc),
        funcName: user_args.funcName
    });
}
function $bd7058b3c940594f$var$makeOp(user_args) {
    var args = [];
    for(var i = 0; i < user_args.args.length; ++i)args.push("a" + i);
    var wrapper = new Function("P", [
        "return function ",
        user_args.funcName,
        "_ndarrayops(",
        args.join(","),
        ") {P(",
        args.join(","),
        ");return a0}"
    ].join(""));
    return wrapper($bd7058b3c940594f$var$pcompile(user_args));
}
var $bd7058b3c940594f$var$assign_ops = {
    add: "+",
    sub: "-",
    mul: "*",
    div: "/",
    mod: "%",
    band: "&",
    bor: "|",
    bxor: "^",
    lshift: "<<",
    rshift: ">>",
    rrshift: ">>>"
};
(function() {
    for(var id in $bd7058b3c940594f$var$assign_ops){
        var op = $bd7058b3c940594f$var$assign_ops[id];
        $bd7058b3c940594f$exports[id] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array",
                "array"
            ],
            body: {
                args: [
                    "a",
                    "b",
                    "c"
                ],
                body: "a=b" + op + "c"
            },
            funcName: id
        });
        $bd7058b3c940594f$exports[id + "eq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array"
            ],
            body: {
                args: [
                    "a",
                    "b"
                ],
                body: "a" + op + "=b"
            },
            rvalue: true,
            funcName: id + "eq"
        });
        $bd7058b3c940594f$exports[id + "s"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array",
                "scalar"
            ],
            body: {
                args: [
                    "a",
                    "b",
                    "s"
                ],
                body: "a=b" + op + "s"
            },
            funcName: id + "s"
        });
        $bd7058b3c940594f$exports[id + "seq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "scalar"
            ],
            body: {
                args: [
                    "a",
                    "s"
                ],
                body: "a" + op + "=s"
            },
            rvalue: true,
            funcName: id + "seq"
        });
    }
})();
var $bd7058b3c940594f$var$unary_ops = {
    not: "!",
    bnot: "~",
    neg: "-",
    recip: "1.0/"
};
(function() {
    for(var id in $bd7058b3c940594f$var$unary_ops){
        var op = $bd7058b3c940594f$var$unary_ops[id];
        $bd7058b3c940594f$exports[id] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array"
            ],
            body: {
                args: [
                    "a",
                    "b"
                ],
                body: "a=" + op + "b"
            },
            funcName: id
        });
        $bd7058b3c940594f$exports[id + "eq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array"
            ],
            body: {
                args: [
                    "a"
                ],
                body: "a=" + op + "a"
            },
            rvalue: true,
            count: 2,
            funcName: id + "eq"
        });
    }
})();
var $bd7058b3c940594f$var$binary_ops = {
    and: "&&",
    or: "||",
    eq: "===",
    neq: "!==",
    lt: "<",
    gt: ">",
    leq: "<=",
    geq: ">="
};
(function() {
    for(var id in $bd7058b3c940594f$var$binary_ops){
        var op = $bd7058b3c940594f$var$binary_ops[id];
        $bd7058b3c940594f$exports[id] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array",
                "array"
            ],
            body: {
                args: [
                    "a",
                    "b",
                    "c"
                ],
                body: "a=b" + op + "c"
            },
            funcName: id
        });
        $bd7058b3c940594f$exports[id + "s"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array",
                "scalar"
            ],
            body: {
                args: [
                    "a",
                    "b",
                    "s"
                ],
                body: "a=b" + op + "s"
            },
            funcName: id + "s"
        });
        $bd7058b3c940594f$exports[id + "eq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array"
            ],
            body: {
                args: [
                    "a",
                    "b"
                ],
                body: "a=a" + op + "b"
            },
            rvalue: true,
            count: 2,
            funcName: id + "eq"
        });
        $bd7058b3c940594f$exports[id + "seq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "scalar"
            ],
            body: {
                args: [
                    "a",
                    "s"
                ],
                body: "a=a" + op + "s"
            },
            rvalue: true,
            count: 2,
            funcName: id + "seq"
        });
    }
})();
var $bd7058b3c940594f$var$math_unary = [
    "abs",
    "acos",
    "asin",
    "atan",
    "ceil",
    "cos",
    "exp",
    "floor",
    "log",
    "round",
    "sin",
    "sqrt",
    "tan"
];
(function() {
    for(var i = 0; i < $bd7058b3c940594f$var$math_unary.length; ++i){
        var f = $bd7058b3c940594f$var$math_unary[i];
        $bd7058b3c940594f$exports[f] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b"
                ],
                body: "a=this_f(b)",
                thisVars: [
                    "this_f"
                ]
            },
            funcName: f
        });
        $bd7058b3c940594f$exports[f + "eq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a"
                ],
                body: "a=this_f(a)",
                thisVars: [
                    "this_f"
                ]
            },
            rvalue: true,
            count: 2,
            funcName: f + "eq"
        });
    }
})();
var $bd7058b3c940594f$var$math_comm = [
    "max",
    "min",
    "atan2",
    "pow"
];
(function() {
    for(var i = 0; i < $bd7058b3c940594f$var$math_comm.length; ++i){
        var f = $bd7058b3c940594f$var$math_comm[i];
        $bd7058b3c940594f$exports[f] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array",
                "array"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b",
                    "c"
                ],
                body: "a=this_f(b,c)",
                thisVars: [
                    "this_f"
                ]
            },
            funcName: f
        });
        $bd7058b3c940594f$exports[f + "s"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array",
                "scalar"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b",
                    "c"
                ],
                body: "a=this_f(b,c)",
                thisVars: [
                    "this_f"
                ]
            },
            funcName: f + "s"
        });
        $bd7058b3c940594f$exports[f + "eq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b"
                ],
                body: "a=this_f(a,b)",
                thisVars: [
                    "this_f"
                ]
            },
            rvalue: true,
            count: 2,
            funcName: f + "eq"
        });
        $bd7058b3c940594f$exports[f + "seq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "scalar"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b"
                ],
                body: "a=this_f(a,b)",
                thisVars: [
                    "this_f"
                ]
            },
            rvalue: true,
            count: 2,
            funcName: f + "seq"
        });
    }
})();
var $bd7058b3c940594f$var$math_noncomm = [
    "atan2",
    "pow"
];
(function() {
    for(var i = 0; i < $bd7058b3c940594f$var$math_noncomm.length; ++i){
        var f = $bd7058b3c940594f$var$math_noncomm[i];
        $bd7058b3c940594f$exports[f + "op"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array",
                "array"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b",
                    "c"
                ],
                body: "a=this_f(c,b)",
                thisVars: [
                    "this_f"
                ]
            },
            funcName: f + "op"
        });
        $bd7058b3c940594f$exports[f + "ops"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array",
                "scalar"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b",
                    "c"
                ],
                body: "a=this_f(c,b)",
                thisVars: [
                    "this_f"
                ]
            },
            funcName: f + "ops"
        });
        $bd7058b3c940594f$exports[f + "opeq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "array"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b"
                ],
                body: "a=this_f(b,a)",
                thisVars: [
                    "this_f"
                ]
            },
            rvalue: true,
            count: 2,
            funcName: f + "opeq"
        });
        $bd7058b3c940594f$exports[f + "opseq"] = $bd7058b3c940594f$var$makeOp({
            args: [
                "array",
                "scalar"
            ],
            pre: {
                args: [],
                body: "this_f=Math." + f,
                thisVars: [
                    "this_f"
                ]
            },
            body: {
                args: [
                    "a",
                    "b"
                ],
                body: "a=this_f(b,a)",
                thisVars: [
                    "this_f"
                ]
            },
            rvalue: true,
            count: 2,
            funcName: f + "opseq"
        });
    }
})();
$bd7058b3c940594f$exports.any = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: $bd7058b3c940594f$var$EmptyProc,
    body: {
        args: [
            {
                name: "a",
                lvalue: false,
                rvalue: true,
                count: 1
            }
        ],
        body: "if(a){return true}",
        localVars: [],
        thisVars: []
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [],
        body: "return false"
    },
    funcName: "any"
});
$bd7058b3c940594f$exports.all = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: $bd7058b3c940594f$var$EmptyProc,
    body: {
        args: [
            {
                name: "x",
                lvalue: false,
                rvalue: true,
                count: 1
            }
        ],
        body: "if(!x){return false}",
        localVars: [],
        thisVars: []
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [],
        body: "return true"
    },
    funcName: "all"
});
$bd7058b3c940594f$exports.sum = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "this_s=0"
    },
    body: {
        args: [
            {
                name: "a",
                lvalue: false,
                rvalue: true,
                count: 1
            }
        ],
        body: "this_s+=a",
        localVars: [],
        thisVars: [
            "this_s"
        ]
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "return this_s"
    },
    funcName: "sum"
});
$bd7058b3c940594f$exports.prod = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "this_s=1"
    },
    body: {
        args: [
            {
                name: "a",
                lvalue: false,
                rvalue: true,
                count: 1
            }
        ],
        body: "this_s*=a",
        localVars: [],
        thisVars: [
            "this_s"
        ]
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "return this_s"
    },
    funcName: "prod"
});
$bd7058b3c940594f$exports.norm2squared = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "this_s=0"
    },
    body: {
        args: [
            {
                name: "a",
                lvalue: false,
                rvalue: true,
                count: 2
            }
        ],
        body: "this_s+=a*a",
        localVars: [],
        thisVars: [
            "this_s"
        ]
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "return this_s"
    },
    funcName: "norm2squared"
});
$bd7058b3c940594f$exports.norm2 = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "this_s=0"
    },
    body: {
        args: [
            {
                name: "a",
                lvalue: false,
                rvalue: true,
                count: 2
            }
        ],
        body: "this_s+=a*a",
        localVars: [],
        thisVars: [
            "this_s"
        ]
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "return Math.sqrt(this_s)"
    },
    funcName: "norm2"
});
$bd7058b3c940594f$exports.norminf = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "this_s=0"
    },
    body: {
        args: [
            {
                name: "a",
                lvalue: false,
                rvalue: true,
                count: 4
            }
        ],
        body: "if(-a>this_s){this_s=-a}else if(a>this_s){this_s=a}",
        localVars: [],
        thisVars: [
            "this_s"
        ]
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "return this_s"
    },
    funcName: "norminf"
});
$bd7058b3c940594f$exports.norm1 = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "this_s=0"
    },
    body: {
        args: [
            {
                name: "a",
                lvalue: false,
                rvalue: true,
                count: 3
            }
        ],
        body: "this_s+=a<0?-a:a",
        localVars: [],
        thisVars: [
            "this_s"
        ]
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [
            "this_s"
        ],
        body: "return this_s"
    },
    funcName: "norm1"
});
$bd7058b3c940594f$exports.sup = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: {
        body: "this_h=-Infinity",
        args: [],
        thisVars: [
            "this_h"
        ],
        localVars: []
    },
    body: {
        body: "if(_inline_1_arg0_>this_h)this_h=_inline_1_arg0_",
        args: [
            {
                "name": "_inline_1_arg0_",
                "lvalue": false,
                "rvalue": true,
                "count": 2
            }
        ],
        thisVars: [
            "this_h"
        ],
        localVars: []
    },
    post: {
        body: "return this_h",
        args: [],
        thisVars: [
            "this_h"
        ],
        localVars: []
    }
});
$bd7058b3c940594f$exports.inf = $b211879b1899badc$exports({
    args: [
        "array"
    ],
    pre: {
        body: "this_h=Infinity",
        args: [],
        thisVars: [
            "this_h"
        ],
        localVars: []
    },
    body: {
        body: "if(_inline_1_arg0_<this_h)this_h=_inline_1_arg0_",
        args: [
            {
                "name": "_inline_1_arg0_",
                "lvalue": false,
                "rvalue": true,
                "count": 2
            }
        ],
        thisVars: [
            "this_h"
        ],
        localVars: []
    },
    post: {
        body: "return this_h",
        args: [],
        thisVars: [
            "this_h"
        ],
        localVars: []
    }
});
$bd7058b3c940594f$exports.argmin = $b211879b1899badc$exports({
    args: [
        "index",
        "array",
        "shape"
    ],
    pre: {
        body: "{this_v=Infinity;this_i=_inline_0_arg2_.slice(0)}",
        args: [
            {
                name: "_inline_0_arg0_",
                lvalue: false,
                rvalue: false,
                count: 0
            },
            {
                name: "_inline_0_arg1_",
                lvalue: false,
                rvalue: false,
                count: 0
            },
            {
                name: "_inline_0_arg2_",
                lvalue: false,
                rvalue: true,
                count: 1
            }
        ],
        thisVars: [
            "this_i",
            "this_v"
        ],
        localVars: []
    },
    body: {
        body: "{if(_inline_1_arg1_<this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
        args: [
            {
                name: "_inline_1_arg0_",
                lvalue: false,
                rvalue: true,
                count: 2
            },
            {
                name: "_inline_1_arg1_",
                lvalue: false,
                rvalue: true,
                count: 2
            }
        ],
        thisVars: [
            "this_i",
            "this_v"
        ],
        localVars: [
            "_inline_1_k"
        ]
    },
    post: {
        body: "{return this_i}",
        args: [],
        thisVars: [
            "this_i"
        ],
        localVars: []
    }
});
$bd7058b3c940594f$exports.argmax = $b211879b1899badc$exports({
    args: [
        "index",
        "array",
        "shape"
    ],
    pre: {
        body: "{this_v=-Infinity;this_i=_inline_0_arg2_.slice(0)}",
        args: [
            {
                name: "_inline_0_arg0_",
                lvalue: false,
                rvalue: false,
                count: 0
            },
            {
                name: "_inline_0_arg1_",
                lvalue: false,
                rvalue: false,
                count: 0
            },
            {
                name: "_inline_0_arg2_",
                lvalue: false,
                rvalue: true,
                count: 1
            }
        ],
        thisVars: [
            "this_i",
            "this_v"
        ],
        localVars: []
    },
    body: {
        body: "{if(_inline_1_arg1_>this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
        args: [
            {
                name: "_inline_1_arg0_",
                lvalue: false,
                rvalue: true,
                count: 2
            },
            {
                name: "_inline_1_arg1_",
                lvalue: false,
                rvalue: true,
                count: 2
            }
        ],
        thisVars: [
            "this_i",
            "this_v"
        ],
        localVars: [
            "_inline_1_k"
        ]
    },
    post: {
        body: "{return this_i}",
        args: [],
        thisVars: [
            "this_i"
        ],
        localVars: []
    }
});
$bd7058b3c940594f$exports.random = $bd7058b3c940594f$var$makeOp({
    args: [
        "array"
    ],
    pre: {
        args: [],
        body: "this_f=Math.random",
        thisVars: [
            "this_f"
        ]
    },
    body: {
        args: [
            "a"
        ],
        body: "a=this_f()",
        thisVars: [
            "this_f"
        ]
    },
    funcName: "random"
});
$bd7058b3c940594f$exports.assign = $bd7058b3c940594f$var$makeOp({
    args: [
        "array",
        "array"
    ],
    body: {
        args: [
            "a",
            "b"
        ],
        body: "a=b"
    },
    funcName: "assign"
});
$bd7058b3c940594f$exports.assigns = $bd7058b3c940594f$var$makeOp({
    args: [
        "array",
        "scalar"
    ],
    body: {
        args: [
            "a",
            "b"
        ],
        body: "a=b"
    },
    funcName: "assigns"
});
$bd7058b3c940594f$exports.equals = $b211879b1899badc$exports({
    args: [
        "array",
        "array"
    ],
    pre: $bd7058b3c940594f$var$EmptyProc,
    body: {
        args: [
            {
                name: "x",
                lvalue: false,
                rvalue: true,
                count: 1
            },
            {
                name: "y",
                lvalue: false,
                rvalue: true,
                count: 1
            }
        ],
        body: "if(x!==y){return false}",
        localVars: [],
        thisVars: []
    },
    post: {
        args: [],
        localVars: [],
        thisVars: [],
        body: "return true"
    },
    funcName: "equals"
});


var $7f253147c04c82d1$exports = {};
'use strict';



var $b81264140eaa46b6$exports = {};

function $b81264140eaa46b6$var$fft(dir, nrows, ncols, buffer, x_ptr, y_ptr, scratch_ptr) {
    dir |= 0;
    nrows |= 0;
    ncols |= 0;
    x_ptr |= 0;
    y_ptr |= 0;
    if ($aaceb971cbaa76bf$export$eb50b9c078eb6ae7(ncols)) $b81264140eaa46b6$var$fftRadix2(dir, nrows, ncols, buffer, x_ptr, y_ptr);
    else $b81264140eaa46b6$var$fftBluestein(dir, nrows, ncols, buffer, x_ptr, y_ptr, scratch_ptr);
}
$b81264140eaa46b6$exports = $b81264140eaa46b6$var$fft;
function $b81264140eaa46b6$var$scratchMemory(n) {
    if ($aaceb971cbaa76bf$export$eb50b9c078eb6ae7(n)) return 0;
    return 2 * n + 4 * $aaceb971cbaa76bf$export$f0d90cf68bd426eb(2 * n + 1);
}
$b81264140eaa46b6$exports.scratchMemory = $b81264140eaa46b6$var$scratchMemory;
//Radix 2 FFT Adapted from Paul Bourke's C Implementation
function $b81264140eaa46b6$var$fftRadix2(dir, nrows, ncols, buffer, x_ptr, y_ptr) {
    dir |= 0;
    nrows |= 0;
    ncols |= 0;
    x_ptr |= 0;
    y_ptr |= 0;
    var nn, m, i, i1, j, k, i2, l, l1, l2;
    var c1, c2, t, t1, t2, u1, u2, z, row, a, b, c, d, k1, k2, k3;
    // Calculate the number of points
    nn = ncols;
    m = $aaceb971cbaa76bf$export$b9fae0bba9d9094d(nn);
    for(row = 0; row < nrows; ++row){
        // Do the bit reversal
        i2 = nn >> 1;
        j = 0;
        for(i = 0; i < nn - 1; i++){
            if (i < j) {
                t = buffer[x_ptr + i];
                buffer[x_ptr + i] = buffer[x_ptr + j];
                buffer[x_ptr + j] = t;
                t = buffer[y_ptr + i];
                buffer[y_ptr + i] = buffer[y_ptr + j];
                buffer[y_ptr + j] = t;
            }
            k = i2;
            while(k <= j){
                j -= k;
                k >>= 1;
            }
            j += k;
        }
        // Compute the FFT
        c1 = -1;
        c2 = 0.0;
        l2 = 1;
        for(l = 0; l < m; l++){
            l1 = l2;
            l2 <<= 1;
            u1 = 1.0;
            u2 = 0.0;
            for(j = 0; j < l1; j++){
                for(i = j; i < nn; i += l2){
                    i1 = i + l1;
                    a = buffer[x_ptr + i1];
                    b = buffer[y_ptr + i1];
                    c = buffer[x_ptr + i];
                    d = buffer[y_ptr + i];
                    k1 = u1 * (a + b);
                    k2 = a * (u2 - u1);
                    k3 = b * (u1 + u2);
                    t1 = k1 - k3;
                    t2 = k1 + k2;
                    buffer[x_ptr + i1] = c - t1;
                    buffer[y_ptr + i1] = d - t2;
                    buffer[x_ptr + i] += t1;
                    buffer[y_ptr + i] += t2;
                }
                k1 = c1 * (u1 + u2);
                k2 = u1 * (c2 - c1);
                k3 = u2 * (c1 + c2);
                u1 = k1 - k3;
                u2 = k1 + k2;
            }
            c2 = Math.sqrt((1.0 - c1) / 2.0);
            if (dir < 0) c2 = -c2;
            c1 = Math.sqrt((1.0 + c1) / 2.0);
        }
        // Scaling for inverse transform
        if (dir < 0) {
            var scale_f = 1.0 / nn;
            for(i = 0; i < nn; i++){
                buffer[x_ptr + i] *= scale_f;
                buffer[y_ptr + i] *= scale_f;
            }
        }
        // Advance pointers
        x_ptr += ncols;
        y_ptr += ncols;
    }
}
// Use Bluestein algorithm for npot FFTs
// Scratch memory required:  2 * ncols + 4 * bits.nextPow2(2*ncols + 1)
function $b81264140eaa46b6$var$fftBluestein(dir, nrows, ncols, buffer, x_ptr, y_ptr, scratch_ptr) {
    dir |= 0;
    nrows |= 0;
    ncols |= 0;
    x_ptr |= 0;
    y_ptr |= 0;
    scratch_ptr |= 0;
    // Initialize tables
    var m = $aaceb971cbaa76bf$export$f0d90cf68bd426eb(2 * ncols + 1), cos_ptr = scratch_ptr, sin_ptr = cos_ptr + ncols, xs_ptr = sin_ptr + ncols, ys_ptr = xs_ptr + m, cft_ptr = ys_ptr + m, sft_ptr = cft_ptr + m, w = -dir * Math.PI / ncols, row, a, b, c, d, k1, k2, k3, i;
    for(i = 0; i < ncols; ++i){
        a = w * (i * i % (ncols * 2));
        c = Math.cos(a);
        d = Math.sin(a);
        buffer[cft_ptr + (m - i)] = buffer[cft_ptr + i] = buffer[cos_ptr + i] = c;
        buffer[sft_ptr + (m - i)] = buffer[sft_ptr + i] = buffer[sin_ptr + i] = d;
    }
    for(i = ncols; i <= m - ncols; ++i)buffer[cft_ptr + i] = 0.0;
    for(i = ncols; i <= m - ncols; ++i)buffer[sft_ptr + i] = 0.0;
    $b81264140eaa46b6$var$fftRadix2(1, 1, m, buffer, cft_ptr, sft_ptr);
    //Compute scale factor
    if (dir < 0) w = 1.0 / ncols;
    else w = 1.0;
    //Handle direction
    for(row = 0; row < nrows; ++row){
        // Copy row into scratch memory, multiply weights
        for(i = 0; i < ncols; ++i){
            a = buffer[x_ptr + i];
            b = buffer[y_ptr + i];
            c = buffer[cos_ptr + i];
            d = -buffer[sin_ptr + i];
            k1 = c * (a + b);
            k2 = a * (d - c);
            k3 = b * (c + d);
            buffer[xs_ptr + i] = k1 - k3;
            buffer[ys_ptr + i] = k1 + k2;
        }
        //Zero out the rest
        for(i = ncols; i < m; ++i)buffer[xs_ptr + i] = 0.0;
        for(i = ncols; i < m; ++i)buffer[ys_ptr + i] = 0.0;
        // FFT buffer
        $b81264140eaa46b6$var$fftRadix2(1, 1, m, buffer, xs_ptr, ys_ptr);
        // Apply multiplier
        for(i = 0; i < m; ++i){
            a = buffer[xs_ptr + i];
            b = buffer[ys_ptr + i];
            c = buffer[cft_ptr + i];
            d = buffer[sft_ptr + i];
            k1 = c * (a + b);
            k2 = a * (d - c);
            k3 = b * (c + d);
            buffer[xs_ptr + i] = k1 - k3;
            buffer[ys_ptr + i] = k1 + k2;
        }
        // Inverse FFT buffer
        $b81264140eaa46b6$var$fftRadix2(-1, 1, m, buffer, xs_ptr, ys_ptr);
        // Copy result back into x/y
        for(i = 0; i < ncols; ++i){
            a = buffer[xs_ptr + i];
            b = buffer[ys_ptr + i];
            c = buffer[cos_ptr + i];
            d = -buffer[sin_ptr + i];
            k1 = c * (a + b);
            k2 = a * (d - c);
            k3 = b * (c + d);
            buffer[x_ptr + i] = w * (k1 - k3);
            buffer[y_ptr + i] = w * (k1 + k2);
        }
        x_ptr += ncols;
        y_ptr += ncols;
    }
}


function $7f253147c04c82d1$var$ndfft(dir, x, y) {
    var shape = x.shape, d = shape.length, size = 1, stride = new Array(d), pad = 0, i, j;
    for(i = d - 1; i >= 0; --i){
        stride[i] = size;
        size *= shape[i];
        pad = Math.max(pad, $b81264140eaa46b6$exports.scratchMemory(shape[i]));
        if (x.shape[i] !== y.shape[i]) throw new Error('Shape mismatch, real and imaginary arrays must have same size');
    }
    var buf_size = 4 * size + pad;
    var buffer;
    if (x.dtype === 'array' || x.dtype === 'float64' || x.dtype === 'custom') buffer = $af06462ea02ec4b1$export$54d221d78667dc5b(buf_size);
    else buffer = $af06462ea02ec4b1$export$d0434a350fe26016(buf_size);
    var x1 = $dff307a8ad5f5850$exports(buffer, shape.slice(0), stride, 0), y1 = $dff307a8ad5f5850$exports(buffer, shape.slice(0), stride.slice(0), size), x2 = $dff307a8ad5f5850$exports(buffer, shape.slice(0), stride.slice(0), 2 * size), y2 = $dff307a8ad5f5850$exports(buffer, shape.slice(0), stride.slice(0), 3 * size), tmp, n, s1, s2, scratch_ptr = 4 * size;
    //Copy into x1/y1
    $bd7058b3c940594f$exports.assign(x1, x);
    $bd7058b3c940594f$exports.assign(y1, y);
    for(i = d - 1; i >= 0; --i){
        $b81264140eaa46b6$exports(dir, size / shape[i], shape[i], buffer, x1.offset, y1.offset, scratch_ptr);
        if (i === 0) break;
        //Compute new stride for x2/y2
        n = 1;
        s1 = x2.stride;
        s2 = y2.stride;
        for(j = i - 1; j < d; ++j){
            s2[j] = s1[j] = n;
            n *= shape[j];
        }
        for(j = i - 2; j >= 0; --j){
            s2[j] = s1[j] = n;
            n *= shape[j];
        }
        //Transpose
        $bd7058b3c940594f$exports.assign(x2, x1);
        $bd7058b3c940594f$exports.assign(y2, y1);
        //Swap buffers
        tmp = x1;
        x1 = x2;
        x2 = tmp;
        tmp = y1;
        y1 = y2;
        y2 = tmp;
    }
    //Copy result back into x
    $bd7058b3c940594f$exports.assign(x, x1);
    $bd7058b3c940594f$exports.assign(y, y1);
    $af06462ea02ec4b1$export$13e2de3c33d99539(buffer);
}
$7f253147c04c82d1$exports = $7f253147c04c82d1$var$ndfft;


var $5597a2935beeb98a$exports = {};
'use strict';
function $5597a2935beeb98a$var$hann(i, N) {
    return 0.5 * (1 - Math.cos(6.283185307179586 * i / (N - 1)));
}
$5597a2935beeb98a$exports = $5597a2935beeb98a$var$hann;


function $049c1069fcbd3f88$var$square(x, y) {
    var n = x.length;
    for(var i = 0; i < n; ++i){
        var a = x[i], b = y[i];
        x[i] = a * a + b * b;
        y[i] = 0.0;
    }
}
function $049c1069fcbd3f88$var$prefilter(x, xf, n) {
    x[0] = 1;
    var s = 0;
    for(var i = 1; i < n; ++i){
        var d = Math.max(xf - x[i], 0.0);
        s += d;
        x[i] = d * i / s;
    }
}
function $049c1069fcbd3f88$var$aperiodic(x, n) {
    if (n <= 3) return true;
    var d = (x + 0.5 * n) % n - 0.5 * n;
    return Math.abs(d) > 1;
}
function $049c1069fcbd3f88$var$findPeriod(x, lo, hi, threshold) {
    var smallest = 1.0;
    var period = 0;
    for(var i = lo; i + 2 < hi; ++i){
        var y0 = x[i], y1 = x[i + 1], y2 = x[i + 2];
        var denom = y2 - 2.0 * y1 + y0;
        if (Math.abs(denom) < 1e-6) {
            if (y1 < smallest && $049c1069fcbd3f88$var$aperiodic(i + 1, period)) {
                smallest = y1;
                period = i + 1;
            }
        } else {
            var s = 0.5 * (y0 - y2) / denom;
            if (Math.abs(s) > 1.0) continue;
            var ymin = y1 + 0.25 * Math.pow(y0 - y2, 2) / denom;
            if (ymin < smallest) {
                var f0 = i + s + 1;
                if ($049c1069fcbd3f88$var$aperiodic(f0, period)) {
                    smallest = ymin;
                    period = f0;
                }
            }
        }
    }
    if (smallest < 1.0 - threshold) return period;
    return 0.0;
}
function $049c1069fcbd3f88$var$detectPitch(signal, threshold) {
    threshold = threshold || 0.0;
    var xs;
    if (signal.shape) xs = signal.shape[0];
    else xs = signal.length;
    var n = $aaceb971cbaa76bf$export$f0d90cf68bd426eb(2 * xs);
    var i, j, k;
    var re_arr = $af06462ea02ec4b1$export$d0434a350fe26016(n);
    var im_arr = $af06462ea02ec4b1$export$d0434a350fe26016(n);
    var X = $dff307a8ad5f5850$exports(re_arr, [
        n
    ], [
        1
    ], 0);
    var Y = $dff307a8ad5f5850$exports(im_arr, [
        n
    ], [
        1
    ], 0);
    //Initialize array depending on if it is a typed array
    if (signal.shape) $bd7058b3c940594f$exports.assign(X.hi(xs), signal);
    else re_arr.set(signal);
    //Compute magnitude
    var magnitude = 0.0;
    for(var i = 0; i < xs; ++i){
        var z = re_arr[i] *= $5597a2935beeb98a$exports(i, xs);
        magnitude += Math.pow(z, 2);
    }
    //Zero out arrays
    for(var i = xs; i < n; ++i)re_arr[i] = 0.0;
    for(var i = 0; i < n; ++i)im_arr[i] = 0.0;
    //Autocorrelate
    $7f253147c04c82d1$exports(1, X, Y);
    $049c1069fcbd3f88$var$square(re_arr, im_arr);
    $7f253147c04c82d1$exports(-1, X, Y);
    //Apply prefiltering
    $049c1069fcbd3f88$var$prefilter(re_arr, magnitude, xs);
    //Detect pitch
    var period = $049c1069fcbd3f88$var$findPeriod(re_arr, 0, xs >>> 1, threshold);
    //Free temporary arrays
    $af06462ea02ec4b1$export$faf8b381a7d1f026(re_arr);
    $af06462ea02ec4b1$export$faf8b381a7d1f026(im_arr);
    return period;
}
$049c1069fcbd3f88$exports = $049c1069fcbd3f88$var$detectPitch;


var $9dd82efbd05f8702$exports = {};
// loosely based on example code at https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
(function(root) {
    'use strict';
    /**
   * Error thrown when any required feature is missing (Promises, navigator, getUserMedia)
   * @constructor
   */ function NotSupportedError() {
        this.name = 'NotSupportedError';
        this.message = 'getUserMedia is not implemented in this browser';
    }
    NotSupportedError.prototype = Error.prototype;
    /**
   * Fake Promise instance that behaves like a Promise except that it always rejects with a NotSupportedError.
   * Used for situations where there is no global Promise constructor.
   *
   * The message will report that the getUserMedia API is not available.
   * This is technically true because every browser that supports getUserMedia also supports promises.
   **
   * @see http://caniuse.com/#feat=stream
   * @see http://caniuse.com/#feat=promises
   * @constructor
   */ function FakePromise() {
        // make it chainable like a real promise
        this.then = function() {
            return this;
        };
        // but always reject with an error
        var err = new NotSupportedError();
        this.catch = function(cb) {
            setTimeout(function() {
                cb(err);
            });
        };
    }
    var isPromiseSupported = typeof Promise !== 'undefined';
    // checks for root.navigator to enable server-side rendering of things that depend on this
    // (will need to be updated on client, but at least doesn't throw this way)
    var navigatorExists = typeof navigator !== "undefined";
    // gump = mondern promise-based interface
    // gum = old callback-based interface
    var gump = navigatorExists && navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
    var gum = navigatorExists && (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
    /**
   * Wrapper for navigator.mediaDevices.getUserMedia.
   * Always returns a Promise or Promise-like object, even in environments without a global Promise constructor
   *
   * @stream https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
   *
   * @param {Object} constraints - must include one or both of audio/video along with optional details for video
   * @param {Boolean} [constraints.audio] - include audio data in the stream
   * @param {Boolean|Object} [constraints.video] - include video data in the stream. May be a boolean or an object with additional constraints, see
   * @returns {Promise<MediaStream>} a promise that resolves to a MediaStream object
     */ function getUserMedia(constraints) {
        // ensure that Promises are supported and we have a navigator object
        if (!isPromiseSupported) return new FakePromise();
        // Try the more modern, promise-based MediaDevices API first
        //https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
        if (gump) return navigator.mediaDevices.getUserMedia(constraints);
        // fall back to the older method second, wrap it in a promise.
        return new Promise(function(resolve, reject) {
            // if navigator doesn't exist, then we can't use the getUserMedia API. (And probably aren't even in a browser.)
            // assuming it does, try getUserMedia and then all of the prefixed versions
            if (!gum) return reject(new NotSupportedError());
            gum.call(navigator, constraints, resolve, reject);
        });
    }
    getUserMedia.NotSupportedError = NotSupportedError;
    // eslint-disable-next-line no-implicit-coercion
    getUserMedia.isSupported = !!(isPromiseSupported && (gump || gum));
    // UMD, loosely based on https://github.com/umdjs/umd/blob/master/templates/returnExportsGlobal.js
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], function() {
        return getUserMedia;
    });
    else if ($9dd82efbd05f8702$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like enviroments that support module.exports,
    // like Node.
    $9dd82efbd05f8702$exports = getUserMedia;
    else {
        // Browser globals
        // polyfill the MediaDevices API if it does not exist.
        root.navigator || (root.navigator = {});
        root.navigator.mediaDevices || (root.navigator.mediaDevices = {});
        root.navigator.mediaDevices.getUserMedia || (root.navigator.mediaDevices.getUserMedia = getUserMedia);
    }
})($9dd82efbd05f8702$exports);


var $0d565b651cfab57f$exports = {};
"use strict";
var $0d565b651cfab57f$var$__extends = $0d565b651cfab57f$exports && $0d565b651cfab57f$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $0d565b651cfab57f$var$__importDefault = $0d565b651cfab57f$exports && $0d565b651cfab57f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0d565b651cfab57f$exports, "__esModule", {
    value: true
});

var $jDc6A = parcelRequire("jDc6A");

// some versions of the buffer browser lib don't support Buffer.from (such as the one included by the
// current version of express-browserify)
var $0d565b651cfab57f$var$buffer_from_1 = $0d565b651cfab57f$var$__importDefault((parcelRequire("kQFso")));
/**
 * Turns a MediaStream object (from getUserMedia) into a Node.js Readable stream
 * and optionally converts the audio to Buffers
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/getUserMedia
 */ var $0d565b651cfab57f$var$MicrophoneStream = /** @class */ function(_super) {
    $0d565b651cfab57f$var$__extends(MicrophoneStream, _super);
    /**
     * Turns a MediaStream object (from getUserMedia) into a Node.js Readable stream
     * and optionally converts the audio to Buffers
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/getUserMedia
     *
     * @param {Object} [opts] options
     * @param {MediaStream} [opts.stream] https://developer.mozilla.org/en-US/docs/Web/API/MediaStream - for iOS compatibility, it is recommended that you create the MicrophoneStream instance in response to the tap - before you have a MediaStream, and then later call setStream() with the MediaStream.
     * @param {Boolean} [opts.objectMode=false] Puts the stream into ObjectMode where it emits AudioBuffers instead of Buffers - see https://developer.mozilla.org/en-US/docs/Web/API/AudioBuffer
     * @param {Number|null} [opts.bufferSize=null] https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/createScriptProcessor
     * @param {AudioContext} [opts.context] - AudioContext - will be automatically created if not passed in
     * @constructor
     */ function MicrophoneStream(opts) {
        if (opts === void 0) opts = {
            objectMode: false
        };
        var _this = _super.call(this, {
            objectMode: opts.objectMode
        }) || this;
        _this.audioInput = null;
        _this.recording = true;
        var stream = opts.stream, objectMode = opts.objectMode, bufferSize = opts.bufferSize, context = opts.context;
        _this.objectMode = objectMode;
        // "It is recommended for authors to not specify this buffer size and allow the implementation
        // to pick a good buffer size to balance between latency and audio quality."
        // https://developer.mozilla.org/en-US/docs/Web/API/AudioContext/createScriptProcessor
        // however, webkitAudioContext (safari) requires it to be set'
        // Possible values: null, 256, 512, 1024, 2048, 4096, 8192, 16384
        _this.bufferSize = bufferSize || typeof window.AudioContext === "undefined" ? 4096 : null;
        // @ts-expect-error Property 'webkitAudioContext' does not exist on type 'Window & typeof globalThis'
        var AudioContext = window.AudioContext || window.webkitAudioContext;
        _this.context = context || new AudioContext();
        // We can only emit one channel's worth of audio, so only one input.
        // (Who has multiple microphones anyways?)
        var inputChannels = 1;
        // We shouldn't need any output channels (going back to the browser),
        // but chrome is buggy and won't give us any audio without one.
        var outputChannels = 1;
        _this.recorder = _this.context.createScriptProcessor(bufferSize, inputChannels, outputChannels);
        // Other half of workaround for chrome bugs.
        _this.recorder.connect(_this.context.destination);
        if (stream) _this.setStream(stream);
        setTimeout(function() {
            _this.emit("format", {
                channels: 1,
                bitDepth: 32,
                sampleRate: _this.context.sampleRate,
                signed: true,
                float: true
            });
        }, 0);
        return _this;
    }
    /**
     * Sets the MediaStream.
     *
     * This was separated from the constructor to enable better compatibility with Safari on iOS 11.
     *
     * Typically the stream is only available asynchronously, but the context must be created or
     * resumed directly in response to a user's tap on iOS.
     *
     * @param {MediaStream} stream https://developer.mozilla.org/en-US/docs/Web/API/MediaStream
     * @type {function(MediaStream): void}
     */ MicrophoneStream.prototype.setStream = function(stream) {
        var _this = this;
        this.stream = stream;
        this.audioInput = this.context.createMediaStreamSource(stream);
        this.audioInput.connect(this.recorder);
        /**
         * Convert and emit the raw audio data
         * @see https://developer.mozilla.org/en-US/docs/Web/API/ScriptProcessorNode/onaudioprocess
         * @param {AudioProcessingEvent} e https://developer.mozilla.org/en-US/docs/Web/API/AudioProcessingEvent
         */ var recorderProcess = function(e) {
            // onaudioprocess can be called at least once after we've stopped
            if (_this.recording) _this.push(_this.objectMode ? e.inputBuffer : $0d565b651cfab57f$var$buffer_from_1.default(e.inputBuffer.getChannelData(0).buffer));
        };
        this.recorder.onaudioprocess = recorderProcess;
    };
    /**
     * Temporarily stop emitting new data. Audio data recieved from the microphone
     * after this will be dropped.
     *
     * Note: the underlying Stream interface has a .pause() API that causes new data
     * to bebuffered rather than dropped.
     */ MicrophoneStream.prototype.pauseRecording = function() {
        this.recording = false;
    };
    /**
     * Resume emitting new audio data after pauseRecording() was called.
     */ MicrophoneStream.prototype.playRecording = function() {
        this.recording = true;
    };
    /**
     * Stops the recording.
     *
     * Note: Some versions of Firefox leave the recording icon in place after recording has stopped.
     */ MicrophoneStream.prototype.stop = function() {
        if (this.context.state === "closed") return;
        try {
            this.stream.getTracks()[0].stop();
        } catch (ex) {
        // This fails in some older versions of chrome. Nothing we can do about it.
        }
        this.recorder.disconnect();
        if (this.audioInput) this.audioInput.disconnect();
        try {
            this.context.close(); // returns a promise;
        } catch (ex) {
        // this can also fail in older versions of chrome
        }
        this.recording = false;
        this.push(null);
        this.emit("close");
    };
    /**
     * no-op, (flow-control doesn't really work on live audio)
     */ MicrophoneStream.prototype._read = function() {
    // no-op, (flow-control doesn't really work on live audio)
    };
    /**
     * Converts a Buffer back into the raw Float32Array format that browsers use.
     * Note: this is just a new DataView for the same underlying buffer -
     * the actual audio data is not copied or changed here.
     *
     * @memberof MicrophoneStream
     * @param {Buffer} chunk node-style buffer of audio data from a 'data' event or read() call
     * @return {Float32Array} raw 32-bit float data view of audio data
     */ MicrophoneStream.toRaw = function(chunk) {
        return new Float32Array(chunk.buffer);
    };
    return MicrophoneStream;
}($jDc6A.Readable);
$0d565b651cfab57f$exports.default = $0d565b651cfab57f$var$MicrophoneStream;



var $jN9B6 = parcelRequire("jN9B6");
var $adcf363a09f534a1$var$version = "0.3.1", $adcf363a09f534a1$var$classCallCheck = function(e, o) {
    if (!(e instanceof o)) throw new TypeError("Cannot call a class as a function");
}, $adcf363a09f534a1$var$createClass = function() {
    function e(e, o) {
        for(var t = 0; t < o.length; t++){
            var i = o[t];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
        }
    }
    return function(o, t, i) {
        return t && e(o.prototype, t), i && e(o, i), o;
    };
}(), $adcf363a09f534a1$var$toConsumableArray = function(e) {
    if (Array.isArray(e)) {
        for(var o = 0, t = Array(e.length); o < e.length; o++)t[o] = e[o];
        return t;
    }
    return Array.from(e);
}, $adcf363a09f534a1$var$MicroModal = function() {
    var e = [
        "a[href]",
        "area[href]",
        'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
        "select:not([disabled]):not([aria-hidden])",
        "textarea:not([disabled]):not([aria-hidden])",
        "button:not([disabled]):not([aria-hidden])",
        "iframe",
        "object",
        "embed",
        "[contenteditable]",
        '[tabindex]:not([tabindex^="-"])'
    ], o = function() {
        function o(e) {
            var t = e.targetModal, i = e.triggers, n = void 0 === i ? [] : i, a = e.onShow, r = void 0 === a ? function() {} : a, s = e.onClose, l = void 0 === s ? function() {} : s, c = e.openTrigger, d = void 0 === c ? "data-micromodal-trigger" : c, u = e.closeTrigger, h = void 0 === u ? "data-micromodal-close" : u, f = e.disableScroll, v = void 0 !== f && f, g = e.disableFocus, m = void 0 !== g && g, b = e.awaitCloseAnimation, y = void 0 !== b && b, k = e.debugMode, w = void 0 !== k && k;
            $adcf363a09f534a1$var$classCallCheck(this, o), this.modal = document.getElementById(t), this.config = {
                debugMode: w,
                disableScroll: v,
                openTrigger: d,
                closeTrigger: h,
                onShow: r,
                onClose: l,
                awaitCloseAnimation: y,
                disableFocus: m
            }, n.length > 0 && this.registerTriggers.apply(this, $adcf363a09f534a1$var$toConsumableArray(n)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this);
        }
        return $adcf363a09f534a1$var$createClass(o, [
            {
                key: "registerTriggers",
                value: function() {
                    for(var e = this, o = arguments.length, t = Array(o), i = 0; i < o; i++)t[i] = arguments[i];
                    t.forEach(function(o) {
                        o.addEventListener("click", function() {
                            return e.showModal();
                        });
                    });
                }
            },
            {
                key: "showModal",
                value: function() {
                    this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add("is-open"), this.setFocusToFirstNode(), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.onShow(this.modal);
                }
            },
            {
                key: "closeModal",
                value: function() {
                    var e = this.modal;
                    this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement.focus(), this.config.onClose(this.modal), this.config.awaitCloseAnimation ? this.modal.addEventListener("animationend", function o() {
                        e.classList.remove("is-open"), e.removeEventListener("animationend", o, !1);
                    }, !1) : e.classList.remove("is-open");
                }
            },
            {
                key: "scrollBehaviour",
                value: function(e) {
                    if (this.config.disableScroll) {
                        var o = document.querySelector("body");
                        switch(e){
                            case "enable":
                                Object.assign(o.style, {
                                    overflow: "initial",
                                    height: "initial"
                                });
                                break;
                            case "disable":
                                Object.assign(o.style, {
                                    overflow: "hidden",
                                    height: "100vh"
                                });
                        }
                    }
                }
            },
            {
                key: "addEventListeners",
                value: function() {
                    this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
                }
            },
            {
                key: "removeEventListeners",
                value: function() {
                    this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
                }
            },
            {
                key: "onClick",
                value: function(e) {
                    e.target.hasAttribute(this.config.closeTrigger) && (this.closeModal(), e.preventDefault());
                }
            },
            {
                key: "onKeydown",
                value: function(e) {
                    27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.maintainFocus(e);
                }
            },
            {
                key: "getFocusableNodes",
                value: function() {
                    var o = this.modal.querySelectorAll(e);
                    return Object.keys(o).map(function(e) {
                        return o[e];
                    });
                }
            },
            {
                key: "setFocusToFirstNode",
                value: function() {
                    if (!this.config.disableFocus) {
                        var e = this.getFocusableNodes();
                        e.length && e[0].focus();
                    }
                }
            },
            {
                key: "maintainFocus",
                value: function(e) {
                    var o = this.getFocusableNodes();
                    if (this.modal.contains(document.activeElement)) {
                        var t = o.indexOf(document.activeElement);
                        e.shiftKey && 0 === t && (o[o.length - 1].focus(), e.preventDefault()), e.shiftKey || t !== o.length - 1 || (o[0].focus(), e.preventDefault());
                    } else o[0].focus();
                }
            }
        ]), o;
    }(), t = null, i = function(e, o) {
        var t = [];
        return e.forEach(function(e) {
            var i = e.attributes[o].value;
            void 0 === t[i] && (t[i] = []), t[i].push(e);
        }), t;
    }, n = function(e) {
        if (!document.getElementById(e)) return console.warn("MicroModal v" + $adcf363a09f534a1$var$version + ": \u2757Seems like you have missed %c'" + e + "'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="' + e + '"></div>'), !1;
    }, a = function(e) {
        if (e.length <= 0) return console.warn("MicroModal v" + $adcf363a09f534a1$var$version + ": \u2757Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'), !1;
    }, r = function(e, o) {
        if (a(e), !o) return !0;
        for(var t in o)n(t);
        return !0;
    };
    return {
        init: function(e) {
            var t = Object.assign({}, {
                openTrigger: "data-micromodal-trigger"
            }, e), n = [].concat($adcf363a09f534a1$var$toConsumableArray(document.querySelectorAll("[" + t.openTrigger + "]"))), a = i(n, t.openTrigger);
            if (!0 !== t.debugMode || !1 !== r(n, a)) for(var s in a){
                var l = a[s];
                t.targetModal = s, t.triggers = [].concat($adcf363a09f534a1$var$toConsumableArray(l)), new o(t);
            }
        },
        show: function(e, i) {
            var a = i || {};
            a.targetModal = e, !0 === a.debugMode && !1 === n(e) || (t = new o(a)).showModal();
        },
        close: function() {
            t.closeModal();
        }
    };
}();
var $adcf363a09f534a1$export$2e2bcd8739ae039 = $adcf363a09f534a1$var$MicroModal;


var $a4d5bda870f39a89$exports = {};

/*!
 * /*! shepherd.js 2.0.0-beta.17 * /
 * 
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $a4d5bda870f39a89$exports = factory((parcelRequire("kJWRP")));
})($a4d5bda870f39a89$exports, function(__WEBPACK_EXTERNAL_MODULE__42__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== 'undefined' && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: 'Module'
            });
            /******/ Object.defineProperty(exports, '__esModule', {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, 'default', {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != 'string') for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 13);
    /******/ }([
        /* 0 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function isUndefined(value) {
                return value === undefined;
            }
            module1.exports = isUndefined;
        /***/ },
        /* 1 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
                return value != null && typeof value == 'object';
            }
            module1.exports = isObjectLike;
        /***/ },
        /* 2 */ /***/ function(module1, exports) {
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
            /**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
                return nativeObjectToString.call(value);
            }
            module1.exports = objectToString;
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.Evented = undefined;
            var _drop2 = __webpack_require__(14);
            var _drop3 = _interopRequireDefault(_drop2);
            var _isUndefined2 = __webpack_require__(0);
            var _isUndefined3 = _interopRequireDefault(_isUndefined2);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var Evented = exports.Evented = function() {
                function Evented() {
                    _classCallCheck(this, Evented);
                }
                _createClass(Evented, [
                    {
                        key: 'on',
                        value: function on(event, handler, ctx) {
                            var once = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
                            if ((0, _isUndefined3.default)(this.bindings)) this.bindings = {};
                            if ((0, _isUndefined3.default)(this.bindings[event])) this.bindings[event] = [];
                            this.bindings[event].push({
                                handler: handler,
                                ctx: ctx,
                                once: once
                            });
                        }
                    },
                    {
                        key: 'once',
                        value: function once(event, handler, ctx) {
                            this.on(event, handler, ctx, true);
                        }
                    },
                    {
                        key: 'off',
                        value: function off(event, handler) {
                            var _this = this;
                            if ((0, _isUndefined3.default)(this.bindings) || (0, _isUndefined3.default)(this.bindings[event])) return false;
                            if ((0, _isUndefined3.default)(handler)) delete this.bindings[event];
                            else this.bindings[event].forEach(function(binding, index) {
                                if (binding.handler === handler) _this.bindings[event].splice(index, 1);
                            });
                        }
                    },
                    {
                        key: 'trigger',
                        value: function trigger(event) {
                            var _this2 = this;
                            if (!(0, _isUndefined3.default)(this.bindings) && this.bindings[event]) {
                                var args = (0, _drop3.default)(arguments);
                                this.bindings[event].forEach(function(binding, index) {
                                    var ctx = binding.ctx, handler = binding.handler, once = binding.once;
                                    var context = ctx || _this2;
                                    handler.apply(context, args);
                                    if (once) _this2.bindings[event].splice(index, 1);
                                });
                            }
                        }
                    }
                ]);
                return Evented;
            }();
        /***/ },
        /* 4 */ /***/ function(module1, exports) {
            /**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
                return function(arg) {
                    return func(transform(arg));
                };
            }
            module1.exports = overArg;
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(2), isArray = __webpack_require__(9), isObjectLike = __webpack_require__(1);
            /** `Object#toString` result references. */ var stringTag = '[object String]';
            /**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
                return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
            }
            module1.exports = isString;
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.Step = undefined;
            var _isElement2 = __webpack_require__(17);
            var _isElement3 = _interopRequireDefault(_isElement2);
            var _forOwn2 = __webpack_require__(8);
            var _forOwn3 = _interopRequireDefault(_forOwn2);
            var _isPlainObject2 = __webpack_require__(7);
            var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
            var _isEmpty2 = __webpack_require__(24);
            var _isEmpty3 = _interopRequireDefault(_isEmpty2);
            var _isUndefined2 = __webpack_require__(0);
            var _isUndefined3 = _interopRequireDefault(_isUndefined2);
            var _isString2 = __webpack_require__(5);
            var _isString3 = _interopRequireDefault(_isString2);
            var _isFunction2 = __webpack_require__(10);
            var _isFunction3 = _interopRequireDefault(_isFunction2);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _evented = __webpack_require__(3);
            __webpack_require__(34);
            var _bind = __webpack_require__(11);
            var _utils = __webpack_require__(12);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Creates incremented ID for each newly created step
 *
 * @private
 * @returns {Number}
 */ var uniqueId = function() {
                var id = 0;
                return function() {
                    return ++id;
                };
            }();
            var Step = exports.Step = function(_Evented) {
                _inherits(Step, _Evented);
                function Step(tour, options) {
                    var _ret;
                    _classCallCheck(this, Step);
                    var _this = _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).call(this, tour, options));
                    _this.tour = tour;
                    _bind.bindMethods.call(_this, [
                        '_show',
                        'cancel',
                        'complete',
                        'destroy',
                        'hide',
                        'isOpen',
                        'render',
                        'scrollTo',
                        'show'
                    ]);
                    _this.setOptions(options);
                    _this.bindAdvance = _bind.bindAdvance.bind(_this);
                    _this.bindButtonEvents = _bind.bindButtonEvents.bind(_this);
                    _this.bindCancelLink = _bind.bindCancelLink.bind(_this);
                    _this.setupPopper = _utils.setupPopper.bind(_this);
                    return _ret = _this, _possibleConstructorReturn(_this, _ret);
                }
                /**
   * Adds buttons to the step as passed into options
   *
   * @private
   * @param {HTMLElement}
   */ _createClass(Step, [
                    {
                        key: '_addButtons',
                        value: function _addButtons(content) {
                            var _this2 = this;
                            if (this.options.buttons) {
                                var footer = document.createElement('footer');
                                var buttons = (0, _utils.createFromHTML)('<ul class="shepherd-buttons"></ul>');
                                this.options.buttons.map(function(cfg) {
                                    var button = (0, _utils.createFromHTML)('<li><a class="shepherd-button ' + (cfg.classes || '') + '">' + cfg.text + '</a>');
                                    buttons.appendChild(button);
                                    _this2.bindButtonEvents(cfg, button.querySelector('a'));
                                });
                                footer.appendChild(buttons);
                                content.appendChild(footer);
                            }
                        }
                    },
                    {
                        key: '_addCancelLink',
                        value: function _addCancelLink(element, header) {
                            if (this.options.showCancelLink) {
                                var link = (0, _utils.createFromHTML)('<a href class="shepherd-cancel-link"></a>');
                                header.appendChild(link);
                                element.classList.add('shepherd-has-cancel-link');
                                this.bindCancelLink(link);
                            }
                        }
                    },
                    {
                        key: '_addContent',
                        value: function _addContent(content) {
                            var text = (0, _utils.createFromHTML)('<div class="shepherd-text"></div>');
                            var paragraphs = this.options.text;
                            if ((0, _isFunction3.default)(paragraphs)) paragraphs = paragraphs.call(this, text);
                            if (paragraphs instanceof HTMLElement) text.appendChild(paragraphs);
                            else {
                                if ((0, _isString3.default)(paragraphs)) paragraphs = [
                                    paragraphs
                                ];
                                paragraphs.map(function(paragraph) {
                                    text.innerHTML += '<p>' + paragraph + '</p>';
                                });
                            }
                            content.appendChild(text);
                        }
                    },
                    {
                        key: '_attach',
                        value: function _attach(element) {
                            var renderLocation = this.options.renderLocation;
                            if (renderLocation) {
                                if (renderLocation instanceof HTMLElement) return renderLocation.appendChild(element);
                                if ((0, _isString3.default)(renderLocation)) return document.querySelector(renderLocation).appendChild(element);
                            }
                            return document.body.appendChild(element);
                        }
                    },
                    {
                        key: '_createElement',
                        value: function _createElement() {
                            var content = document.createElement('div');
                            var classes = this.options.classes || '';
                            var element = (0, _utils.createFromHTML)('<div class=\'' + classes + '\' data-id=\'' + this.id + '\' id="' + this.options.idAttribute + '"}>');
                            var header = document.createElement('header');
                            content.classList.add('shepherd-content');
                            element.appendChild(content);
                            content.appendChild(header);
                            if (this.options.attachTo) element.appendChild((0, _utils.createFromHTML)('<div class="popper__arrow" x-arrow></div>'));
                            if (!(0, _isUndefined3.default)(this.options.text)) this._addContent(content);
                            this._addButtons(content);
                            this._addCancelLink(element, header);
                            if (this.options.title) {
                                header.innerHTML += '<h3 class="shepherd-title">' + this.options.title + '</h3>';
                                element.classList.add('shepherd-has-title');
                            }
                            return element;
                        }
                    },
                    {
                        key: '_setUpButtons',
                        value: function _setUpButtons() {
                            var buttons = this.options.buttons;
                            if (!buttons) return;
                            var buttonsAreDefault = (0, _isUndefined3.default)(buttons) || (0, _isEmpty3.default)(buttons);
                            if (buttonsAreDefault) return this.options.buttons = [
                                {
                                    text: 'Next',
                                    action: this.tour.next,
                                    classes: 'btn'
                                }
                            ];
                            var buttonsAreObject = (0, _isPlainObject3.default)(buttons);
                            // Can pass in an object which will assume a single button
                            if (buttonsAreObject) return this.options.buttons = [
                                this.options.buttons
                            ];
                            return buttons;
                        }
                    },
                    {
                        key: 'getTour',
                        value: function getTour() {
                            return this.tour;
                        }
                    },
                    {
                        key: 'getAttachTo',
                        value: function getAttachTo() {
                            var opts = (0, _utils.parsePosition)(this.options.attachTo) || {};
                            var returnOpts = Object.assign({}, opts);
                            if ((0, _isString3.default)(opts.element)) {
                                // Can't override the element in user opts reference because we can't
                                // guarantee that the element will exist in the future.
                                try {
                                    returnOpts.element = document.querySelector(opts.element);
                                } catch (e) {
                                // TODO
                                }
                                if (!returnOpts.element) console.error('The element for this Shepherd step was not found ' + opts.element);
                            }
                            return returnOpts;
                        }
                    },
                    {
                        key: 'setOptions',
                        value: function setOptions() {
                            var _this3 = this;
                            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            this.options = options;
                            var when = this.options.when;
                            this.destroy();
                            this.id = this.options.id || this.id || 'step-' + uniqueId();
                            (0, _forOwn3.default)(when, function(handler, event) {
                                _this3.on(event, handler, _this3);
                            });
                            this._setUpButtons();
                        }
                    },
                    {
                        key: 'show',
                        value: function show() {
                            var _this4 = this;
                            if ((0, _isFunction3.default)(this.options.beforeShowPromise)) {
                                var beforeShowPromise = this.options.beforeShowPromise();
                                if (!(0, _isUndefined3.default)(beforeShowPromise)) return beforeShowPromise.then(function() {
                                    return _this4._show();
                                });
                            }
                            this._show();
                        }
                    },
                    {
                        key: '_show',
                        value: function _show() {
                            var _this5 = this;
                            this.trigger('before-show');
                            if (!this.el) this.render();
                            this.el.hidden = false;
                            // We need to manually set styles for < IE11 support
                            this.el.style.display = 'block';
                            document.body.setAttribute('data-shepherd-step', this.id);
                            this.setupPopper();
                            if (this.options.scrollTo) setTimeout(function() {
                                _this5.scrollTo();
                            });
                            this.trigger('show');
                        }
                    },
                    {
                        key: 'hide',
                        value: function hide() {
                            this.trigger('before-hide');
                            if (this.el) {
                                this.el.hidden = true;
                                // We need to manually set styles for < IE11 support
                                this.el.style.display = 'none';
                            }
                            document.body.removeAttribute('data-shepherd-step');
                            if (this.target) this.target.classList.remove('shepherd-enabled', 'shepherd-target');
                            if (this.popper) this.popper.destroy();
                            this.popper = null;
                            this.trigger('hide');
                        }
                    },
                    {
                        key: 'isOpen',
                        value: function isOpen() {
                            return this.el && !this.el.hidden;
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            this.tour.cancel();
                            this.trigger('cancel');
                        }
                    },
                    {
                        key: 'complete',
                        value: function complete() {
                            this.tour.complete();
                            this.trigger('complete');
                        }
                    },
                    {
                        key: 'scrollTo',
                        value: function scrollTo() {
                            var _getAttachTo = this.getAttachTo(), element = _getAttachTo.element;
                            if ((0, _isFunction3.default)(this.options.scrollToHandler)) this.options.scrollToHandler(element);
                            else if ((0, _isElement3.default)(element)) element.scrollIntoView();
                        }
                    },
                    {
                        key: 'destroy',
                        value: function destroy() {
                            if ((0, _isElement3.default)(this.el) && this.el.parentNode) {
                                this.el.parentNode.removeChild(this.el);
                                delete this.el;
                            }
                            if (this.popper) this.popper.destroy();
                            this.popper = null;
                            this.trigger('destroy');
                        }
                    },
                    {
                        key: 'render',
                        value: function render() {
                            if (!(0, _isUndefined3.default)(this.el)) this.destroy();
                            this.el = this._createElement();
                            if (this.options.advanceOn) this.bindAdvance();
                            this._attach(this.el);
                            this.setupPopper();
                        }
                    }
                ]);
                return Step;
            }(_evented.Evented);
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(2), getPrototype = __webpack_require__(18), isObjectLike = __webpack_require__(1);
            /** `Object#toString` result references. */ var objectTag = '[object Object]';
            /** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
            /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
            /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
            /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
            /**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
                if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
                var proto = getPrototype(value);
                if (proto === null) return true;
                var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
            }
            module1.exports = isPlainObject;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            var baseForOwn = __webpack_require__(19), castFunction = __webpack_require__(23);
            /**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function forOwn(object, iteratee) {
                return object && baseForOwn(object, castFunction(iteratee));
            }
            module1.exports = forOwn;
        /***/ },
        /* 9 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
            module1.exports = isArray;
        /***/ },
        /* 10 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(2), isObject = __webpack_require__(29);
            /** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
            /**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
                if (!isObject(value)) return false;
                // The use of `Object#toString` avoids issues with the `typeof` operator
                // in Safari 9 which returns 'object' for typed arrays and other constructors.
                var tag = baseGetTag(value);
                return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
            }
            module1.exports = isFunction;
        /***/ },
        /* 11 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _isString2 = __webpack_require__(5);
            var _isString3 = _interopRequireDefault(_isString2);
            var _forOwn2 = __webpack_require__(8);
            var _forOwn3 = _interopRequireDefault(_forOwn2);
            var _isUndefined2 = __webpack_require__(0);
            var _isUndefined3 = _interopRequireDefault(_isUndefined2);
            exports.bindAdvance = bindAdvance;
            exports.bindButtonEvents = bindButtonEvents;
            exports.bindCancelLink = bindCancelLink;
            exports.bindMethods = bindMethods;
            var _utils = __webpack_require__(12);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * Sets up the handler to determine if we should advance the tour
 * @private
 */ function _setupAdvanceOnHandler(selector) {
                var _this = this;
                return function(e) {
                    if (_this.isOpen()) {
                        var targetIsEl = _this.el && e.target === _this.el;
                        var targetIsSelector = !(0, _isUndefined3.default)(selector) && e.target.matches(selector);
                        if (targetIsSelector || targetIsEl) _this.tour.next();
                    }
                };
            }
            /**
 * Bind the event handler for advanceOn
 */ function bindAdvance() {
                // An empty selector matches the step element
                var _parseShorthand = (0, _utils.parseShorthand)(this.options.advanceOn, [
                    'selector',
                    'event'
                ]), event = _parseShorthand.event, selector = _parseShorthand.selector;
                var handler = _setupAdvanceOnHandler.call(this, selector);
                // TODO: this should also bind/unbind on show/hide
                if (!(0, _isUndefined3.default)(selector)) {
                    var el = document.querySelector(selector);
                    el.addEventListener(event, handler);
                } else document.body.addEventListener(event, handler);
                this.on('destroy', function() {
                    return document.body.removeEventListener(event, handler);
                });
            }
            /**
 * Bind events to the buttons for next, back, etc
 * @param {Object} cfg An object containing the config options for the button
 * @param {HTMLElement} el The element for the button
 */ function bindButtonEvents(cfg, el) {
                var _this2 = this;
                cfg.events = cfg.events || {};
                if (!(0, _isUndefined3.default)(cfg.action)) // Including both a click event and an action is not supported
                cfg.events.click = cfg.action;
                (0, _forOwn3.default)(cfg.events, function(handler, event) {
                    if ((0, _isString3.default)(handler)) {
                        var page = handler;
                        handler = function handler() {
                            return _this2.tour.show(page);
                        };
                    }
                    el.dataset.buttonEvent = true;
                    el.addEventListener(event, handler);
                    // Cleanup event listeners on destroy
                    _this2.on('destroy', function() {
                        el.removeAttribute('data-button-event');
                        el.removeEventListener(event, handler);
                    });
                });
            }
            /**
 * Add a click listener to the cancel link that cancels the tour
 * @param {HTMLElement} link The cancel link element
 */ function bindCancelLink(link) {
                var _this3 = this;
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    _this3.cancel();
                });
            }
            /**
 * Take an array of strings and look up methods by name, then bind them to `this`
 * @param {[String]} methods The names of methods to bind
 */ function bindMethods(methods) {
                var _this4 = this;
                methods.map(function(method) {
                    _this4[method] = _this4[method].bind(_this4);
                });
            }
        /***/ },
        /* 12 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _zipObject2 = __webpack_require__(35);
            var _zipObject3 = _interopRequireDefault(_zipObject2);
            var _isUndefined2 = __webpack_require__(0);
            var _isUndefined3 = _interopRequireDefault(_isUndefined2);
            var _isObjectLike2 = __webpack_require__(1);
            var _isObjectLike3 = _interopRequireDefault(_isObjectLike2);
            exports.createFromHTML = createFromHTML;
            exports.parsePosition = parsePosition;
            exports.parseShorthand = parseShorthand;
            exports.setupPopper = setupPopper;
            var _popper = __webpack_require__(42);
            var _popper2 = _interopRequireDefault(_popper);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            /**
 * TODO rewrite the way items are being added to use more performant documentFragment code
 * @param html
 * @returns {HTMLElement}
 */ function createFromHTML(html) {
                var el = document.createElement('div');
                el.innerHTML = html;
                return el.children[0];
            }
            /**
 * Parse the position object or string to return the attachment and element to attach to
 * @param {Object|String} position Either a string or object denoting the selector and position for attachment
 * @returns {Object}
 */ function parsePosition(position) {
                if ((0, _isObjectLike3.default)(position)) {
                    if (position.hasOwnProperty('element') && position.hasOwnProperty('on')) return position;
                    return null;
                }
                var positionRe = /^(.+) (top|left|right|bottom|center)$/;
                var matches = positionRe.exec(position);
                if (!matches) return null;
                return {
                    element: matches[1],
                    on: matches[2]
                };
            }
            /**
 * @param obj
 * @param {Array} props
 * @returns {*}
 */ function parseShorthand(obj, props) {
                if (obj === null || (0, _isUndefined3.default)(obj)) return obj;
                else if ((0, _isObjectLike3.default)(obj)) return obj;
                var values = obj.split(' ');
                return (0, _zipObject3.default)(props, values);
            }
            /**
 * Determines options for Popper and initializes the Popper instance
 */ function setupPopper() {
                if ((0, _isUndefined3.default)(_popper2.default)) throw new Error('Using the attachment feature of Shepherd requires the Popper.js library');
                var opts = this.getAttachTo();
                opts.modifiers = opts.modifiers || {};
                var attachment = opts.on || 'right';
                opts.positionFixed = false;
                if ((0, _isUndefined3.default)(opts.element)) {
                    attachment = 'top';
                    _setupCenteredPopper(opts);
                }
                var popperOpts = Object.assign({}, {
                    placement: attachment,
                    arrowElement: this.el.querySelector('.popper__arrow'),
                    modifiers: opts.modifiers,
                    positionFixed: opts.positionFixed
                }, this.options.popperOptions);
                if (this.popper) this.popper.destroy();
                this.el.classList.add('shepherd-element');
                this.popper = new _popper2.default(opts.element, this.el, popperOpts);
                this.target = opts.element;
                this.target.classList.add('shepherd-enabled', 'shepherd-target');
            }
            /**
 * Sets up a popper centered on the screen, when there is no attachTo element
 * @param {Object} opts The config object
 * @returns {*}
 * @private
 */ function _setupCenteredPopper(opts) {
                opts.element = document.body;
                opts.modifiers = Object.assign({
                    computeStyle: {
                        enabled: true,
                        fn: function fn(data) {
                            data.styles = Object.assign({}, data.styles, {
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -50%)'
                            });
                            return data;
                        }
                    }
                }, opts.modifiers);
                opts.positionFixed = true;
            }
        /***/ },
        /* 13 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _evented = __webpack_require__(3);
            var _step = __webpack_require__(6);
            var _tour = __webpack_require__(43);
            Object.assign(_tour.Shepherd, {
                Tour: _tour.Tour,
                Step: _step.Step,
                Evented: _evented.Evented
            });
            exports.default = _tour.Shepherd;
            module1.exports = exports['default'];
        /***/ },
        /* 14 */ /***/ function(module1, exports, __webpack_require__) {
            var baseSlice = __webpack_require__(15), toInteger = __webpack_require__(16);
            /**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */ function drop(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            module1.exports = drop;
        /***/ },
        /* 15 */ /***/ function(module1, exports) {
            /**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
                var index = -1, length = array.length;
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end > length ? length : end;
                if (end < 0) end += length;
                length = start > end ? 0 : end - start >>> 0;
                start >>>= 0;
                var result = Array(length);
                while(++index < length)result[index] = array[index + start];
                return result;
            }
            module1.exports = baseSlice;
        /***/ },
        /* 16 */ /***/ function(module1, exports) {
            /**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
                return value;
            }
            module1.exports = identity;
        /***/ },
        /* 17 */ /***/ function(module1, exports, __webpack_require__) {
            var isObjectLike = __webpack_require__(1), isPlainObject = __webpack_require__(7);
            /**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */ function isElement(value) {
                return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
            }
            module1.exports = isElement;
        /***/ },
        /* 18 */ /***/ function(module1, exports, __webpack_require__) {
            var overArg = __webpack_require__(4);
            /** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
            module1.exports = getPrototype;
        /***/ },
        /* 19 */ /***/ function(module1, exports, __webpack_require__) {
            var baseFor = __webpack_require__(20), keys = __webpack_require__(22);
            /**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
                return object && baseFor(object, iteratee, keys);
            }
            module1.exports = baseForOwn;
        /***/ },
        /* 20 */ /***/ function(module1, exports, __webpack_require__) {
            var createBaseFor = __webpack_require__(21);
            /**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
            module1.exports = baseFor;
        /***/ },
        /* 21 */ /***/ function(module1, exports) {
            /**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
                return function(object, iteratee, keysFunc) {
                    var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
                    while(length--){
                        var key = props[fromRight ? length : ++index];
                        if (iteratee(iterable[key], key, iterable) === false) break;
                    }
                    return object;
                };
            }
            module1.exports = createBaseFor;
        /***/ },
        /* 22 */ /***/ function(module1, exports, __webpack_require__) {
            var overArg = __webpack_require__(4);
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
            module1.exports = nativeKeys;
        /***/ },
        /* 23 */ /***/ function(module1, exports) {
            /**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
                return value;
            }
            module1.exports = identity;
        /***/ },
        /* 24 */ /***/ function(module1, exports, __webpack_require__) {
            var baseKeys = __webpack_require__(25), getTag = __webpack_require__(26), isArguments = __webpack_require__(27), isArray = __webpack_require__(9), isArrayLike = __webpack_require__(28), isBuffer = __webpack_require__(31), isPrototype = __webpack_require__(32), isTypedArray = __webpack_require__(33);
            /** `Object#toString` result references. */ var mapTag = '[object Map]', setTag = '[object Set]';
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
            /**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
                if (value == null) return true;
                if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
                var tag = getTag(value);
                if (tag == mapTag || tag == setTag) return !value.size;
                if (isPrototype(value)) return !baseKeys(value).length;
                for(var key in value){
                    if (hasOwnProperty.call(value, key)) return false;
                }
                return true;
            }
            module1.exports = isEmpty;
        /***/ },
        /* 25 */ /***/ function(module1, exports, __webpack_require__) {
            var overArg = __webpack_require__(4);
            /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
            module1.exports = nativeKeys;
        /***/ },
        /* 26 */ /***/ function(module1, exports) {
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
            /**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
                return nativeObjectToString.call(value);
            }
            module1.exports = objectToString;
        /***/ },
        /* 27 */ /***/ function(module1, exports) {
            /**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
                return false;
            }
            module1.exports = stubFalse;
        /***/ },
        /* 28 */ /***/ function(module1, exports, __webpack_require__) {
            var isFunction = __webpack_require__(10), isLength = __webpack_require__(30);
            /**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
                return value != null && isLength(value.length) && !isFunction(value);
            }
            module1.exports = isArrayLike;
        /***/ },
        /* 29 */ /***/ function(module1, exports) {
            /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
                var type = typeof value;
                return value != null && (type == 'object' || type == 'function');
            }
            module1.exports = isObject;
        /***/ },
        /* 30 */ /***/ function(module1, exports) {
            /** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
            /**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
                return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
            }
            module1.exports = isLength;
        /***/ },
        /* 31 */ /***/ function(module1, exports) {
            /**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
                return false;
            }
            module1.exports = stubFalse;
        /***/ },
        /* 32 */ /***/ function(module1, exports) {
            /**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
                return false;
            }
            module1.exports = stubFalse;
        /***/ },
        /* 33 */ /***/ function(module1, exports) {
            /**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
                return false;
            }
            module1.exports = stubFalse;
        /***/ },
        /* 34 */ /***/ function(module1, exports) {
            if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        /***/ },
        /* 35 */ /***/ function(module1, exports, __webpack_require__) {
            var assignValue = __webpack_require__(36), baseZipObject = __webpack_require__(41);
            /**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function zipObject(props, values) {
                return baseZipObject(props || [], values || [], assignValue);
            }
            module1.exports = zipObject;
        /***/ },
        /* 36 */ /***/ function(module1, exports, __webpack_require__) {
            var baseAssignValue = __webpack_require__(37), eq = __webpack_require__(40);
            /** Used for built-in method references. */ var objectProto = Object.prototype;
            /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
            /**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
                var objValue = object[key];
                if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            module1.exports = assignValue;
        /***/ },
        /* 37 */ /***/ function(module1, exports, __webpack_require__) {
            var defineProperty = __webpack_require__(38);
            /**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
                if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                    'configurable': true,
                    'enumerable': true,
                    'value': value,
                    'writable': true
                });
                else object[key] = value;
            }
            module1.exports = baseAssignValue;
        /***/ },
        /* 38 */ /***/ function(module1, exports, __webpack_require__) {
            var getNative = __webpack_require__(39);
            var defineProperty = function() {
                try {
                    var func = getNative(Object, 'defineProperty');
                    func({}, '', {});
                    return func;
                } catch (e) {}
            }();
            module1.exports = defineProperty;
        /***/ },
        /* 39 */ /***/ function(module1, exports) {
            /**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
                return object == null ? undefined : object[key];
            }
            module1.exports = getValue;
        /***/ },
        /* 40 */ /***/ function(module1, exports) {
            /**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
                return value === other || value !== value && other !== other;
            }
            module1.exports = eq;
        /***/ },
        /* 41 */ /***/ function(module1, exports) {
            /**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function baseZipObject(props, values, assignFunc) {
                var index = -1, length = props.length, valsLength = values.length, result = {};
                while(++index < length){
                    var value = index < valsLength ? values[index] : undefined;
                    assignFunc(result, props[index], value);
                }
                return result;
            }
            module1.exports = baseZipObject;
        /***/ },
        /* 42 */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE__42__;
        /***/ },
        /* 43 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.Shepherd = exports.Tour = undefined;
            var _isNumber2 = __webpack_require__(44);
            var _isNumber3 = _interopRequireDefault(_isNumber2);
            var _isString2 = __webpack_require__(5);
            var _isString3 = _interopRequireDefault(_isString2);
            var _isUndefined2 = __webpack_require__(0);
            var _isUndefined3 = _interopRequireDefault(_isUndefined2);
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _evented = __webpack_require__(3);
            var _step = __webpack_require__(6);
            var _bind = __webpack_require__(11);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            var Shepherd = new _evented.Evented();
            var Tour = exports.Tour = function(_Evented) {
                _inherits(Tour, _Evented);
                function Tour() {
                    var _ret;
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    _classCallCheck(this, Tour);
                    var _this = _possibleConstructorReturn(this, (Tour.__proto__ || Object.getPrototypeOf(Tour)).call(this, options));
                    _bind.bindMethods.call(_this, [
                        'back',
                        'cancel',
                        'complete',
                        'next'
                    ]);
                    _this.options = options;
                    _this.steps = _this.options.steps || [];
                    // Pass these events onto the global Shepherd object
                    var events = [
                        'active',
                        'cancel',
                        'complete',
                        'inactive',
                        'show',
                        'start'
                    ];
                    events.map(function(event) {
                        (function(e) {
                            _this.on(e, function(opts) {
                                opts = opts || {};
                                opts.tour = _this;
                                Shepherd.trigger(e, opts);
                            });
                        })(event);
                    });
                    return _ret = _this, _possibleConstructorReturn(_this, _ret);
                }
                /**
   * Adds a new step to the tour
   * @param {Object|Number|Step|String} arg1
   * When arg2 is defined, arg1 can either be a string or number, to use for the `id` for the step
   * When arg2 is undefined, arg1 is either an object containing step options or a Step instance
   * @param {Object|Step} arg2 An object containing step options or a Step instance
   * @returns {Step} The newly added step
   */ _createClass(Tour, [
                    {
                        key: 'addStep',
                        value: function addStep(arg1, arg2) {
                            var name = void 0, step = void 0;
                            // If we just have one argument, we can assume it is an object of step options, with an id
                            if ((0, _isUndefined3.default)(arg2)) step = arg1;
                            else {
                                name = arg1;
                                step = arg2;
                            }
                            if (!(step instanceof _step.Step)) step = this.setupStep(step, name);
                            else step.tour = this;
                            this.steps.push(step);
                            return step;
                        }
                    },
                    {
                        key: 'removeStep',
                        value: function removeStep(name) {
                            var _this2 = this;
                            var current = this.getCurrentStep();
                            // Find the step, destroy it and remove it from this.steps
                            this.steps.some(function(step, i) {
                                if (step.id === name) {
                                    if (step.isOpen()) step.hide();
                                    step.destroy();
                                    _this2.steps.splice(i, 1);
                                    return true;
                                }
                            });
                            if (current && current.id === name) {
                                this.currentStep = undefined;
                                // If we have steps left, show the first one, otherwise just cancel the tour
                                this.steps.length ? this.show(0) : this.cancel();
                            }
                        }
                    },
                    {
                        key: 'setupStep',
                        value: function setupStep(stepOptions, name) {
                            if ((0, _isString3.default)(name) || (0, _isNumber3.default)(name)) stepOptions.id = name.toString();
                            stepOptions = Object.assign({}, this.options.defaults, stepOptions);
                            return new _step.Step(this, stepOptions);
                        }
                    },
                    {
                        key: 'getById',
                        value: function getById(id) {
                            for(var i = 0; i < this.steps.length; ++i){
                                var step = this.steps[i];
                                if (step.id === id) return step;
                            }
                        }
                    },
                    {
                        key: 'getCurrentStep',
                        value: function getCurrentStep() {
                            return this.currentStep;
                        }
                    },
                    {
                        key: 'back',
                        value: function back() {
                            var index = this.steps.indexOf(this.currentStep);
                            this.show(index - 1, false);
                        }
                    },
                    {
                        key: 'cancel',
                        value: function cancel() {
                            this.done('cancel');
                        }
                    },
                    {
                        key: 'complete',
                        value: function complete() {
                            this.done('complete');
                        }
                    },
                    {
                        key: 'done',
                        value: function done(event) {
                            if (this.currentStep) this.currentStep.hide();
                            this.trigger(event);
                            if (Shepherd.activeTour) Shepherd.activeTour.steps.forEach(function(step) {
                                step.destroy();
                            });
                            Shepherd.activeTour = null;
                            document.body.classList.remove('shepherd-active');
                            this.trigger('inactive', {
                                tour: this
                            });
                        }
                    },
                    {
                        key: 'next',
                        value: function next() {
                            var index = this.steps.indexOf(this.currentStep);
                            if (index === this.steps.length - 1) this.complete();
                            else this.show(index + 1, true);
                        }
                    },
                    {
                        key: 'show',
                        value: function show() {
                            var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                            var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                            if (this.currentStep) this.currentStep.hide();
                            else {
                                document.body.classList.add('shepherd-active');
                                this.trigger('active', {
                                    tour: this
                                });
                            }
                            Shepherd.activeTour = this;
                            var next = (0, _isString3.default)(key) ? this.getById(key) : this.steps[key];
                            if (next) {
                                if (!(0, _isUndefined3.default)(next.options.showOn) && !next.options.showOn()) {
                                    var index = this.steps.indexOf(next);
                                    var nextIndex = forward ? index + 1 : index - 1;
                                    this.show(nextIndex, forward);
                                } else {
                                    this.trigger('show', {
                                        step: next,
                                        previous: this.currentStep
                                    });
                                    this.currentStep = next;
                                    next.show();
                                }
                            }
                        }
                    },
                    {
                        key: 'start',
                        value: function start() {
                            this.trigger('start');
                            this.currentStep = null;
                            this.next();
                        }
                    }
                ]);
                return Tour;
            }(_evented.Evented);
            exports.Shepherd = Shepherd;
        /***/ },
        /* 44 */ /***/ function(module1, exports, __webpack_require__) {
            var baseGetTag = __webpack_require__(2), isObjectLike = __webpack_require__(1);
            /** `Object#toString` result references. */ var numberTag = '[object Number]';
            /**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function isNumber(value) {
                return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
            }
            module1.exports = isNumber;
        /***/ }
    ]);
});


var $1a6cd9663479e45c$exports = {};
$1a6cd9663479e45c$exports = {
    LowC: {
        wholeUp: [
            'Bb5'
        ],
        halfUp: [
            'Eb5',
            'Gb5',
            'B5'
        ],
        blow: [
            'C3',
            'E3',
            'G3',
            'C4',
            'E4',
            'G4',
            'C5',
            'E5',
            'G5',
            'C6'
        ],
        draw: [
            'D3',
            'G3',
            'B3',
            'D4',
            'F4',
            'A4',
            'B4',
            'D5',
            'F5',
            'A5'
        ],
        halfDown: [
            'Db3',
            'Gb3',
            'Bb3',
            'Db4',
            'Ab4'
        ],
        wholeDown: [
            'F3',
            'A3'
        ],
        wholeHalfDown: [
            'Ab3'
        ]
    },
    LowDb: {
        wholeUp: [
            'B5'
        ],
        halfUp: [
            'E5',
            'G5',
            'C6'
        ],
        blow: [
            'Db3',
            'F3',
            'Ab3',
            'Db4',
            'F4',
            'Ab4',
            'Db5',
            'F5',
            'Ab5',
            'Db6'
        ],
        draw: [
            'Eb3',
            'Ab3',
            'C4',
            'Eb4',
            'Gb4',
            'Bb4',
            'C5',
            'Eb5',
            'Gb5',
            'Bb5'
        ],
        halfDown: [
            'D3',
            'G3',
            'B3',
            'D4',
            'A4'
        ],
        wholeDown: [
            'Gb3',
            'Bb3'
        ],
        wholeHalfDown: [
            'A3'
        ]
    },
    LowD: {
        wholeUp: [
            'C6'
        ],
        halfUp: [
            'F5',
            'G#5',
            'C#6'
        ],
        blow: [
            'D3',
            'F#3',
            'A3',
            'D4',
            'F#4',
            'A4',
            'D5',
            'F#5',
            'A5',
            'D6'
        ],
        draw: [
            'E3',
            'A3',
            'C#4',
            'E4',
            'G4',
            'B4',
            'C#5',
            'E5',
            'G5',
            'B5'
        ],
        halfDown: [
            'D#3',
            'G#3',
            'C4',
            'D#4',
            'A#4'
        ],
        wholeDown: [
            'G3',
            'B3'
        ],
        wholeHalfDown: [
            'A#3'
        ]
    },
    LowEb: {
        wholeUp: [
            'Db6'
        ],
        halfUp: [
            'Gb5',
            'A5',
            'D6'
        ],
        blow: [
            'Eb3',
            'G3',
            'Bb3',
            'Eb4',
            'G4',
            'Bb4',
            'Eb5',
            'G5',
            'Bb5',
            'Eb6'
        ],
        draw: [
            'F3',
            'Bb3',
            'D4',
            'F4',
            'Ab4',
            'C5',
            'D5',
            'F5',
            'Ab5',
            'C6'
        ],
        halfDown: [
            'E3',
            'A3',
            'Db4',
            'E4',
            'B4'
        ],
        wholeDown: [
            'Ab3',
            'C4'
        ],
        wholeHalfDown: [
            'B3'
        ]
    },
    LowE: {
        wholeUp: [
            'D6'
        ],
        halfUp: [
            'G5',
            'A#5',
            'D#6'
        ],
        blow: [
            'E3',
            'G#3',
            'B3',
            'E4',
            'G#4',
            'B4',
            'E5',
            'G#5',
            'B5',
            'E6'
        ],
        draw: [
            'F#3',
            'B3',
            'D#4',
            'F#4',
            'A4',
            'C#5',
            'D#5',
            'F#5',
            'A5',
            'C#6'
        ],
        halfDown: [
            'F3',
            'A#3',
            'D4',
            'F4',
            'C5'
        ],
        wholeDown: [
            'A3',
            'C#4'
        ],
        wholeHalfDown: [
            'C4'
        ]
    },
    LowF: {
        wholeUp: [
            'Eb6'
        ],
        halfUp: [
            'Ab5',
            'B5',
            'E6'
        ],
        blow: [
            'F3',
            'A3',
            'C4',
            'F4',
            'A4',
            'C5',
            'F5',
            'A5',
            'C6',
            'F6'
        ],
        draw: [
            'G3',
            'C4',
            'E4',
            'G4',
            'Bb4',
            'D5',
            'E5',
            'G5',
            'Bb5',
            'D6'
        ],
        halfDown: [
            'Gb3',
            'B3',
            'Eb4',
            'Gb4',
            'Db5'
        ],
        wholeDown: [
            'Bb3',
            'D4'
        ],
        wholeHalfDown: [
            'Db4'
        ]
    },
    'LowF#': {
        wholeUp: [
            'E6'
        ],
        halfUp: [
            'A5',
            'C6',
            'F6'
        ],
        blow: [
            'F#3',
            'A#3',
            'C#4',
            'F#4',
            'A#4',
            'C#5',
            'F#5',
            'A#5',
            'C#6',
            'F#6'
        ],
        draw: [
            'G#3',
            'C#4',
            'F4',
            'G#4',
            'B4',
            'D#5',
            'F5',
            'G#5',
            'B5',
            'D#6'
        ],
        halfDown: [
            'G3',
            'C4',
            'E4',
            'G4',
            'D5'
        ],
        wholeDown: [
            'B3',
            'D#4'
        ],
        wholeHalfDown: [
            'D4'
        ]
    },
    LowG: {
        wholeUp: [
            'F6'
        ],
        halfUp: [
            'A#5',
            'C#6',
            'F#6'
        ],
        blow: [
            'G3',
            'B3',
            'D4',
            'G4',
            'B4',
            'D5',
            'G5',
            'B5',
            'D6',
            'G6'
        ],
        draw: [
            'A3',
            'D4',
            'F#4',
            'A4',
            'C5',
            'E5',
            'F#5',
            'A5',
            'C6',
            'E6'
        ],
        halfDown: [
            'G#3',
            'C#4',
            'F4',
            'G#4',
            'D#5'
        ],
        wholeDown: [
            'C4',
            'E4'
        ],
        wholeHalfDown: [
            'D#4'
        ]
    },
    Ab: {
        wholeUp: [
            'Gb6'
        ],
        halfUp: [
            'B5',
            'D6',
            'G6'
        ],
        blow: [
            'Ab3',
            'C4',
            'Eb4',
            'Ab4',
            'C5',
            'Eb5',
            'Ab5',
            'C6',
            'Eb6',
            'Ab6'
        ],
        draw: [
            'Bb3',
            'Eb4',
            'G4',
            'Bb4',
            'Db5',
            'F5',
            'G5',
            'Bb5',
            'Db6',
            'F6'
        ],
        halfDown: [
            'A3',
            'D4',
            'Gb4',
            'A4',
            'E5'
        ],
        wholeDown: [
            'Db4',
            'F4'
        ],
        wholeHalfDown: [
            'E4'
        ]
    },
    A: {
        wholeUp: [
            'G6'
        ],
        halfUp: [
            'C6',
            'D#6',
            'G#6'
        ],
        blow: [
            'A3',
            'C#4',
            'E4',
            'A4',
            'C#5',
            'E5',
            'A5',
            'C#6',
            'E6',
            'A6'
        ],
        draw: [
            'B3',
            'E4',
            'G#4',
            'B4',
            'D5',
            'F#5',
            'G#5',
            'B5',
            'D6',
            'F#6'
        ],
        halfDown: [
            'A#3',
            'D#4',
            'G4',
            'A#4',
            'F5'
        ],
        wholeDown: [
            'D4',
            'F#4'
        ],
        wholeHalfDown: [
            'F4'
        ]
    },
    Bb: {
        wholeUp: [
            'Ab6'
        ],
        halfUp: [
            'Db6',
            'E6',
            'A6'
        ],
        blow: [
            'Bb3',
            'D4',
            'F4',
            'Bb4',
            'D5',
            'F5',
            'Bb5',
            'D6',
            'F6',
            'Bb6'
        ],
        draw: [
            'C4',
            'F4',
            'A4',
            'C5',
            'Eb5',
            'G5',
            'A5',
            'C6',
            'Eb6',
            'G6'
        ],
        halfDown: [
            'B3',
            'E4',
            'Ab4',
            'B4',
            'Gb5'
        ],
        wholeDown: [
            'Eb4',
            'G4'
        ],
        wholeHalfDown: [
            'Gb4'
        ]
    },
    B: {
        wholeUp: [
            'A6'
        ],
        halfUp: [
            'D6',
            'F6',
            'A#6'
        ],
        blow: [
            'B3',
            'D#4',
            'F#4',
            'B4',
            'D#5',
            'F#5',
            'B5',
            'D#6',
            'F#6',
            'B6'
        ],
        draw: [
            'C#4',
            'F#4',
            'A#4',
            'C#5',
            'E5',
            'G#5',
            'A#5',
            'C#6',
            'E6',
            'G#6'
        ],
        halfDown: [
            'C4',
            'F4',
            'A4',
            'C5',
            'G5'
        ],
        wholeDown: [
            'E4',
            'G#4'
        ],
        wholeHalfDown: [
            'G4'
        ]
    },
    C: {
        wholeUp: [
            'Bb6'
        ],
        halfUp: [
            'Eb6',
            'Gb6',
            'B6'
        ],
        blow: [
            'C4',
            'E4',
            'G4',
            'C5',
            'E5',
            'G5',
            'C6',
            'E6',
            'G6',
            'C7'
        ],
        draw: [
            'D4',
            'G4',
            'B4',
            'D5',
            'F5',
            'A5',
            'B5',
            'D6',
            'F6',
            'A6'
        ],
        halfDown: [
            'Db4',
            'Gb4',
            'Bb4',
            'Db5',
            'Ab5'
        ],
        wholeDown: [
            'F4',
            'A4'
        ],
        wholeHalfDown: [
            'Ab4'
        ]
    },
    Db: {
        wholeUp: [
            'B6'
        ],
        halfUp: [
            'E6',
            'G6',
            'C7'
        ],
        blow: [
            'Db4',
            'F4',
            'Ab4',
            'Db5',
            'F5',
            'Ab5',
            'Db6',
            'F6',
            'Ab6',
            'Db7'
        ],
        draw: [
            'Eb4',
            'Ab4',
            'C5',
            'Eb5',
            'Gb5',
            'Bb5',
            'C6',
            'Eb6',
            'Gb6',
            'Bb6'
        ],
        halfDown: [
            'D4',
            'G4',
            'B4',
            'D5',
            'A5'
        ],
        wholeDown: [
            'Gb4',
            'Bb4'
        ],
        wholeHalfDown: [
            'A4'
        ]
    },
    D: {
        wholeUp: [
            'C7'
        ],
        halfUp: [
            'F6',
            'G#6',
            'C#7'
        ],
        blow: [
            'D4',
            'F#4',
            'A4',
            'D5',
            'F#5',
            'A5',
            'D6',
            'F#6',
            'A6',
            'D7'
        ],
        draw: [
            'E4',
            'A4',
            'C#5',
            'E5',
            'G5',
            'B5',
            'C#6',
            'E6',
            'G6',
            'B6'
        ],
        halfDown: [
            'D#4',
            'G#4',
            'C5',
            'D#5',
            'A#5'
        ],
        wholeDown: [
            'G4',
            'B4'
        ],
        wholeHalfDown: [
            'A#4'
        ]
    },
    Eb: {
        wholeUp: [
            'Db7'
        ],
        halfUp: [
            'Gb6',
            'A6',
            'D7'
        ],
        blow: [
            'Eb4',
            'G4',
            'Bb4',
            'Eb5',
            'G5',
            'Bb5',
            'Eb6',
            'G6',
            'Bb6',
            'Eb7'
        ],
        draw: [
            'F4',
            'Bb4',
            'D5',
            'F5',
            'Ab5',
            'C6',
            'D6',
            'F6',
            'Ab6',
            'C7'
        ],
        halfDown: [
            'E4',
            'A4',
            'Db5',
            'E5',
            'B5'
        ],
        wholeDown: [
            'Ab4',
            'C5'
        ],
        wholeHalfDown: [
            'B4'
        ]
    },
    E: {
        wholeUp: [
            'D7'
        ],
        halfUp: [
            'G6',
            'A#6',
            'D#7'
        ],
        blow: [
            'E4',
            'G#4',
            'B4',
            'E5',
            'G#5',
            'B5',
            'E6',
            'G#6',
            'B6',
            'E7'
        ],
        draw: [
            'F#4',
            'B4',
            'D#5',
            'F#5',
            'A5',
            'C#6',
            'D#6',
            'F#6',
            'A6',
            'C#7'
        ],
        halfDown: [
            'F4',
            'A#4',
            'D5',
            'F5',
            'C6'
        ],
        wholeDown: [
            'A4',
            'C#5'
        ],
        wholeHalfDown: [
            'C5'
        ]
    },
    F: {
        wholeUp: [
            'Eb7'
        ],
        halfUp: [
            'Ab6',
            'B6',
            'E7'
        ],
        blow: [
            'F4',
            'A4',
            'C5',
            'F5',
            'A5',
            'C6',
            'F6',
            'A6',
            'C7',
            'F7'
        ],
        draw: [
            'G4',
            'C5',
            'E5',
            'G5',
            'Bb5',
            'D6',
            'E6',
            'G6',
            'Bb6',
            'D7'
        ],
        halfDown: [
            'Gb4',
            'B4',
            'Eb5',
            'Gb5',
            'Db6'
        ],
        wholeDown: [
            'Bb4',
            'D5'
        ],
        wholeHalfDown: [
            'Db5'
        ]
    },
    'F#': {
        wholeUp: [
            'E7'
        ],
        halfUp: [
            'A6',
            'C7',
            'F7'
        ],
        blow: [
            'F#4',
            'A#4',
            'C#5',
            'F#5',
            'A#5',
            'C#6',
            'F#6',
            'A#6',
            'C#7',
            'F#7'
        ],
        draw: [
            'G#4',
            'C#5',
            'F5',
            'G#5',
            'B5',
            'D#6',
            'F6',
            'G#6',
            'B6',
            'D#7'
        ],
        halfDown: [
            'G4',
            'C5',
            'E5',
            'G5',
            'D6'
        ],
        wholeDown: [
            'B4',
            'D#5'
        ],
        wholeHalfDown: [
            'D5'
        ]
    },
    G: {
        wholeUp: [
            'F7'
        ],
        halfUp: [
            'A#6',
            'C#7',
            'F#7'
        ],
        blow: [
            'G4',
            'B4',
            'D5',
            'G5',
            'B5',
            'D6',
            'G6',
            'B6',
            'D7',
            'G7'
        ],
        draw: [
            'A4',
            'D5',
            'F#5',
            'A5',
            'C6',
            'E6',
            'F#6',
            'A6',
            'C7',
            'E7'
        ],
        halfDown: [
            'G#4',
            'C#5',
            'F5',
            'G#5',
            'D#6'
        ],
        wholeDown: [
            'C5',
            'E5'
        ],
        wholeHalfDown: [
            'D#5'
        ]
    }
};


var $f633c4a13e468503$exports = {};
$f633c4a13e468503$exports = import.meta.resolve("fj2SN");


var $210abc16c776aac1$exports = {};
$210abc16c776aac1$exports = import.meta.resolve("cW8DW");


var $9361714ac5cf3d6c$exports = {};
$9361714ac5cf3d6c$exports = import.meta.resolve("d0aab");


var $900b31c2dea9ed13$exports = {};
$900b31c2dea9ed13$exports = import.meta.resolve("dxqne");


var $5dc6e291e63b5468$exports = {};
$5dc6e291e63b5468$exports = import.meta.resolve("74UYh");


var $0f4d3f1e6a2baed1$exports = {};
$0f4d3f1e6a2baed1$exports = import.meta.resolve("ijx5Q");


var $7604d1935f9e9f28$exports = {};
$7604d1935f9e9f28$exports = import.meta.resolve("2Yjk2");


var $74da642edd5492a7$exports = {};
$74da642edd5492a7$exports = import.meta.resolve("5c3GE");


var $35a1437a6d488c8a$exports = {};
$35a1437a6d488c8a$exports = import.meta.resolve("fzjwU");


var $f38273d432445119$exports = {};
$f38273d432445119$exports = import.meta.resolve("eCjx6");


var $f96e1a7cd5cd8964$exports = {};
$f96e1a7cd5cd8964$exports = import.meta.resolve("hO0yg");


var $11a67d13e4359ffc$exports = {};
$11a67d13e4359ffc$exports = import.meta.resolve("5b04V");


var $c37b0ac62157521a$exports = {};
$c37b0ac62157521a$exports = import.meta.resolve("9S7i8");


var $663d4f9139ebea36$exports = {};
$663d4f9139ebea36$exports = import.meta.resolve("cWk5G");


var $8ce320e7da54e808$exports = {};
$8ce320e7da54e808$exports = import.meta.resolve("5KoF2");


var $678593cb9da6a998$exports = {};
$678593cb9da6a998$exports = import.meta.resolve("bEr47");


var $fabc754ef6e24c8c$exports = {};
$fabc754ef6e24c8c$exports = import.meta.resolve("bkkpU");


var $5377b362121eabf5$exports = {};
$5377b362121eabf5$exports = import.meta.resolve("7ybYs");


var $40bba97cde470478$exports = {};
$40bba97cde470478$exports = import.meta.resolve("66OPJ");


var $729cef30edee851d$exports = {};
$729cef30edee851d$exports = import.meta.resolve("61eqP");


var $e4e27e5d98dad6cb$exports = {};
$e4e27e5d98dad6cb$exports = import.meta.resolve("9zrQX");


var $0a49654137d9558e$exports = {};
$0a49654137d9558e$exports = import.meta.resolve("dP6Yb");


var $a398dbf83b9c70c6$exports = {};
$a398dbf83b9c70c6$exports = import.meta.resolve("2d8oh");


var $dd3aff2a978b4cc2$exports = {};
$dd3aff2a978b4cc2$exports = import.meta.resolve("8cogN");


var $be5369666eccceb9$exports = {};
$be5369666eccceb9$exports = import.meta.resolve("jiVOC");


var $e21dbaf513a5c754$exports = {};
$e21dbaf513a5c754$exports = import.meta.resolve("awepc");


var $21cbb7098a80e199$exports = {};
$21cbb7098a80e199$exports = import.meta.resolve("aljAc");


var $b9372ea7cae9cffa$exports = {};
$b9372ea7cae9cffa$exports = import.meta.resolve("6HKPv");


var $b00f4f9b933fca9e$exports = {};
$b00f4f9b933fca9e$exports = import.meta.resolve("eYN1I");


var $8f93e7f690133195$exports = {};
$8f93e7f690133195$exports = import.meta.resolve("hraa9");


var $6155a5dae43e146e$exports = {};
$6155a5dae43e146e$exports = import.meta.resolve("f1FNy");


var $10a83c1d231e722b$exports = {};
$10a83c1d231e722b$exports = import.meta.resolve("6IqKn");


var $712cd1cbe1109c72$exports = {};
$712cd1cbe1109c72$exports = import.meta.resolve("eYiQU");


var $51a0f2ccdf2ef6e2$exports = {};
$51a0f2ccdf2ef6e2$exports = import.meta.resolve("DxknT");


var $f1d360554ececea5$exports = {};
$f1d360554ececea5$exports = import.meta.resolve("coHSk");


var $034d1585da9459a3$exports = {};
$034d1585da9459a3$exports = import.meta.resolve("lcYMv");


var $2e447c3722fc8021$exports = {};
$2e447c3722fc8021$exports = import.meta.resolve("8EzhR");


var $965aaf11bd74eec7$exports = {};
$965aaf11bd74eec7$exports = import.meta.resolve("jLFe2");


var $b92a85cb8934d905$exports = {};
$b92a85cb8934d905$exports = import.meta.resolve("BxoGo");


var $90c823bae42d5243$exports = {};
$90c823bae42d5243$exports = import.meta.resolve("7eocC");


var $f33bd8934e6f4352$exports = {};
$f33bd8934e6f4352$exports = import.meta.resolve("3AWM7");


var $f37f7d3f1ed4e802$exports = {};
$f37f7d3f1ed4e802$exports = import.meta.resolve("4jfjx");


var $f482ec4afac26e23$exports = {};
$f482ec4afac26e23$exports = import.meta.resolve("M1uJ7");


var $8babb13462276645$exports = {};
$8babb13462276645$exports = import.meta.resolve("j2stg");


var $d571b9a07c4f072d$exports = {};
$d571b9a07c4f072d$exports = import.meta.resolve("fxQ6G");


var $406a4a42a004cec6$exports = {};
$406a4a42a004cec6$exports = import.meta.resolve("ePGsZ");


var $ebd61b865b019991$exports = {};
$ebd61b865b019991$exports = import.meta.resolve("aHoHD");


var $fb0d22bfb0e62ae1$exports = {};
$fb0d22bfb0e62ae1$exports = import.meta.resolve("8dcHR");


var $b644ec9d7dbaf335$exports = {};
$b644ec9d7dbaf335$exports = import.meta.resolve("gbiS1");


var $e038b745a85b1322$exports = {};
$e038b745a85b1322$exports = import.meta.resolve("12lIo");


var $4fb0ca4a670f8258$exports = {};
$4fb0ca4a670f8258$exports = import.meta.resolve("2A3ks");


var $4ebaedc0e89fa146$exports = {};
$4ebaedc0e89fa146$exports = import.meta.resolve("dHMZl");


var $2d60d2275d5d39bb$exports = {};
$2d60d2275d5d39bb$exports = import.meta.resolve("dE6ZX");


var $2599c9764736db04$exports = {};
$2599c9764736db04$exports = import.meta.resolve("g4MHj");


var $395cd74fd9576fa8$exports = {};
$395cd74fd9576fa8$exports = import.meta.resolve("b6jro");


var $1a1ddd64b27f0dc6$exports = {};
$1a1ddd64b27f0dc6$exports = import.meta.resolve("hGPvO");


const $74a45bff3c7a3ab4$var$audioPaths = {
    C3: (/*@__PURE__*/$parcel$interopDefault($f633c4a13e468503$exports)),
    Cs3: (/*@__PURE__*/$parcel$interopDefault($210abc16c776aac1$exports)),
    D3: (/*@__PURE__*/$parcel$interopDefault($9361714ac5cf3d6c$exports)),
    Ds3: (/*@__PURE__*/$parcel$interopDefault($900b31c2dea9ed13$exports)),
    E3: (/*@__PURE__*/$parcel$interopDefault($5dc6e291e63b5468$exports)),
    F3: (/*@__PURE__*/$parcel$interopDefault($0f4d3f1e6a2baed1$exports)),
    Fs3: (/*@__PURE__*/$parcel$interopDefault($7604d1935f9e9f28$exports)),
    G3: (/*@__PURE__*/$parcel$interopDefault($74da642edd5492a7$exports)),
    Gs3: (/*@__PURE__*/$parcel$interopDefault($35a1437a6d488c8a$exports)),
    A3: (/*@__PURE__*/$parcel$interopDefault($f38273d432445119$exports)),
    As3: (/*@__PURE__*/$parcel$interopDefault($f96e1a7cd5cd8964$exports)),
    B3: (/*@__PURE__*/$parcel$interopDefault($11a67d13e4359ffc$exports)),
    C4: (/*@__PURE__*/$parcel$interopDefault($c37b0ac62157521a$exports)),
    Cs4: (/*@__PURE__*/$parcel$interopDefault($663d4f9139ebea36$exports)),
    D4: (/*@__PURE__*/$parcel$interopDefault($8ce320e7da54e808$exports)),
    Ds4: (/*@__PURE__*/$parcel$interopDefault($678593cb9da6a998$exports)),
    E4: (/*@__PURE__*/$parcel$interopDefault($fabc754ef6e24c8c$exports)),
    F4: (/*@__PURE__*/$parcel$interopDefault($5377b362121eabf5$exports)),
    Fs4: (/*@__PURE__*/$parcel$interopDefault($40bba97cde470478$exports)),
    G4: (/*@__PURE__*/$parcel$interopDefault($729cef30edee851d$exports)),
    Gs4: (/*@__PURE__*/$parcel$interopDefault($e4e27e5d98dad6cb$exports)),
    A4: (/*@__PURE__*/$parcel$interopDefault($0a49654137d9558e$exports)),
    As4: (/*@__PURE__*/$parcel$interopDefault($a398dbf83b9c70c6$exports)),
    B4: (/*@__PURE__*/$parcel$interopDefault($dd3aff2a978b4cc2$exports)),
    C5: (/*@__PURE__*/$parcel$interopDefault($be5369666eccceb9$exports)),
    Cs5: (/*@__PURE__*/$parcel$interopDefault($e21dbaf513a5c754$exports)),
    D5: (/*@__PURE__*/$parcel$interopDefault($21cbb7098a80e199$exports)),
    Ds5: (/*@__PURE__*/$parcel$interopDefault($b9372ea7cae9cffa$exports)),
    E5: (/*@__PURE__*/$parcel$interopDefault($b00f4f9b933fca9e$exports)),
    F5: (/*@__PURE__*/$parcel$interopDefault($8f93e7f690133195$exports)),
    Fs5: (/*@__PURE__*/$parcel$interopDefault($6155a5dae43e146e$exports)),
    G5: (/*@__PURE__*/$parcel$interopDefault($10a83c1d231e722b$exports)),
    Gs5: (/*@__PURE__*/$parcel$interopDefault($712cd1cbe1109c72$exports)),
    A5: (/*@__PURE__*/$parcel$interopDefault($51a0f2ccdf2ef6e2$exports)),
    As5: (/*@__PURE__*/$parcel$interopDefault($f1d360554ececea5$exports)),
    B5: (/*@__PURE__*/$parcel$interopDefault($034d1585da9459a3$exports)),
    C6: (/*@__PURE__*/$parcel$interopDefault($2e447c3722fc8021$exports)),
    Cs6: (/*@__PURE__*/$parcel$interopDefault($965aaf11bd74eec7$exports)),
    D6: (/*@__PURE__*/$parcel$interopDefault($b92a85cb8934d905$exports)),
    Ds6: (/*@__PURE__*/$parcel$interopDefault($90c823bae42d5243$exports)),
    E6: (/*@__PURE__*/$parcel$interopDefault($f33bd8934e6f4352$exports)),
    F6: (/*@__PURE__*/$parcel$interopDefault($f37f7d3f1ed4e802$exports)),
    Fs6: (/*@__PURE__*/$parcel$interopDefault($f482ec4afac26e23$exports)),
    G6: (/*@__PURE__*/$parcel$interopDefault($8babb13462276645$exports)),
    Gs6: (/*@__PURE__*/$parcel$interopDefault($d571b9a07c4f072d$exports)),
    A6: (/*@__PURE__*/$parcel$interopDefault($406a4a42a004cec6$exports)),
    As6: (/*@__PURE__*/$parcel$interopDefault($ebd61b865b019991$exports)),
    B6: (/*@__PURE__*/$parcel$interopDefault($fb0d22bfb0e62ae1$exports)),
    C7: (/*@__PURE__*/$parcel$interopDefault($b644ec9d7dbaf335$exports)),
    Cs7: (/*@__PURE__*/$parcel$interopDefault($e038b745a85b1322$exports)),
    D7: (/*@__PURE__*/$parcel$interopDefault($4fb0ca4a670f8258$exports)),
    Ds7: (/*@__PURE__*/$parcel$interopDefault($4ebaedc0e89fa146$exports)),
    E7: (/*@__PURE__*/$parcel$interopDefault($2d60d2275d5d39bb$exports)),
    F7: (/*@__PURE__*/$parcel$interopDefault($2599c9764736db04$exports)),
    Fs7: (/*@__PURE__*/$parcel$interopDefault($395cd74fd9576fa8$exports)),
    G7: (/*@__PURE__*/$parcel$interopDefault($1a1ddd64b27f0dc6$exports))
};
// Add enharmonic equivalents
$74a45bff3c7a3ab4$var$audioPaths.Db3 = (0, (/*@__PURE__*/$parcel$interopDefault($210abc16c776aac1$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Eb3 = (0, (/*@__PURE__*/$parcel$interopDefault($900b31c2dea9ed13$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Gb3 = (0, (/*@__PURE__*/$parcel$interopDefault($7604d1935f9e9f28$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Ab3 = (0, (/*@__PURE__*/$parcel$interopDefault($35a1437a6d488c8a$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Bb3 = (0, (/*@__PURE__*/$parcel$interopDefault($f96e1a7cd5cd8964$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Db4 = (0, (/*@__PURE__*/$parcel$interopDefault($663d4f9139ebea36$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Eb4 = (0, (/*@__PURE__*/$parcel$interopDefault($678593cb9da6a998$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Gb4 = (0, (/*@__PURE__*/$parcel$interopDefault($40bba97cde470478$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Ab4 = (0, (/*@__PURE__*/$parcel$interopDefault($e4e27e5d98dad6cb$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Bb4 = (0, (/*@__PURE__*/$parcel$interopDefault($a398dbf83b9c70c6$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Db5 = (0, (/*@__PURE__*/$parcel$interopDefault($e21dbaf513a5c754$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Eb5 = (0, (/*@__PURE__*/$parcel$interopDefault($b9372ea7cae9cffa$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Gb5 = (0, (/*@__PURE__*/$parcel$interopDefault($6155a5dae43e146e$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Ab5 = (0, (/*@__PURE__*/$parcel$interopDefault($712cd1cbe1109c72$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Bb5 = (0, (/*@__PURE__*/$parcel$interopDefault($f1d360554ececea5$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Db6 = (0, (/*@__PURE__*/$parcel$interopDefault($965aaf11bd74eec7$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Eb6 = (0, (/*@__PURE__*/$parcel$interopDefault($90c823bae42d5243$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Gb6 = (0, (/*@__PURE__*/$parcel$interopDefault($f482ec4afac26e23$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Ab6 = (0, (/*@__PURE__*/$parcel$interopDefault($d571b9a07c4f072d$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Bb6 = (0, (/*@__PURE__*/$parcel$interopDefault($ebd61b865b019991$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Db7 = (0, (/*@__PURE__*/$parcel$interopDefault($e038b745a85b1322$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Eb7 = (0, (/*@__PURE__*/$parcel$interopDefault($4ebaedc0e89fa146$exports)));
$74a45bff3c7a3ab4$var$audioPaths.Gb7 = (0, (/*@__PURE__*/$parcel$interopDefault($395cd74fd9576fa8$exports)));
// audioPaths.Ab7 = Gs7;
// audioPaths.Bb7 = As7;
var $74a45bff3c7a3ab4$var$WindowAudioContext = window.AudioContext || window.webkitAudioContext;
var $74a45bff3c7a3ab4$var$outputAudioContext;
var $74a45bff3c7a3ab4$var$micAudioContext;
var $74a45bff3c7a3ab4$var$listening = false;
var $74a45bff3c7a3ab4$var$track;
var $74a45bff3c7a3ab4$var$micButtonEl;
var $74a45bff3c7a3ab4$var$micButtonStatusEl;
var $74a45bff3c7a3ab4$var$keySelectEl;
var $74a45bff3c7a3ab4$var$lineTimeout;
var $74a45bff3c7a3ab4$var$noteStopTimeout;
var $74a45bff3c7a3ab4$var$currentGainNode;
var $74a45bff3c7a3ab4$var$visibilityHandler;
var $74a45bff3c7a3ab4$var$volume = 0.6;
var $74a45bff3c7a3ab4$var$defaultFormat = 'wave';
var $74a45bff3c7a3ab4$var$format = 'wave';
var $74a45bff3c7a3ab4$var$currentSoundPlaying;
function $74a45bff3c7a3ab4$var$ready(fn) {
    function done() {
        document.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        fn();
    }
    if (document.readyState !== 'loading') done();
    else {
        document.addEventListener('DOMContentLoaded', done);
        window.addEventListener('load', done);
    }
}
const $74a45bff3c7a3ab4$var$sounds = {};
$74a45bff3c7a3ab4$var$ready($74a45bff3c7a3ab4$var$init);
function $74a45bff3c7a3ab4$var$init() {
    $74a45bff3c7a3ab4$var$loadAudio();
    $74a45bff3c7a3ab4$var$setKey('C');
    $74a45bff3c7a3ab4$var$setupKeySelect();
    $74a45bff3c7a3ab4$var$setupFormat();
    $74a45bff3c7a3ab4$var$setupAudio();
    $74a45bff3c7a3ab4$var$setupMicButton();
    $74a45bff3c7a3ab4$var$setupHelp();
}
function $74a45bff3c7a3ab4$var$loadAudio() {
    Object.keys($74a45bff3c7a3ab4$var$audioPaths).forEach(function(note) {
        $74a45bff3c7a3ab4$var$sounds[note] = new (0, $f89d8ffbdc18f2ab$export$b791fe48eec8032a)({
            src: [
                $74a45bff3c7a3ab4$var$audioPaths[note]
            ],
            volume: $74a45bff3c7a3ab4$var$volume
        });
    });
}
// set up HTML based on key
function $74a45bff3c7a3ab4$var$setKey(harmonicaKey) {
    var rows = (0, (/*@__PURE__*/$parcel$interopDefault($1a6cd9663479e45c$exports)))[harmonicaKey];
    Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($1a6cd9663479e45c$exports)))[harmonicaKey]).forEach(function(rowKey) {
        var selector = '.benditbetter-notes--' + $74a45bff3c7a3ab4$var$camelToKebab(rowKey) + '> .benditbetter-note--on';
        var notesEls = document.querySelectorAll(selector);
        notesEls.forEach(function(noteEl, i) {
            // clear children
            while(noteEl.firstChild)noteEl.removeChild(noteEl.firstChild);
            var t = (0, (/*@__PURE__*/$parcel$interopDefault($jN9B6))).note(rows[rowKey][i]);
            noteEl.setAttribute('data-name', t.name());
            noteEl.setAttribute('data-accidental', t.accidental());
            noteEl.setAttribute('data-octave', t.octave());
            var noteTextEl = document.createElement('span');
            noteTextEl.setAttribute('class', 'benditbetter-note-text');
            noteTextEl.innerHTML = $74a45bff3c7a3ab4$var$formatNote(t.name().toUpperCase() + t.accidental());
            noteEl.appendChild(noteTextEl);
            var lineEl = document.createElement('div');
            lineEl.setAttribute('class', 'benditbetter-line');
            noteEl.appendChild(lineEl);
        });
    });
}
function $74a45bff3c7a3ab4$var$setupAudio() {
    // http://marcgg.com/blog/2016/11/01/javascript-audio/
    if ($74a45bff3c7a3ab4$var$WindowAudioContext) {
        $74a45bff3c7a3ab4$var$outputAudioContext = window.Howler && window.Howler.ctx || new $74a45bff3c7a3ab4$var$WindowAudioContext();
        $74a45bff3c7a3ab4$var$micAudioContext = new $74a45bff3c7a3ab4$var$WindowAudioContext();
        if ($74a45bff3c7a3ab4$var$outputAudioContext) // TODO: event delegation
        document.querySelectorAll('.benditbetter-note.benditbetter-note--on').forEach(function(el) {
            el.addEventListener('click', function(e) {
                var noteEl = e.target.closest('.benditbetter-note');
                var noteString = noteEl.getAttribute('data-name').toUpperCase() + noteEl.getAttribute('data-accidental') + noteEl.getAttribute('data-octave');
                $74a45bff3c7a3ab4$var$stopCurrentPlaying();
                $74a45bff3c7a3ab4$var$play(noteString);
            });
        });
    }
}
function $74a45bff3c7a3ab4$var$play(noteString, short) {
    var note = (0, (/*@__PURE__*/$parcel$interopDefault($jN9B6))).note(noteString);
    var noteStringForFile = noteString.replace('#', 's');
    var sound = $74a45bff3c7a3ab4$var$sounds[noteStringForFile];
    if (!sound) return;
    var shortDuration = 650;
    var fadeDuration = 150;
    var sampleDuration = sound.duration() * 1000;
    var fadeDelay = short ? shortDuration : sampleDuration - fadeDuration;
    if ($74a45bff3c7a3ab4$var$format === 'wave') {
        var oscillatorNode = $74a45bff3c7a3ab4$var$outputAudioContext.createOscillator();
        var gainNode = $74a45bff3c7a3ab4$var$outputAudioContext.createGain();
        $74a45bff3c7a3ab4$var$currentGainNode = gainNode;
        gainNode.gain.value = $74a45bff3c7a3ab4$var$volume;
        oscillatorNode.connect(gainNode);
        gainNode.connect($74a45bff3c7a3ab4$var$outputAudioContext.destination);
        oscillatorNode.frequency.value = note.fq();
        oscillatorNode.start(0);
        $74a45bff3c7a3ab4$var$noteStopTimeout = setTimeout(function() {
            gainNode.gain.exponentialRampToValueAtTime(0.00001, $74a45bff3c7a3ab4$var$outputAudioContext.currentTime + 1);
        }, fadeDelay);
    } else if ($74a45bff3c7a3ab4$var$format === 'sample') {
        var soundId = sound.play();
        $74a45bff3c7a3ab4$var$currentSoundPlaying = sound;
        setTimeout(function() {
            sound.fade($74a45bff3c7a3ab4$var$volume, 0, fadeDuration, soundId);
        }, fadeDelay);
    }
}
function $74a45bff3c7a3ab4$var$stopCurrentPlaying() {
    if ($74a45bff3c7a3ab4$var$currentSoundPlaying) $74a45bff3c7a3ab4$var$currentSoundPlaying.stop();
    if ($74a45bff3c7a3ab4$var$noteStopTimeout) {
        clearTimeout($74a45bff3c7a3ab4$var$noteStopTimeout);
        if ($74a45bff3c7a3ab4$var$currentGainNode) $74a45bff3c7a3ab4$var$currentGainNode.gain.exponentialRampToValueAtTime(0.00001, $74a45bff3c7a3ab4$var$outputAudioContext.currentTime + 0.1);
    }
}
function $74a45bff3c7a3ab4$var$setupKeySelect() {
    $74a45bff3c7a3ab4$var$micButtonEl = document.querySelector('.benditbetter-mic-button');
    $74a45bff3c7a3ab4$var$micButtonStatusEl = document.querySelector('.benditbetter-mic-button__status');
    $74a45bff3c7a3ab4$var$keySelectEl = document.querySelector('.benditbetter-select__select');
    $74a45bff3c7a3ab4$var$keySelectEl.addEventListener('change', function() {
        if ($74a45bff3c7a3ab4$var$keySelectEl.value) $74a45bff3c7a3ab4$var$setKey($74a45bff3c7a3ab4$var$keySelectEl.value);
    });
}
function $74a45bff3c7a3ab4$var$setupFormat() {
    if (window.localStorage) {
        var formatFromStorage = localStorage.getItem('BenditbetterFormat') || $74a45bff3c7a3ab4$var$defaultFormat;
        if (formatFromStorage === 'wave') {
            document.querySelector('#input-wave').checked = true;
            $74a45bff3c7a3ab4$var$format = 'wave';
        } else {
            document.querySelector('#input-sample').checked = true;
            $74a45bff3c7a3ab4$var$format = 'sample';
        }
    }
    var formatRadioEls = document.querySelectorAll('.benditbetter-select__format input');
    function handleClick(e) {
        // TODO: stop all audio when switching formats
        $74a45bff3c7a3ab4$var$stopCurrentPlaying();
        if (window.localStorage) localStorage.setItem('BenditbetterFormat', e.target.value);
        $74a45bff3c7a3ab4$var$format = e.target.value;
        $74a45bff3c7a3ab4$var$play('G4', true);
    }
    for(var i = 0; i < formatRadioEls.length; i++)formatRadioEls[i].addEventListener('click', handleClick);
}
var $74a45bff3c7a3ab4$var$tour = new (0, (/*@__PURE__*/$parcel$interopDefault($a4d5bda870f39a89$exports))).Tour({
    defaultStepOptions: {}
});
$74a45bff3c7a3ab4$var$tour.addStep('mic', {
    text: 'Click the microphone button and start playing the harmonica. The notes that you play will appear on the notes below.',
    attachTo: '.benditbetter-mic-button right',
    buttons: [
        {
            action: $74a45bff3c7a3ab4$var$tour.cancel,
            classes: 'shepherd-button-secondary',
            text: 'Exit'
        },
        {
            text: 'Next',
            action: $74a45bff3c7a3ab4$var$tour.next
        }
    ]
});
$74a45bff3c7a3ab4$var$tour.addStep('pitch', {
    text: 'Click on the notes of the harmonica to hear the pitch.',
    attachTo: '.benditbetter-notes:nth-of-type(3) .benditbetter-note:nth-of-type(3) bottom',
    buttons: [
        {
            action: $74a45bff3c7a3ab4$var$tour.cancel,
            classes: 'shepherd-button-secondary',
            text: 'Exit'
        },
        {
            text: 'Next',
            action: $74a45bff3c7a3ab4$var$tour.next
        }
    ]
});
$74a45bff3c7a3ab4$var$tour.addStep('format', {
    text: 'Switch between harmonica samples and the sine wave audio format.',
    attachTo: '.switch-field label:last-of-type right',
    buttons: [
        {
            action: $74a45bff3c7a3ab4$var$tour.cancel,
            classes: 'shepherd-button-secondary',
            text: 'Exit'
        },
        {
            text: 'Next',
            action: $74a45bff3c7a3ab4$var$tour.next
        }
    ]
});
$74a45bff3c7a3ab4$var$tour.addStep('key', {
    text: 'Change the key of the harmonica here.',
    attachTo: '.benditbetter-select__select right',
    buttons: [
        {
            action: $74a45bff3c7a3ab4$var$tour.cancel,
            classes: 'shepherd-button-secondary',
            text: 'Exit'
        },
        {
            text: 'Next',
            action: $74a45bff3c7a3ab4$var$tour.next
        }
    ]
});
$74a45bff3c7a3ab4$var$tour.addStep('logo', {
    text: "Get more tips and help by clicking on the Harmonica.com logo here. Happy Harpin'!",
    attachTo: '.benditbetter-logo top',
    buttons: [
        {
            text: 'Done',
            action: $74a45bff3c7a3ab4$var$tour.next
        }
    ]
});
if (window.localStorage) {
    if (!localStorage.getItem('BenditbetterRepeatVisit')) {
        localStorage.setItem('BenditbetterRepeatVisit', true);
        $74a45bff3c7a3ab4$var$tour.start();
    }
}
function $74a45bff3c7a3ab4$var$setupHelp() {
    (0, $adcf363a09f534a1$export$2e2bcd8739ae039).init({
        onClose: function() {
            document.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
    });
    document.querySelector('.benditbetter-help__tour').addEventListener('click', function() {
        $74a45bff3c7a3ab4$var$tour.start();
    });
}
function $74a45bff3c7a3ab4$var$setupMicButton() {
    // need user interaction on iOS
    $74a45bff3c7a3ab4$var$micButtonEl.addEventListener('click', function() {
        $74a45bff3c7a3ab4$var$stopCurrentPlaying();
        if ($74a45bff3c7a3ab4$var$listening) {
            $74a45bff3c7a3ab4$var$listening = false;
            if ($74a45bff3c7a3ab4$var$track && $74a45bff3c7a3ab4$var$track.enabled) $74a45bff3c7a3ab4$var$track.enabled = false;
            $74a45bff3c7a3ab4$var$micButtonEl.classList.remove('benditbetter-mic-button--listen');
            $74a45bff3c7a3ab4$var$micButtonStatusEl.classList.remove('benditbetter-mic-button__status--on');
        } else $74a45bff3c7a3ab4$var$listenForMicrophone();
    });
// if not ios, and user has already granted mic permission, then auto click the mic button
// if (!/iP(hone|od|ad)/.test(navigator.platform) && window.localStorage && localStorage.getItem('BenditbetterPermission') === 'true') {
//     micButtonEl.click();
// }
}
function $74a45bff3c7a3ab4$var$listenForMicrophone() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($9dd82efbd05f8702$exports))).isSupported && $74a45bff3c7a3ab4$var$WindowAudioContext) {
        var micStream = new (0, (/*@__PURE__*/$parcel$interopDefault($0d565b651cfab57f$exports)))({
            bufferSize: 4096
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($9dd82efbd05f8702$exports)))({
            audio: true
        }).then(function(mediaStream) {
            $74a45bff3c7a3ab4$var$listening = true;
            $74a45bff3c7a3ab4$var$micButtonEl.classList.add('benditbetter-mic-button--listen');
            $74a45bff3c7a3ab4$var$micButtonStatusEl.classList.add('benditbetter-mic-button__status--on');
            // if (window.localStorage) {
            //     localStorage.setItem('BenditbetterPermission', true);
            // }
            var tracks = mediaStream.getAudioTracks();
            $74a45bff3c7a3ab4$var$track = tracks[0] || {};
            micStream.setStream(mediaStream);
            // disable media stream when page is hidden
            if ($74a45bff3c7a3ab4$var$visibilityHandler) document.removeEventListener('visibilitychange', $74a45bff3c7a3ab4$var$visibilityHandler);
            $74a45bff3c7a3ab4$var$visibilityHandler = function() {
                if ($74a45bff3c7a3ab4$var$listening) $74a45bff3c7a3ab4$var$track.enabled = !document.hidden;
            };
            document.addEventListener('visibilitychange', $74a45bff3c7a3ab4$var$visibilityHandler, false);
            micStream.on('data', function(chunk) {
                var raw = (0, (/*@__PURE__*/$parcel$interopDefault($0d565b651cfab57f$exports))).toRaw(chunk); // Float32Array
                var periodInSamples = (0, (/*@__PURE__*/$parcel$interopDefault($049c1069fcbd3f88$exports)))(raw, 0.85);
                var sampleRateInHz = $74a45bff3c7a3ab4$var$micAudioContext.sampleRate || 48000;
                var pitchInHz = sampleRateInHz / periodInSamples;
                if (periodInSamples !== 0) $74a45bff3c7a3ab4$var$updateFromMic(pitchInHz);
            });
        }).catch(function(e) {
            // TODO: tell user permission was denied
            e;
        });
    }
}
function $74a45bff3c7a3ab4$var$updateFromMic(freq) {
    var noteData = (0, (/*@__PURE__*/$parcel$interopDefault($jN9B6))).note.fromFrequency(freq);
    var note = noteData.note;
    var cents = noteData.cents.toFixed(2);
    cents = cents > 0 ? Math.floor(cents) : Math.ceil(cents); // round towards zero
    // var div = document.getElementsByClassName('benditbetter-big')[0];
    // div.innerHTML = note.name().toUpperCase() + note.accidental() + note.octave() + '&nbsp;&middot;&nbsp;' + cents;
    var selector = '.benditbetter-note--on[data-name="' + note.name() + '"][data-accidental="' + note.accidental() + '"][data-octave="' + note.octave() + '"] > .benditbetter-line';
    var enharmonic = note.enharmonics(true)[0];
    if (enharmonic) selector += ', .benditbetter-note--on[data-name="' + enharmonic.name() + '"][data-accidental="' + enharmonic.accidental() + '"][data-octave="' + enharmonic.octave() + '"] > .benditbetter-line';
    var lineEls = document.querySelectorAll(selector);
    if (lineEls.length) {
        clearTimeout($74a45bff3c7a3ab4$var$lineTimeout);
        $74a45bff3c7a3ab4$var$lineTimeout = setTimeout($74a45bff3c7a3ab4$var$clear, 350);
        $74a45bff3c7a3ab4$var$clear();
        lineEls.forEach(function(lineEl) {
            lineEl.classList.remove('benditbetter-line--close', 'benditbetter-line--correct');
            lineEl.classList.add('benditbetter-line--on');
            if (Math.abs(cents) < 8) lineEl.classList.add('benditbetter-line--correct');
            else if (Math.abs(cents) < 18) lineEl.classList.add('benditbetter-line--close');
            lineEl.style.top = -1 * (50 + cents) + '%';
        });
    }
}
function $74a45bff3c7a3ab4$var$clear() {
    document.querySelectorAll('.benditbetter-line--on').forEach(function(lineEl) {
        lineEl.classList.remove('benditbetter-line--on');
    });
}
function $74a45bff3c7a3ab4$var$camelToKebab(s) {
    return s.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $74a45bff3c7a3ab4$var$formatNote(s) {
    return s.replace('b', '<span class="benditbetter-flat">&flat;</span>').replace('#', '<span class="benditbetter-sharp">&sharp;</span>');
}


//# sourceMappingURL=benditbetter.js.map
